import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
import * as dcei_engine_unit_proto from './dcei_engine_unit_proto';
import * as dcei_engine_expression_proto from './dcei_engine_expression_proto';
export class BehaviorFlags {
  get descriptor() {
    return BehaviorFlags.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInvulnerable = false;
    this._invulnerable = null;
    this._hasStealth = false;
    this._stealth = null;
    this._hasDetector = false;
    this._detector = null;
    this._hasSuppressMovement = false;
    this._suppressMovement = null;
    this._hasSuppressWeapon = false;
    this._suppressWeapon = null;
    this._hasSuppressAbility = false;
    this._suppressAbility = null;
    this._hasSuppressTurning = false;
    this._suppressTurning = null;
    this._hasSuppressCollision = false;
    this._suppressCollision = null;
    this._hasSuppressTargetable = false;
    this._suppressTargetable = null;
    this._hasSuppressSelectable = false;
    this._suppressSelectable = null;
    this._hasIgnorePathing = false;
    this._ignorePathing = null;
  }
  isEmpty() {
    if (this._hasInvulnerable) return false;
    if (this._hasStealth) return false;
    if (this._hasDetector) return false;
    if (this._hasSuppressMovement) return false;
    if (this._hasSuppressWeapon) return false;
    if (this._hasSuppressAbility) return false;
    if (this._hasSuppressTurning) return false;
    if (this._hasSuppressCollision) return false;
    if (this._hasSuppressTargetable) return false;
    if (this._hasSuppressSelectable) return false;
    if (this._hasIgnorePathing) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorFlags) {
      return value;
    }
    return BehaviorFlags.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorFlags();
    if (json.invulnerable != null) {
      result._hasInvulnerable = true;
      result._invulnerable = JsonToBoolean.fromJson(json.invulnerable);
    }
    if (json.stealth != null) {
      result._hasStealth = true;
      result._stealth = JsonToBoolean.fromJson(json.stealth);
    }
    if (json.detector != null) {
      result._hasDetector = true;
      result._detector = JsonToBoolean.fromJson(json.detector);
    }
    if (json.suppressMovement != null) {
      result._hasSuppressMovement = true;
      result._suppressMovement = JsonToBoolean.fromJson(json.suppressMovement);
    }
    if (json.suppressWeapon != null) {
      result._hasSuppressWeapon = true;
      result._suppressWeapon = JsonToBoolean.fromJson(json.suppressWeapon);
    }
    if (json.suppressAbility != null) {
      result._hasSuppressAbility = true;
      result._suppressAbility = JsonToBoolean.fromJson(json.suppressAbility);
    }
    if (json.suppressTurning != null) {
      result._hasSuppressTurning = true;
      result._suppressTurning = JsonToBoolean.fromJson(json.suppressTurning);
    }
    if (json.suppressCollision != null) {
      result._hasSuppressCollision = true;
      result._suppressCollision = JsonToBoolean.fromJson(json.suppressCollision);
    }
    if (json.suppressTargetable != null) {
      result._hasSuppressTargetable = true;
      result._suppressTargetable = JsonToBoolean.fromJson(json.suppressTargetable);
    }
    if (json.suppressSelectable != null) {
      result._hasSuppressSelectable = true;
      result._suppressSelectable = JsonToBoolean.fromJson(json.suppressSelectable);
    }
    if (json.ignorePathing != null) {
      result._hasIgnorePathing = true;
      result._ignorePathing = JsonToBoolean.fromJson(json.ignorePathing);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInvulnerable) {
      result.invulnerable = JsonToBoolean.toJson(this._invulnerable);
    }
    if (this._hasStealth) {
      result.stealth = JsonToBoolean.toJson(this._stealth);
    }
    if (this._hasDetector) {
      result.detector = JsonToBoolean.toJson(this._detector);
    }
    if (this._hasSuppressMovement) {
      result.suppressMovement = JsonToBoolean.toJson(this._suppressMovement);
    }
    if (this._hasSuppressWeapon) {
      result.suppressWeapon = JsonToBoolean.toJson(this._suppressWeapon);
    }
    if (this._hasSuppressAbility) {
      result.suppressAbility = JsonToBoolean.toJson(this._suppressAbility);
    }
    if (this._hasSuppressTurning) {
      result.suppressTurning = JsonToBoolean.toJson(this._suppressTurning);
    }
    if (this._hasSuppressCollision) {
      result.suppressCollision = JsonToBoolean.toJson(this._suppressCollision);
    }
    if (this._hasSuppressTargetable) {
      result.suppressTargetable = JsonToBoolean.toJson(this._suppressTargetable);
    }
    if (this._hasSuppressSelectable) {
      result.suppressSelectable = JsonToBoolean.toJson(this._suppressSelectable);
    }
    if (this._hasIgnorePathing) {
      result.ignorePathing = JsonToBoolean.toJson(this._ignorePathing);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get invulnerable() {
    return this._hasInvulnerable ? this._invulnerable : JsonToBoolean.default;
  }
  get hasInvulnerable() {
    return this._hasInvulnerable;
  }
  setInvulnerable(path, value) {
    return {type: 'SET', path: path.concat(['invulnerable']), value};
  }
  deleteInvulnerable(path) {
    return {type: 'DELETE', path: path.concat(['invulnerable'])};
  }
  /**
   * @returns {boolean}
   */
  get stealth() {
    return this._hasStealth ? this._stealth : JsonToBoolean.default;
  }
  get hasStealth() {
    return this._hasStealth;
  }
  setStealth(path, value) {
    return {type: 'SET', path: path.concat(['stealth']), value};
  }
  deleteStealth(path) {
    return {type: 'DELETE', path: path.concat(['stealth'])};
  }
  /**
   * @returns {boolean}
   */
  get detector() {
    return this._hasDetector ? this._detector : JsonToBoolean.default;
  }
  get hasDetector() {
    return this._hasDetector;
  }
  setDetector(path, value) {
    return {type: 'SET', path: path.concat(['detector']), value};
  }
  deleteDetector(path) {
    return {type: 'DELETE', path: path.concat(['detector'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressMovement() {
    return this._hasSuppressMovement ? this._suppressMovement : JsonToBoolean.default;
  }
  get hasSuppressMovement() {
    return this._hasSuppressMovement;
  }
  setSuppressMovement(path, value) {
    return {type: 'SET', path: path.concat(['suppressMovement']), value};
  }
  deleteSuppressMovement(path) {
    return {type: 'DELETE', path: path.concat(['suppressMovement'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressWeapon() {
    return this._hasSuppressWeapon ? this._suppressWeapon : JsonToBoolean.default;
  }
  get hasSuppressWeapon() {
    return this._hasSuppressWeapon;
  }
  setSuppressWeapon(path, value) {
    return {type: 'SET', path: path.concat(['suppressWeapon']), value};
  }
  deleteSuppressWeapon(path) {
    return {type: 'DELETE', path: path.concat(['suppressWeapon'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressAbility() {
    return this._hasSuppressAbility ? this._suppressAbility : JsonToBoolean.default;
  }
  get hasSuppressAbility() {
    return this._hasSuppressAbility;
  }
  setSuppressAbility(path, value) {
    return {type: 'SET', path: path.concat(['suppressAbility']), value};
  }
  deleteSuppressAbility(path) {
    return {type: 'DELETE', path: path.concat(['suppressAbility'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressTurning() {
    return this._hasSuppressTurning ? this._suppressTurning : JsonToBoolean.default;
  }
  get hasSuppressTurning() {
    return this._hasSuppressTurning;
  }
  setSuppressTurning(path, value) {
    return {type: 'SET', path: path.concat(['suppressTurning']), value};
  }
  deleteSuppressTurning(path) {
    return {type: 'DELETE', path: path.concat(['suppressTurning'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressCollision() {
    return this._hasSuppressCollision ? this._suppressCollision : JsonToBoolean.default;
  }
  get hasSuppressCollision() {
    return this._hasSuppressCollision;
  }
  setSuppressCollision(path, value) {
    return {type: 'SET', path: path.concat(['suppressCollision']), value};
  }
  deleteSuppressCollision(path) {
    return {type: 'DELETE', path: path.concat(['suppressCollision'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressTargetable() {
    return this._hasSuppressTargetable ? this._suppressTargetable : JsonToBoolean.default;
  }
  get hasSuppressTargetable() {
    return this._hasSuppressTargetable;
  }
  setSuppressTargetable(path, value) {
    return {type: 'SET', path: path.concat(['suppressTargetable']), value};
  }
  deleteSuppressTargetable(path) {
    return {type: 'DELETE', path: path.concat(['suppressTargetable'])};
  }
  /**
   * @returns {boolean}
   */
  get suppressSelectable() {
    return this._hasSuppressSelectable ? this._suppressSelectable : JsonToBoolean.default;
  }
  get hasSuppressSelectable() {
    return this._hasSuppressSelectable;
  }
  setSuppressSelectable(path, value) {
    return {type: 'SET', path: path.concat(['suppressSelectable']), value};
  }
  deleteSuppressSelectable(path) {
    return {type: 'DELETE', path: path.concat(['suppressSelectable'])};
  }
  /**
   * @returns {boolean}
   */
  get ignorePathing() {
    return this._hasIgnorePathing ? this._ignorePathing : JsonToBoolean.default;
  }
  get hasIgnorePathing() {
    return this._hasIgnorePathing;
  }
  setIgnorePathing(path, value) {
    return {type: 'SET', path: path.concat(['ignorePathing']), value};
  }
  deleteIgnorePathing(path) {
    return {type: 'DELETE', path: path.concat(['ignorePathing'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "invulnerable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasInvulnerable = true;
              copy._invulnerable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInvulnerable) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasInvulnerable = false;
              copy._invulnerable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasStealth = true;
              copy._stealth = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStealth) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasStealth = false;
              copy._stealth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "detector": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasDetector = true;
              copy._detector = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDetector) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasDetector = false;
              copy._detector = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressMovement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressMovement = true;
              copy._suppressMovement = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressMovement) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressMovement = false;
              copy._suppressMovement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressWeapon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressWeapon = true;
              copy._suppressWeapon = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressWeapon) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressWeapon = false;
              copy._suppressWeapon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressAbility = true;
              copy._suppressAbility = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressAbility) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressAbility = false;
              copy._suppressAbility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressTurning": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressTurning = true;
              copy._suppressTurning = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressTurning) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressTurning = false;
              copy._suppressTurning = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressCollision": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressCollision = true;
              copy._suppressCollision = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressCollision) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressCollision = false;
              copy._suppressCollision = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressTargetable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressTargetable = true;
              copy._suppressTargetable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressTargetable) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressTargetable = false;
              copy._suppressTargetable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "suppressSelectable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasSuppressSelectable = true;
              copy._suppressSelectable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSuppressSelectable) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasSuppressSelectable = false;
              copy._suppressSelectable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignorePathing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorFlags(this);
              copy._hasIgnorePathing = true;
              copy._ignorePathing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnorePathing) {
                return this;
              }
              const copy = new BehaviorFlags(this);
              copy._hasIgnorePathing = false;
              copy._ignorePathing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorFlags} other
   * @returns {BehaviorFlags}
   */
  merge(other) {
    const copy = new BehaviorFlags(this);
    if (other._hasInvulnerable) {
      copy._hasInvulnerable = true;
      copy._invulnerable = other._invulnerable;
    }
    if (other._hasStealth) {
      copy._hasStealth = true;
      copy._stealth = other._stealth;
    }
    if (other._hasDetector) {
      copy._hasDetector = true;
      copy._detector = other._detector;
    }
    if (other._hasSuppressMovement) {
      copy._hasSuppressMovement = true;
      copy._suppressMovement = other._suppressMovement;
    }
    if (other._hasSuppressWeapon) {
      copy._hasSuppressWeapon = true;
      copy._suppressWeapon = other._suppressWeapon;
    }
    if (other._hasSuppressAbility) {
      copy._hasSuppressAbility = true;
      copy._suppressAbility = other._suppressAbility;
    }
    if (other._hasSuppressTurning) {
      copy._hasSuppressTurning = true;
      copy._suppressTurning = other._suppressTurning;
    }
    if (other._hasSuppressCollision) {
      copy._hasSuppressCollision = true;
      copy._suppressCollision = other._suppressCollision;
    }
    if (other._hasSuppressTargetable) {
      copy._hasSuppressTargetable = true;
      copy._suppressTargetable = other._suppressTargetable;
    }
    if (other._hasSuppressSelectable) {
      copy._hasSuppressSelectable = true;
      copy._suppressSelectable = other._suppressSelectable;
    }
    if (other._hasIgnorePathing) {
      copy._hasIgnorePathing = true;
      copy._ignorePathing = other._ignorePathing;
    }
    return copy;
  }
}
BehaviorFlags.default = new BehaviorFlags();
class BehaviorFlags_Builder {
  constructor(value) {
    this._value = new BehaviorFlags(value);
  }
  build() {
    return new BehaviorFlags(this._value);
  }
  setInvulnerable(value) {
    this._value._hasInvulnerable = true;
    this._value._invulnerable = value;
    return this;
  }
  deleteInvulnerable() {
    this._value._hasInvulnerable = false;
    this._value._invulnerable = null;
    return this;
  }
  setStealth(value) {
    this._value._hasStealth = true;
    this._value._stealth = value;
    return this;
  }
  deleteStealth() {
    this._value._hasStealth = false;
    this._value._stealth = null;
    return this;
  }
  setDetector(value) {
    this._value._hasDetector = true;
    this._value._detector = value;
    return this;
  }
  deleteDetector() {
    this._value._hasDetector = false;
    this._value._detector = null;
    return this;
  }
  setSuppressMovement(value) {
    this._value._hasSuppressMovement = true;
    this._value._suppressMovement = value;
    return this;
  }
  deleteSuppressMovement() {
    this._value._hasSuppressMovement = false;
    this._value._suppressMovement = null;
    return this;
  }
  setSuppressWeapon(value) {
    this._value._hasSuppressWeapon = true;
    this._value._suppressWeapon = value;
    return this;
  }
  deleteSuppressWeapon() {
    this._value._hasSuppressWeapon = false;
    this._value._suppressWeapon = null;
    return this;
  }
  setSuppressAbility(value) {
    this._value._hasSuppressAbility = true;
    this._value._suppressAbility = value;
    return this;
  }
  deleteSuppressAbility() {
    this._value._hasSuppressAbility = false;
    this._value._suppressAbility = null;
    return this;
  }
  setSuppressTurning(value) {
    this._value._hasSuppressTurning = true;
    this._value._suppressTurning = value;
    return this;
  }
  deleteSuppressTurning() {
    this._value._hasSuppressTurning = false;
    this._value._suppressTurning = null;
    return this;
  }
  setSuppressCollision(value) {
    this._value._hasSuppressCollision = true;
    this._value._suppressCollision = value;
    return this;
  }
  deleteSuppressCollision() {
    this._value._hasSuppressCollision = false;
    this._value._suppressCollision = null;
    return this;
  }
  setSuppressTargetable(value) {
    this._value._hasSuppressTargetable = true;
    this._value._suppressTargetable = value;
    return this;
  }
  deleteSuppressTargetable() {
    this._value._hasSuppressTargetable = false;
    this._value._suppressTargetable = null;
    return this;
  }
  setSuppressSelectable(value) {
    this._value._hasSuppressSelectable = true;
    this._value._suppressSelectable = value;
    return this;
  }
  deleteSuppressSelectable() {
    this._value._hasSuppressSelectable = false;
    this._value._suppressSelectable = null;
    return this;
  }
  setIgnorePathing(value) {
    this._value._hasIgnorePathing = true;
    this._value._ignorePathing = value;
    return this;
  }
  deleteIgnorePathing() {
    this._value._hasIgnorePathing = false;
    this._value._ignorePathing = null;
    return this;
  }
}
BehaviorFlags.Builder = BehaviorFlags_Builder;
class BehaviorFlags_WithParent {
  /**
   * @param {BehaviorFlags} value
   * @param {BehaviorFlags_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorFlags.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInvulnerable() {
    if (this._cachedHasInvulnerable === undefined) {
      if (this._value.hasInvulnerable) {
        this._cachedHasInvulnerable = true;
      } else {
        this._cachedHasInvulnerable = this._parent ? this._parent.hasInvulnerable : false;
      }
    }
    return this._cachedHasInvulnerable;
  }
  get invulnerable() {
    if (this._cachedInvulnerable === undefined) {
      if (this._value.hasInvulnerable) {
        this._cachedInvulnerable = this._value.invulnerable;
      } else {
        this._cachedInvulnerable = this._parent ? this._parent.invulnerable : this._value.invulnerable;
      }
    }
    return this._cachedInvulnerable;
  }
  get hasStealth() {
    if (this._cachedHasStealth === undefined) {
      if (this._value.hasStealth) {
        this._cachedHasStealth = true;
      } else {
        this._cachedHasStealth = this._parent ? this._parent.hasStealth : false;
      }
    }
    return this._cachedHasStealth;
  }
  get stealth() {
    if (this._cachedStealth === undefined) {
      if (this._value.hasStealth) {
        this._cachedStealth = this._value.stealth;
      } else {
        this._cachedStealth = this._parent ? this._parent.stealth : this._value.stealth;
      }
    }
    return this._cachedStealth;
  }
  get hasDetector() {
    if (this._cachedHasDetector === undefined) {
      if (this._value.hasDetector) {
        this._cachedHasDetector = true;
      } else {
        this._cachedHasDetector = this._parent ? this._parent.hasDetector : false;
      }
    }
    return this._cachedHasDetector;
  }
  get detector() {
    if (this._cachedDetector === undefined) {
      if (this._value.hasDetector) {
        this._cachedDetector = this._value.detector;
      } else {
        this._cachedDetector = this._parent ? this._parent.detector : this._value.detector;
      }
    }
    return this._cachedDetector;
  }
  get hasSuppressMovement() {
    if (this._cachedHasSuppressMovement === undefined) {
      if (this._value.hasSuppressMovement) {
        this._cachedHasSuppressMovement = true;
      } else {
        this._cachedHasSuppressMovement = this._parent ? this._parent.hasSuppressMovement : false;
      }
    }
    return this._cachedHasSuppressMovement;
  }
  get suppressMovement() {
    if (this._cachedSuppressMovement === undefined) {
      if (this._value.hasSuppressMovement) {
        this._cachedSuppressMovement = this._value.suppressMovement;
      } else {
        this._cachedSuppressMovement = this._parent ? this._parent.suppressMovement : this._value.suppressMovement;
      }
    }
    return this._cachedSuppressMovement;
  }
  get hasSuppressWeapon() {
    if (this._cachedHasSuppressWeapon === undefined) {
      if (this._value.hasSuppressWeapon) {
        this._cachedHasSuppressWeapon = true;
      } else {
        this._cachedHasSuppressWeapon = this._parent ? this._parent.hasSuppressWeapon : false;
      }
    }
    return this._cachedHasSuppressWeapon;
  }
  get suppressWeapon() {
    if (this._cachedSuppressWeapon === undefined) {
      if (this._value.hasSuppressWeapon) {
        this._cachedSuppressWeapon = this._value.suppressWeapon;
      } else {
        this._cachedSuppressWeapon = this._parent ? this._parent.suppressWeapon : this._value.suppressWeapon;
      }
    }
    return this._cachedSuppressWeapon;
  }
  get hasSuppressAbility() {
    if (this._cachedHasSuppressAbility === undefined) {
      if (this._value.hasSuppressAbility) {
        this._cachedHasSuppressAbility = true;
      } else {
        this._cachedHasSuppressAbility = this._parent ? this._parent.hasSuppressAbility : false;
      }
    }
    return this._cachedHasSuppressAbility;
  }
  get suppressAbility() {
    if (this._cachedSuppressAbility === undefined) {
      if (this._value.hasSuppressAbility) {
        this._cachedSuppressAbility = this._value.suppressAbility;
      } else {
        this._cachedSuppressAbility = this._parent ? this._parent.suppressAbility : this._value.suppressAbility;
      }
    }
    return this._cachedSuppressAbility;
  }
  get hasSuppressTurning() {
    if (this._cachedHasSuppressTurning === undefined) {
      if (this._value.hasSuppressTurning) {
        this._cachedHasSuppressTurning = true;
      } else {
        this._cachedHasSuppressTurning = this._parent ? this._parent.hasSuppressTurning : false;
      }
    }
    return this._cachedHasSuppressTurning;
  }
  get suppressTurning() {
    if (this._cachedSuppressTurning === undefined) {
      if (this._value.hasSuppressTurning) {
        this._cachedSuppressTurning = this._value.suppressTurning;
      } else {
        this._cachedSuppressTurning = this._parent ? this._parent.suppressTurning : this._value.suppressTurning;
      }
    }
    return this._cachedSuppressTurning;
  }
  get hasSuppressCollision() {
    if (this._cachedHasSuppressCollision === undefined) {
      if (this._value.hasSuppressCollision) {
        this._cachedHasSuppressCollision = true;
      } else {
        this._cachedHasSuppressCollision = this._parent ? this._parent.hasSuppressCollision : false;
      }
    }
    return this._cachedHasSuppressCollision;
  }
  get suppressCollision() {
    if (this._cachedSuppressCollision === undefined) {
      if (this._value.hasSuppressCollision) {
        this._cachedSuppressCollision = this._value.suppressCollision;
      } else {
        this._cachedSuppressCollision = this._parent ? this._parent.suppressCollision : this._value.suppressCollision;
      }
    }
    return this._cachedSuppressCollision;
  }
  get hasSuppressTargetable() {
    if (this._cachedHasSuppressTargetable === undefined) {
      if (this._value.hasSuppressTargetable) {
        this._cachedHasSuppressTargetable = true;
      } else {
        this._cachedHasSuppressTargetable = this._parent ? this._parent.hasSuppressTargetable : false;
      }
    }
    return this._cachedHasSuppressTargetable;
  }
  get suppressTargetable() {
    if (this._cachedSuppressTargetable === undefined) {
      if (this._value.hasSuppressTargetable) {
        this._cachedSuppressTargetable = this._value.suppressTargetable;
      } else {
        this._cachedSuppressTargetable = this._parent ? this._parent.suppressTargetable : this._value.suppressTargetable;
      }
    }
    return this._cachedSuppressTargetable;
  }
  get hasSuppressSelectable() {
    if (this._cachedHasSuppressSelectable === undefined) {
      if (this._value.hasSuppressSelectable) {
        this._cachedHasSuppressSelectable = true;
      } else {
        this._cachedHasSuppressSelectable = this._parent ? this._parent.hasSuppressSelectable : false;
      }
    }
    return this._cachedHasSuppressSelectable;
  }
  get suppressSelectable() {
    if (this._cachedSuppressSelectable === undefined) {
      if (this._value.hasSuppressSelectable) {
        this._cachedSuppressSelectable = this._value.suppressSelectable;
      } else {
        this._cachedSuppressSelectable = this._parent ? this._parent.suppressSelectable : this._value.suppressSelectable;
      }
    }
    return this._cachedSuppressSelectable;
  }
  get hasIgnorePathing() {
    if (this._cachedHasIgnorePathing === undefined) {
      if (this._value.hasIgnorePathing) {
        this._cachedHasIgnorePathing = true;
      } else {
        this._cachedHasIgnorePathing = this._parent ? this._parent.hasIgnorePathing : false;
      }
    }
    return this._cachedHasIgnorePathing;
  }
  get ignorePathing() {
    if (this._cachedIgnorePathing === undefined) {
      if (this._value.hasIgnorePathing) {
        this._cachedIgnorePathing = this._value.ignorePathing;
      } else {
        this._cachedIgnorePathing = this._parent ? this._parent.ignorePathing : this._value.ignorePathing;
      }
    }
    return this._cachedIgnorePathing;
  }
  update(current, parent) {
    const result = new BehaviorFlags_WithParent(current, parent);
    return result;
  }
}
BehaviorFlags_WithParent.default = new BehaviorFlags_WithParent(BehaviorFlags.default, null);
BehaviorFlags.WithParent = BehaviorFlags_WithParent;
class BehaviorFlags_Descriptor {
  get invulnerable() {
    if (!this._invulnerable) {
      this._invulnerable = {
        name: "invulnerable",
        Name: "Invulnerable",
        number: 1,
        protoType: 8,
        protoName: "invulnerable",
        type: JsonToBoolean,
        options: {
          comments: "Prevents damage taken.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._invulnerable;
  }
  get stealth() {
    if (!this._stealth) {
      this._stealth = {
        name: "stealth",
        Name: "Stealth",
        number: 2,
        protoType: 8,
        protoName: "stealth",
        type: JsonToBoolean,
        options: {
          comments: "Can be filtered by search filters. By itself stealth does not do anything.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stealth;
  }
  get detector() {
    if (!this._detector) {
      this._detector = {
        name: "detector",
        Name: "Detector",
        number: 3,
        protoType: 8,
        protoName: "detector",
        type: JsonToBoolean,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._detector;
  }
  get suppressMovement() {
    if (!this._suppressMovement) {
      this._suppressMovement = {
        name: "suppressMovement",
        Name: "SuppressMovement",
        number: 4,
        protoType: 8,
        protoName: "suppress_movement",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit from moving.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressMovement;
  }
  get suppressWeapon() {
    if (!this._suppressWeapon) {
      this._suppressWeapon = {
        name: "suppressWeapon",
        Name: "SuppressWeapon",
        number: 5,
        protoType: 8,
        protoName: "suppress_weapon",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit using weapons.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressWeapon;
  }
  get suppressAbility() {
    if (!this._suppressAbility) {
      this._suppressAbility = {
        name: "suppressAbility",
        Name: "SuppressAbility",
        number: 6,
        protoType: 8,
        protoName: "suppress_ability",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit from casting abilities.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressAbility;
  }
  get suppressTurning() {
    if (!this._suppressTurning) {
      this._suppressTurning = {
        name: "suppressTurning",
        Name: "SuppressTurning",
        number: 7,
        protoType: 8,
        protoName: "suppress_turning",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit from turning.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressTurning;
  }
  get suppressCollision() {
    if (!this._suppressCollision) {
      this._suppressCollision = {
        name: "suppressCollision",
        Name: "SuppressCollision",
        number: 8,
        protoType: 8,
        protoName: "suppress_collision",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit from interacting with or being affected by other unit\'s collision.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressCollision;
  }
  get suppressTargetable() {
    if (!this._suppressTargetable) {
      this._suppressTargetable = {
        name: "suppressTargetable",
        Name: "SuppressTargetable",
        number: 9,
        protoType: 8,
        protoName: "suppress_targetable",
        type: JsonToBoolean,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressTargetable;
  }
  get suppressSelectable() {
    if (!this._suppressSelectable) {
      this._suppressSelectable = {
        name: "suppressSelectable",
        Name: "SuppressSelectable",
        number: 10,
        protoType: 8,
        protoName: "suppress_selectable",
        type: JsonToBoolean,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._suppressSelectable;
  }
  get ignorePathing() {
    if (!this._ignorePathing) {
      this._ignorePathing = {
        name: "ignorePathing",
        Name: "IgnorePathing",
        number: 11,
        protoType: 8,
        protoName: "ignore_pathing",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the unit from being restricted to moving on the navmesh.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignorePathing;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.invulnerable,
        this.stealth,
        this.detector,
        this.suppressMovement,
        this.suppressWeapon,
        this.suppressAbility,
        this.suppressTurning,
        this.suppressCollision,
        this.suppressTargetable,
        this.suppressSelectable,
        this.ignorePathing,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInvulnerable",
        Name: "DummyOneofForInvulnerable",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStealth",
        Name: "DummyOneofForStealth",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDetector",
        Name: "DummyOneofForDetector",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressMovement",
        Name: "DummyOneofForSuppressMovement",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressWeapon",
        Name: "DummyOneofForSuppressWeapon",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressAbility",
        Name: "DummyOneofForSuppressAbility",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressTurning",
        Name: "DummyOneofForSuppressTurning",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressCollision",
        Name: "DummyOneofForSuppressCollision",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressTargetable",
        Name: "DummyOneofForSuppressTargetable",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSuppressSelectable",
        Name: "DummyOneofForSuppressSelectable",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnorePathing",
        Name: "DummyOneofForIgnorePathing",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorFlags.descriptor = new BehaviorFlags_Descriptor();
export class BehaviorModifier {
  get descriptor() {
    return BehaviorModifier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasScaled = false;
    this._scaled = null;
    this._hasUnscaled = false;
    this._unscaled = null;
    this._hasAdditiveFactor = false;
    this._additiveFactor = null;
    this._hasUnifiedFactor = false;
    this._unifiedFactor = null;
    this._hasMultiplierFactor = false;
    this._multiplierFactor = null;
  }
  isEmpty() {
    if (this._hasScaled) return false;
    if (this._hasUnscaled) return false;
    if (this._hasAdditiveFactor) return false;
    if (this._hasUnifiedFactor) return false;
    if (this._hasMultiplierFactor) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorModifier) {
      return value;
    }
    return BehaviorModifier.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorModifier();
    if (json.scaled != null) {
      result._hasScaled = true;
      result._scaled = JsonToDouble.fromJson(json.scaled);
    }
    if (json.unscaled != null) {
      result._hasUnscaled = true;
      result._unscaled = JsonToDouble.fromJson(json.unscaled);
    }
    if (json.additiveFactor != null) {
      result._hasAdditiveFactor = true;
      result._additiveFactor = JsonToDouble.fromJson(json.additiveFactor);
    }
    if (json.unifiedFactor != null) {
      result._hasUnifiedFactor = true;
      result._unifiedFactor = JsonToDouble.fromJson(json.unifiedFactor);
    }
    if (json.multiplierFactor != null) {
      result._hasMultiplierFactor = true;
      result._multiplierFactor = JsonToDouble.fromJson(json.multiplierFactor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasScaled) {
      result.scaled = JsonToDouble.toJson(this._scaled);
    }
    if (this._hasUnscaled) {
      result.unscaled = JsonToDouble.toJson(this._unscaled);
    }
    if (this._hasAdditiveFactor) {
      result.additiveFactor = JsonToDouble.toJson(this._additiveFactor);
    }
    if (this._hasUnifiedFactor) {
      result.unifiedFactor = JsonToDouble.toJson(this._unifiedFactor);
    }
    if (this._hasMultiplierFactor) {
      result.multiplierFactor = JsonToDouble.toJson(this._multiplierFactor);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get scaled() {
    return this._hasScaled ? this._scaled : JsonToDouble.default;
  }
  get hasScaled() {
    return this._hasScaled;
  }
  setScaled(path, value) {
    return {type: 'SET', path: path.concat(['scaled']), value};
  }
  deleteScaled(path) {
    return {type: 'DELETE', path: path.concat(['scaled'])};
  }
  /**
   * @returns {number}
   */
  get unscaled() {
    return this._hasUnscaled ? this._unscaled : JsonToDouble.default;
  }
  get hasUnscaled() {
    return this._hasUnscaled;
  }
  setUnscaled(path, value) {
    return {type: 'SET', path: path.concat(['unscaled']), value};
  }
  deleteUnscaled(path) {
    return {type: 'DELETE', path: path.concat(['unscaled'])};
  }
  /**
   * @returns {number}
   */
  get additiveFactor() {
    return this._hasAdditiveFactor ? this._additiveFactor : JsonToDouble.default;
  }
  get hasAdditiveFactor() {
    return this._hasAdditiveFactor;
  }
  setAdditiveFactor(path, value) {
    return {type: 'SET', path: path.concat(['additiveFactor']), value};
  }
  deleteAdditiveFactor(path) {
    return {type: 'DELETE', path: path.concat(['additiveFactor'])};
  }
  /**
   * @returns {number}
   */
  get unifiedFactor() {
    return this._hasUnifiedFactor ? this._unifiedFactor : JsonToDouble.default;
  }
  get hasUnifiedFactor() {
    return this._hasUnifiedFactor;
  }
  setUnifiedFactor(path, value) {
    return {type: 'SET', path: path.concat(['unifiedFactor']), value};
  }
  deleteUnifiedFactor(path) {
    return {type: 'DELETE', path: path.concat(['unifiedFactor'])};
  }
  /**
   * @returns {number}
   */
  get multiplierFactor() {
    return this._hasMultiplierFactor ? this._multiplierFactor : JsonToDouble.default;
  }
  get hasMultiplierFactor() {
    return this._hasMultiplierFactor;
  }
  setMultiplierFactor(path, value) {
    return {type: 'SET', path: path.concat(['multiplierFactor']), value};
  }
  deleteMultiplierFactor(path) {
    return {type: 'DELETE', path: path.concat(['multiplierFactor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "scaled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifier(this);
              copy._hasScaled = true;
              copy._scaled = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScaled) {
                return this;
              }
              const copy = new BehaviorModifier(this);
              copy._hasScaled = false;
              copy._scaled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unscaled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifier(this);
              copy._hasUnscaled = true;
              copy._unscaled = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnscaled) {
                return this;
              }
              const copy = new BehaviorModifier(this);
              copy._hasUnscaled = false;
              copy._unscaled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "additiveFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifier(this);
              copy._hasAdditiveFactor = true;
              copy._additiveFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAdditiveFactor) {
                return this;
              }
              const copy = new BehaviorModifier(this);
              copy._hasAdditiveFactor = false;
              copy._additiveFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unifiedFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifier(this);
              copy._hasUnifiedFactor = true;
              copy._unifiedFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnifiedFactor) {
                return this;
              }
              const copy = new BehaviorModifier(this);
              copy._hasUnifiedFactor = false;
              copy._unifiedFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "multiplierFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifier(this);
              copy._hasMultiplierFactor = true;
              copy._multiplierFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMultiplierFactor) {
                return this;
              }
              const copy = new BehaviorModifier(this);
              copy._hasMultiplierFactor = false;
              copy._multiplierFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorModifier} other
   * @returns {BehaviorModifier}
   */
  merge(other) {
    const copy = new BehaviorModifier(this);
    if (other._hasScaled) {
      copy._hasScaled = true;
      copy._scaled = other._scaled;
    }
    if (other._hasUnscaled) {
      copy._hasUnscaled = true;
      copy._unscaled = other._unscaled;
    }
    if (other._hasAdditiveFactor) {
      copy._hasAdditiveFactor = true;
      copy._additiveFactor = other._additiveFactor;
    }
    if (other._hasUnifiedFactor) {
      copy._hasUnifiedFactor = true;
      copy._unifiedFactor = other._unifiedFactor;
    }
    if (other._hasMultiplierFactor) {
      copy._hasMultiplierFactor = true;
      copy._multiplierFactor = other._multiplierFactor;
    }
    return copy;
  }
}
BehaviorModifier.default = new BehaviorModifier();
class BehaviorModifier_Builder {
  constructor(value) {
    this._value = new BehaviorModifier(value);
  }
  build() {
    return new BehaviorModifier(this._value);
  }
  setScaled(value) {
    this._value._hasScaled = true;
    this._value._scaled = value;
    return this;
  }
  deleteScaled() {
    this._value._hasScaled = false;
    this._value._scaled = null;
    return this;
  }
  setUnscaled(value) {
    this._value._hasUnscaled = true;
    this._value._unscaled = value;
    return this;
  }
  deleteUnscaled() {
    this._value._hasUnscaled = false;
    this._value._unscaled = null;
    return this;
  }
  setAdditiveFactor(value) {
    this._value._hasAdditiveFactor = true;
    this._value._additiveFactor = value;
    return this;
  }
  deleteAdditiveFactor() {
    this._value._hasAdditiveFactor = false;
    this._value._additiveFactor = null;
    return this;
  }
  setUnifiedFactor(value) {
    this._value._hasUnifiedFactor = true;
    this._value._unifiedFactor = value;
    return this;
  }
  deleteUnifiedFactor() {
    this._value._hasUnifiedFactor = false;
    this._value._unifiedFactor = null;
    return this;
  }
  setMultiplierFactor(value) {
    this._value._hasMultiplierFactor = true;
    this._value._multiplierFactor = value;
    return this;
  }
  deleteMultiplierFactor() {
    this._value._hasMultiplierFactor = false;
    this._value._multiplierFactor = null;
    return this;
  }
}
BehaviorModifier.Builder = BehaviorModifier_Builder;
class BehaviorModifier_WithParent {
  /**
   * @param {BehaviorModifier} value
   * @param {BehaviorModifier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorModifier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasScaled() {
    if (this._cachedHasScaled === undefined) {
      if (this._value.hasScaled) {
        this._cachedHasScaled = true;
      } else {
        this._cachedHasScaled = this._parent ? this._parent.hasScaled : false;
      }
    }
    return this._cachedHasScaled;
  }
  get scaled() {
    if (this._cachedScaled === undefined) {
      if (this._value.hasScaled) {
        this._cachedScaled = this._value.scaled;
      } else {
        this._cachedScaled = this._parent ? this._parent.scaled : this._value.scaled;
      }
    }
    return this._cachedScaled;
  }
  get hasUnscaled() {
    if (this._cachedHasUnscaled === undefined) {
      if (this._value.hasUnscaled) {
        this._cachedHasUnscaled = true;
      } else {
        this._cachedHasUnscaled = this._parent ? this._parent.hasUnscaled : false;
      }
    }
    return this._cachedHasUnscaled;
  }
  get unscaled() {
    if (this._cachedUnscaled === undefined) {
      if (this._value.hasUnscaled) {
        this._cachedUnscaled = this._value.unscaled;
      } else {
        this._cachedUnscaled = this._parent ? this._parent.unscaled : this._value.unscaled;
      }
    }
    return this._cachedUnscaled;
  }
  get hasAdditiveFactor() {
    if (this._cachedHasAdditiveFactor === undefined) {
      if (this._value.hasAdditiveFactor) {
        this._cachedHasAdditiveFactor = true;
      } else {
        this._cachedHasAdditiveFactor = this._parent ? this._parent.hasAdditiveFactor : false;
      }
    }
    return this._cachedHasAdditiveFactor;
  }
  get additiveFactor() {
    if (this._cachedAdditiveFactor === undefined) {
      if (this._value.hasAdditiveFactor) {
        this._cachedAdditiveFactor = this._value.additiveFactor;
      } else {
        this._cachedAdditiveFactor = this._parent ? this._parent.additiveFactor : this._value.additiveFactor;
      }
    }
    return this._cachedAdditiveFactor;
  }
  get hasUnifiedFactor() {
    if (this._cachedHasUnifiedFactor === undefined) {
      if (this._value.hasUnifiedFactor) {
        this._cachedHasUnifiedFactor = true;
      } else {
        this._cachedHasUnifiedFactor = this._parent ? this._parent.hasUnifiedFactor : false;
      }
    }
    return this._cachedHasUnifiedFactor;
  }
  get unifiedFactor() {
    if (this._cachedUnifiedFactor === undefined) {
      if (this._value.hasUnifiedFactor) {
        this._cachedUnifiedFactor = this._value.unifiedFactor;
      } else {
        this._cachedUnifiedFactor = this._parent ? this._parent.unifiedFactor : this._value.unifiedFactor;
      }
    }
    return this._cachedUnifiedFactor;
  }
  get hasMultiplierFactor() {
    if (this._cachedHasMultiplierFactor === undefined) {
      if (this._value.hasMultiplierFactor) {
        this._cachedHasMultiplierFactor = true;
      } else {
        this._cachedHasMultiplierFactor = this._parent ? this._parent.hasMultiplierFactor : false;
      }
    }
    return this._cachedHasMultiplierFactor;
  }
  get multiplierFactor() {
    if (this._cachedMultiplierFactor === undefined) {
      if (this._value.hasMultiplierFactor) {
        this._cachedMultiplierFactor = this._value.multiplierFactor;
      } else {
        this._cachedMultiplierFactor = this._parent ? this._parent.multiplierFactor : this._value.multiplierFactor;
      }
    }
    return this._cachedMultiplierFactor;
  }
  update(current, parent) {
    const result = new BehaviorModifier_WithParent(current, parent);
    return result;
  }
}
BehaviorModifier_WithParent.default = new BehaviorModifier_WithParent(BehaviorModifier.default, null);
BehaviorModifier.WithParent = BehaviorModifier_WithParent;
class BehaviorModifier_Descriptor {
  get scaled() {
    if (!this._scaled) {
      this._scaled = {
        name: "scaled",
        Name: "Scaled",
        number: 1,
        protoType: 1,
        protoName: "scaled",
        type: JsonToDouble,
        options: {
          comments: "The value is added to the base value, and can be multiplied by additive, unified, or multiplier factors.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scaled;
  }
  get unscaled() {
    if (!this._unscaled) {
      this._unscaled = {
        name: "unscaled",
        Name: "Unscaled",
        number: 2,
        protoType: 1,
        protoName: "unscaled",
        type: JsonToDouble,
        options: {
          comments: "The value is added to the base value but are never multiplied by additive, unified, or multiplier factors.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unscaled;
  }
  get additiveFactor() {
    if (!this._additiveFactor) {
      this._additiveFactor = {
        name: "additiveFactor",
        Name: "AdditiveFactor",
        number: 3,
        protoType: 1,
        protoName: "additive_factor",
        type: JsonToDouble,
        options: {
          comments: "Increases the base value as a multiplier.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additiveFactor;
  }
  get unifiedFactor() {
    if (!this._unifiedFactor) {
      this._unifiedFactor = {
        name: "unifiedFactor",
        Name: "UnifiedFactor",
        number: 4,
        protoType: 1,
        protoName: "unified_factor",
        type: JsonToDouble,
        options: {
          comments: "Increases the base value as a multiplier.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unifiedFactor;
  }
  get multiplierFactor() {
    if (!this._multiplierFactor) {
      this._multiplierFactor = {
        name: "multiplierFactor",
        Name: "MultiplierFactor",
        number: 5,
        protoType: 1,
        protoName: "multiplier_factor",
        type: JsonToDouble,
        options: {
          comments: "Increases the base value as a multiplier.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiplierFactor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.scaled,
        this.unscaled,
        this.additiveFactor,
        this.unifiedFactor,
        this.multiplierFactor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForScaled",
        Name: "DummyOneofForScaled",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnscaled",
        Name: "DummyOneofForUnscaled",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAdditiveFactor",
        Name: "DummyOneofForAdditiveFactor",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnifiedFactor",
        Name: "DummyOneofForUnifiedFactor",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMultiplierFactor",
        Name: "DummyOneofForMultiplierFactor",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorModifier.descriptor = new BehaviorModifier_Descriptor();
export class BehaviorModifiers {
  get descriptor() {
    return BehaviorModifiers.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFlags = false;
    this._flags = null;
    this._hasMaxHealthModifier = false;
    this._maxHealthModifier = null;
    this._hasMaxManaModifier = false;
    this._maxManaModifier = null;
    this._hasMaxShieldModifier = false;
    this._maxShieldModifier = null;
    this._hasHealthRegenerationModifier = false;
    this._healthRegenerationModifier = null;
    this._hasManaRegenerationModifier = false;
    this._manaRegenerationModifier = null;
    this._hasShieldRegenerationModifier = false;
    this._shieldRegenerationModifier = null;
    this._hasUnitTargetPriority = false;
    this._unitTargetPriority = null;
    this._hasUnitRadiusModifier = false;
    this._unitRadiusModifier = null;
    this._hasMoveSpeedModifier = false;
    this._moveSpeedModifier = null;
    this._hasAttackSpeedModifier = false;
    this._attackSpeedModifier = null;
    this._hasWeaponDamageModifier = false;
    this._weaponDamageModifier = null;
    this._hasAbilityDamageModifier = false;
    this._abilityDamageModifier = null;
    this._hasWeaponDamageTakenModifier = false;
    this._weaponDamageTakenModifier = null;
    this._hasAbilityDamageTakenModifier = false;
    this._abilityDamageTakenModifier = null;
    this._hasCriticalChanceModifier = false;
    this._criticalChanceModifier = null;
    this._hasAbilityCriticalChanceModifier = false;
    this._abilityCriticalChanceModifier = null;
    this._hasAbilityGoldCostModifier = false;
    this._abilityGoldCostModifier = null;
    this._hasAbilityManaCostModifier = false;
    this._abilityManaCostModifier = null;
    this._hasAbilityHealthCostModifier = false;
    this._abilityHealthCostModifier = null;
    this._hasHealModifier = false;
    this._healModifier = null;
    this._hasWeaponRangeModifier = false;
    this._weaponRangeModifier = null;
    this._hasWeaponScanRangeModifier = false;
    this._weaponScanRangeModifier = null;
    this._hasAbilityCooldownModifier = false;
    this._abilityCooldownModifier = null;
    this._hasChargeTimeModifier = false;
    this._chargeTimeModifier = null;
    this._hasAbilitySpeedModifier = false;
    this._abilitySpeedModifier = null;
    this._hasAbilityCooldownPeriodModifier = false;
    this._abilityCooldownPeriodModifier = null;
    this._disabledWeapons = [];
    this._enabledWeapons = [];
    this._disabledWeaponFamilies = [];
    this._enabledWeaponFamilies = [];
    this._weaponModifierGroup = [];
    this._abilityModifierGroup = [];
    this._disabledAbilities = [];
    this._enabledAbilities = [];
    this._hideAbilities = [];
    this._showAbilities = [];
    this._addHighlightToAbilities = [];
    this._removeHighlightFromAbilities = [];
  }
  isEmpty() {
    if (this._hasFlags && !this._flags.isEmpty()) return false;
    if (this._hasMaxHealthModifier && !this._maxHealthModifier.isEmpty()) return false;
    if (this._hasMaxManaModifier && !this._maxManaModifier.isEmpty()) return false;
    if (this._hasMaxShieldModifier && !this._maxShieldModifier.isEmpty()) return false;
    if (this._hasHealthRegenerationModifier && !this._healthRegenerationModifier.isEmpty()) return false;
    if (this._hasManaRegenerationModifier && !this._manaRegenerationModifier.isEmpty()) return false;
    if (this._hasShieldRegenerationModifier && !this._shieldRegenerationModifier.isEmpty()) return false;
    if (this._hasUnitTargetPriority && !this._unitTargetPriority.isEmpty()) return false;
    if (this._hasUnitRadiusModifier && !this._unitRadiusModifier.isEmpty()) return false;
    if (this._hasMoveSpeedModifier && !this._moveSpeedModifier.isEmpty()) return false;
    if (this._hasAttackSpeedModifier && !this._attackSpeedModifier.isEmpty()) return false;
    if (this._hasWeaponDamageModifier && !this._weaponDamageModifier.isEmpty()) return false;
    if (this._hasAbilityDamageModifier && !this._abilityDamageModifier.isEmpty()) return false;
    if (this._hasWeaponDamageTakenModifier && !this._weaponDamageTakenModifier.isEmpty()) return false;
    if (this._hasAbilityDamageTakenModifier && !this._abilityDamageTakenModifier.isEmpty()) return false;
    if (this._hasCriticalChanceModifier && !this._criticalChanceModifier.isEmpty()) return false;
    if (this._hasAbilityCriticalChanceModifier && !this._abilityCriticalChanceModifier.isEmpty()) return false;
    if (this._hasAbilityGoldCostModifier && !this._abilityGoldCostModifier.isEmpty()) return false;
    if (this._hasAbilityManaCostModifier && !this._abilityManaCostModifier.isEmpty()) return false;
    if (this._hasAbilityHealthCostModifier && !this._abilityHealthCostModifier.isEmpty()) return false;
    if (this._hasHealModifier && !this._healModifier.isEmpty()) return false;
    if (this._hasWeaponRangeModifier && !this._weaponRangeModifier.isEmpty()) return false;
    if (this._hasWeaponScanRangeModifier && !this._weaponScanRangeModifier.isEmpty()) return false;
    if (this._hasAbilityCooldownModifier && !this._abilityCooldownModifier.isEmpty()) return false;
    if (this._hasChargeTimeModifier && !this._chargeTimeModifier.isEmpty()) return false;
    if (this._hasAbilitySpeedModifier && !this._abilitySpeedModifier.isEmpty()) return false;
    if (this._hasAbilityCooldownPeriodModifier && !this._abilityCooldownPeriodModifier.isEmpty()) return false;
    if (this._disabledWeapons.length > 0) return false;
    if (this._enabledWeapons.length > 0) return false;
    if (this._disabledWeaponFamilies.length > 0) return false;
    if (this._enabledWeaponFamilies.length > 0) return false;
    if (this._weaponModifierGroup.length > 0) return false;
    if (this._abilityModifierGroup.length > 0) return false;
    if (this._disabledAbilities.length > 0) return false;
    if (this._enabledAbilities.length > 0) return false;
    if (this._hideAbilities.length > 0) return false;
    if (this._showAbilities.length > 0) return false;
    if (this._addHighlightToAbilities.length > 0) return false;
    if (this._removeHighlightFromAbilities.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorModifiers) {
      return value;
    }
    return BehaviorModifiers.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorModifiers();
    if (json.flags != null) {
      result._hasFlags = true;
      result._flags = BehaviorFlags.fromJson(json.flags);
    }
    if (json.maxHealthModifier != null) {
      result._hasMaxHealthModifier = true;
      result._maxHealthModifier = BehaviorModifier.fromJson(json.maxHealthModifier);
    }
    if (json.maxManaModifier != null) {
      result._hasMaxManaModifier = true;
      result._maxManaModifier = BehaviorModifier.fromJson(json.maxManaModifier);
    }
    if (json.maxShieldModifier != null) {
      result._hasMaxShieldModifier = true;
      result._maxShieldModifier = BehaviorModifier.fromJson(json.maxShieldModifier);
    }
    if (json.healthRegenerationModifier != null) {
      result._hasHealthRegenerationModifier = true;
      result._healthRegenerationModifier = BehaviorModifier.fromJson(json.healthRegenerationModifier);
    }
    if (json.manaRegenerationModifier != null) {
      result._hasManaRegenerationModifier = true;
      result._manaRegenerationModifier = BehaviorModifier.fromJson(json.manaRegenerationModifier);
    }
    if (json.shieldRegenerationModifier != null) {
      result._hasShieldRegenerationModifier = true;
      result._shieldRegenerationModifier = BehaviorModifier.fromJson(json.shieldRegenerationModifier);
    }
    if (json.unitTargetPriority != null) {
      result._hasUnitTargetPriority = true;
      result._unitTargetPriority = BehaviorModifier.fromJson(json.unitTargetPriority);
    }
    if (json.unitRadiusModifier != null) {
      result._hasUnitRadiusModifier = true;
      result._unitRadiusModifier = BehaviorModifier.fromJson(json.unitRadiusModifier);
    }
    if (json.moveSpeedModifier != null) {
      result._hasMoveSpeedModifier = true;
      result._moveSpeedModifier = BehaviorModifier.fromJson(json.moveSpeedModifier);
    }
    if (json.attackSpeedModifier != null) {
      result._hasAttackSpeedModifier = true;
      result._attackSpeedModifier = BehaviorModifier.fromJson(json.attackSpeedModifier);
    }
    if (json.weaponDamageModifier != null) {
      result._hasWeaponDamageModifier = true;
      result._weaponDamageModifier = BehaviorModifier.fromJson(json.weaponDamageModifier);
    }
    if (json.abilityDamageModifier != null) {
      result._hasAbilityDamageModifier = true;
      result._abilityDamageModifier = BehaviorModifier.fromJson(json.abilityDamageModifier);
    }
    if (json.weaponDamageTakenModifier != null) {
      result._hasWeaponDamageTakenModifier = true;
      result._weaponDamageTakenModifier = BehaviorModifier.fromJson(json.weaponDamageTakenModifier);
    }
    if (json.abilityDamageTakenModifier != null) {
      result._hasAbilityDamageTakenModifier = true;
      result._abilityDamageTakenModifier = BehaviorModifier.fromJson(json.abilityDamageTakenModifier);
    }
    if (json.criticalChanceModifier != null) {
      result._hasCriticalChanceModifier = true;
      result._criticalChanceModifier = BehaviorModifier.fromJson(json.criticalChanceModifier);
    }
    if (json.abilityCriticalChanceModifier != null) {
      result._hasAbilityCriticalChanceModifier = true;
      result._abilityCriticalChanceModifier = BehaviorModifier.fromJson(json.abilityCriticalChanceModifier);
    }
    if (json.abilityGoldCostModifier != null) {
      result._hasAbilityGoldCostModifier = true;
      result._abilityGoldCostModifier = BehaviorModifier.fromJson(json.abilityGoldCostModifier);
    }
    if (json.abilityManaCostModifier != null) {
      result._hasAbilityManaCostModifier = true;
      result._abilityManaCostModifier = BehaviorModifier.fromJson(json.abilityManaCostModifier);
    }
    if (json.abilityHealthCostModifier != null) {
      result._hasAbilityHealthCostModifier = true;
      result._abilityHealthCostModifier = BehaviorModifier.fromJson(json.abilityHealthCostModifier);
    }
    if (json.healModifier != null) {
      result._hasHealModifier = true;
      result._healModifier = BehaviorModifier.fromJson(json.healModifier);
    }
    if (json.weaponRangeModifier != null) {
      result._hasWeaponRangeModifier = true;
      result._weaponRangeModifier = BehaviorModifier.fromJson(json.weaponRangeModifier);
    }
    if (json.weaponScanRangeModifier != null) {
      result._hasWeaponScanRangeModifier = true;
      result._weaponScanRangeModifier = BehaviorModifier.fromJson(json.weaponScanRangeModifier);
    }
    if (json.abilityCooldownModifier != null) {
      result._hasAbilityCooldownModifier = true;
      result._abilityCooldownModifier = BehaviorModifier.fromJson(json.abilityCooldownModifier);
    }
    if (json.chargeTimeModifier != null) {
      result._hasChargeTimeModifier = true;
      result._chargeTimeModifier = BehaviorModifier.fromJson(json.chargeTimeModifier);
    }
    if (json.abilitySpeedModifier != null) {
      result._hasAbilitySpeedModifier = true;
      result._abilitySpeedModifier = BehaviorModifier.fromJson(json.abilitySpeedModifier);
    }
    if (json.abilityCooldownPeriodModifier != null) {
      result._hasAbilityCooldownPeriodModifier = true;
      result._abilityCooldownPeriodModifier = BehaviorModifier.fromJson(json.abilityCooldownPeriodModifier);
    }
    result._disabledWeapons = JsonToList(json.disabledWeapons, JsonToString);
    result._enabledWeapons = JsonToList(json.enabledWeapons, JsonToString);
    result._disabledWeaponFamilies = JsonToList(json.disabledWeaponFamilies, JsonToString);
    result._enabledWeaponFamilies = JsonToList(json.enabledWeaponFamilies, JsonToString);
    result._weaponModifierGroup = JsonToList(json.weaponModifierGroup, JsonToString);
    result._abilityModifierGroup = JsonToList(json.abilityModifierGroup, JsonToString);
    result._disabledAbilities = JsonToList(json.disabledAbilities, JsonToString);
    result._enabledAbilities = JsonToList(json.enabledAbilities, JsonToString);
    result._hideAbilities = JsonToList(json.hideAbilities, JsonToString);
    result._showAbilities = JsonToList(json.showAbilities, JsonToString);
    result._addHighlightToAbilities = JsonToList(json.addHighlightToAbilities, JsonToString);
    result._removeHighlightFromAbilities = JsonToList(json.removeHighlightFromAbilities, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFlags && !this._flags.isEmpty()) {
      result.flags = BehaviorFlags.toJson(this._flags);
    }
    if (this._hasMaxHealthModifier && !this._maxHealthModifier.isEmpty()) {
      result.maxHealthModifier = BehaviorModifier.toJson(this._maxHealthModifier);
    }
    if (this._hasMaxManaModifier && !this._maxManaModifier.isEmpty()) {
      result.maxManaModifier = BehaviorModifier.toJson(this._maxManaModifier);
    }
    if (this._hasMaxShieldModifier && !this._maxShieldModifier.isEmpty()) {
      result.maxShieldModifier = BehaviorModifier.toJson(this._maxShieldModifier);
    }
    if (this._hasHealthRegenerationModifier && !this._healthRegenerationModifier.isEmpty()) {
      result.healthRegenerationModifier = BehaviorModifier.toJson(this._healthRegenerationModifier);
    }
    if (this._hasManaRegenerationModifier && !this._manaRegenerationModifier.isEmpty()) {
      result.manaRegenerationModifier = BehaviorModifier.toJson(this._manaRegenerationModifier);
    }
    if (this._hasShieldRegenerationModifier && !this._shieldRegenerationModifier.isEmpty()) {
      result.shieldRegenerationModifier = BehaviorModifier.toJson(this._shieldRegenerationModifier);
    }
    if (this._hasUnitTargetPriority && !this._unitTargetPriority.isEmpty()) {
      result.unitTargetPriority = BehaviorModifier.toJson(this._unitTargetPriority);
    }
    if (this._hasUnitRadiusModifier && !this._unitRadiusModifier.isEmpty()) {
      result.unitRadiusModifier = BehaviorModifier.toJson(this._unitRadiusModifier);
    }
    if (this._hasMoveSpeedModifier && !this._moveSpeedModifier.isEmpty()) {
      result.moveSpeedModifier = BehaviorModifier.toJson(this._moveSpeedModifier);
    }
    if (this._hasAttackSpeedModifier && !this._attackSpeedModifier.isEmpty()) {
      result.attackSpeedModifier = BehaviorModifier.toJson(this._attackSpeedModifier);
    }
    if (this._hasWeaponDamageModifier && !this._weaponDamageModifier.isEmpty()) {
      result.weaponDamageModifier = BehaviorModifier.toJson(this._weaponDamageModifier);
    }
    if (this._hasAbilityDamageModifier && !this._abilityDamageModifier.isEmpty()) {
      result.abilityDamageModifier = BehaviorModifier.toJson(this._abilityDamageModifier);
    }
    if (this._hasWeaponDamageTakenModifier && !this._weaponDamageTakenModifier.isEmpty()) {
      result.weaponDamageTakenModifier = BehaviorModifier.toJson(this._weaponDamageTakenModifier);
    }
    if (this._hasAbilityDamageTakenModifier && !this._abilityDamageTakenModifier.isEmpty()) {
      result.abilityDamageTakenModifier = BehaviorModifier.toJson(this._abilityDamageTakenModifier);
    }
    if (this._hasCriticalChanceModifier && !this._criticalChanceModifier.isEmpty()) {
      result.criticalChanceModifier = BehaviorModifier.toJson(this._criticalChanceModifier);
    }
    if (this._hasAbilityCriticalChanceModifier && !this._abilityCriticalChanceModifier.isEmpty()) {
      result.abilityCriticalChanceModifier = BehaviorModifier.toJson(this._abilityCriticalChanceModifier);
    }
    if (this._hasAbilityGoldCostModifier && !this._abilityGoldCostModifier.isEmpty()) {
      result.abilityGoldCostModifier = BehaviorModifier.toJson(this._abilityGoldCostModifier);
    }
    if (this._hasAbilityManaCostModifier && !this._abilityManaCostModifier.isEmpty()) {
      result.abilityManaCostModifier = BehaviorModifier.toJson(this._abilityManaCostModifier);
    }
    if (this._hasAbilityHealthCostModifier && !this._abilityHealthCostModifier.isEmpty()) {
      result.abilityHealthCostModifier = BehaviorModifier.toJson(this._abilityHealthCostModifier);
    }
    if (this._hasHealModifier && !this._healModifier.isEmpty()) {
      result.healModifier = BehaviorModifier.toJson(this._healModifier);
    }
    if (this._hasWeaponRangeModifier && !this._weaponRangeModifier.isEmpty()) {
      result.weaponRangeModifier = BehaviorModifier.toJson(this._weaponRangeModifier);
    }
    if (this._hasWeaponScanRangeModifier && !this._weaponScanRangeModifier.isEmpty()) {
      result.weaponScanRangeModifier = BehaviorModifier.toJson(this._weaponScanRangeModifier);
    }
    if (this._hasAbilityCooldownModifier && !this._abilityCooldownModifier.isEmpty()) {
      result.abilityCooldownModifier = BehaviorModifier.toJson(this._abilityCooldownModifier);
    }
    if (this._hasChargeTimeModifier && !this._chargeTimeModifier.isEmpty()) {
      result.chargeTimeModifier = BehaviorModifier.toJson(this._chargeTimeModifier);
    }
    if (this._hasAbilitySpeedModifier && !this._abilitySpeedModifier.isEmpty()) {
      result.abilitySpeedModifier = BehaviorModifier.toJson(this._abilitySpeedModifier);
    }
    if (this._hasAbilityCooldownPeriodModifier && !this._abilityCooldownPeriodModifier.isEmpty()) {
      result.abilityCooldownPeriodModifier = BehaviorModifier.toJson(this._abilityCooldownPeriodModifier);
    }
    if (this._disabledWeapons.length > 0) {
      result.disabledWeapons = ArrayToJson(this._disabledWeapons, JsonToString);
    }
    if (this._enabledWeapons.length > 0) {
      result.enabledWeapons = ArrayToJson(this._enabledWeapons, JsonToString);
    }
    if (this._disabledWeaponFamilies.length > 0) {
      result.disabledWeaponFamilies = ArrayToJson(this._disabledWeaponFamilies, JsonToString);
    }
    if (this._enabledWeaponFamilies.length > 0) {
      result.enabledWeaponFamilies = ArrayToJson(this._enabledWeaponFamilies, JsonToString);
    }
    if (this._weaponModifierGroup.length > 0) {
      result.weaponModifierGroup = ArrayToJson(this._weaponModifierGroup, JsonToString);
    }
    if (this._abilityModifierGroup.length > 0) {
      result.abilityModifierGroup = ArrayToJson(this._abilityModifierGroup, JsonToString);
    }
    if (this._disabledAbilities.length > 0) {
      result.disabledAbilities = ArrayToJson(this._disabledAbilities, JsonToString);
    }
    if (this._enabledAbilities.length > 0) {
      result.enabledAbilities = ArrayToJson(this._enabledAbilities, JsonToString);
    }
    if (this._hideAbilities.length > 0) {
      result.hideAbilities = ArrayToJson(this._hideAbilities, JsonToString);
    }
    if (this._showAbilities.length > 0) {
      result.showAbilities = ArrayToJson(this._showAbilities, JsonToString);
    }
    if (this._addHighlightToAbilities.length > 0) {
      result.addHighlightToAbilities = ArrayToJson(this._addHighlightToAbilities, JsonToString);
    }
    if (this._removeHighlightFromAbilities.length > 0) {
      result.removeHighlightFromAbilities = ArrayToJson(this._removeHighlightFromAbilities, JsonToString);
    }
    return result;
  }
  /**
   * @returns {BehaviorFlags}
   */
  get flags() {
    return this._hasFlags ? this._flags : BehaviorFlags.default;
  }
  get hasFlags() {
    return this._hasFlags;
  }
  setFlags(path, value) {
    return {type: 'SET', path: path.concat(['flags']), value: value.toJson()};
  }
  deleteFlags(path) {
    return {type: 'DELETE', path: path.concat(['flags'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get maxHealthModifier() {
    return this._hasMaxHealthModifier ? this._maxHealthModifier : BehaviorModifier.default;
  }
  get hasMaxHealthModifier() {
    return this._hasMaxHealthModifier;
  }
  setMaxHealthModifier(path, value) {
    return {type: 'SET', path: path.concat(['maxHealthModifier']), value: value.toJson()};
  }
  deleteMaxHealthModifier(path) {
    return {type: 'DELETE', path: path.concat(['maxHealthModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get maxManaModifier() {
    return this._hasMaxManaModifier ? this._maxManaModifier : BehaviorModifier.default;
  }
  get hasMaxManaModifier() {
    return this._hasMaxManaModifier;
  }
  setMaxManaModifier(path, value) {
    return {type: 'SET', path: path.concat(['maxManaModifier']), value: value.toJson()};
  }
  deleteMaxManaModifier(path) {
    return {type: 'DELETE', path: path.concat(['maxManaModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get maxShieldModifier() {
    return this._hasMaxShieldModifier ? this._maxShieldModifier : BehaviorModifier.default;
  }
  get hasMaxShieldModifier() {
    return this._hasMaxShieldModifier;
  }
  setMaxShieldModifier(path, value) {
    return {type: 'SET', path: path.concat(['maxShieldModifier']), value: value.toJson()};
  }
  deleteMaxShieldModifier(path) {
    return {type: 'DELETE', path: path.concat(['maxShieldModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get healthRegenerationModifier() {
    return this._hasHealthRegenerationModifier ? this._healthRegenerationModifier : BehaviorModifier.default;
  }
  get hasHealthRegenerationModifier() {
    return this._hasHealthRegenerationModifier;
  }
  setHealthRegenerationModifier(path, value) {
    return {type: 'SET', path: path.concat(['healthRegenerationModifier']), value: value.toJson()};
  }
  deleteHealthRegenerationModifier(path) {
    return {type: 'DELETE', path: path.concat(['healthRegenerationModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get manaRegenerationModifier() {
    return this._hasManaRegenerationModifier ? this._manaRegenerationModifier : BehaviorModifier.default;
  }
  get hasManaRegenerationModifier() {
    return this._hasManaRegenerationModifier;
  }
  setManaRegenerationModifier(path, value) {
    return {type: 'SET', path: path.concat(['manaRegenerationModifier']), value: value.toJson()};
  }
  deleteManaRegenerationModifier(path) {
    return {type: 'DELETE', path: path.concat(['manaRegenerationModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get shieldRegenerationModifier() {
    return this._hasShieldRegenerationModifier ? this._shieldRegenerationModifier : BehaviorModifier.default;
  }
  get hasShieldRegenerationModifier() {
    return this._hasShieldRegenerationModifier;
  }
  setShieldRegenerationModifier(path, value) {
    return {type: 'SET', path: path.concat(['shieldRegenerationModifier']), value: value.toJson()};
  }
  deleteShieldRegenerationModifier(path) {
    return {type: 'DELETE', path: path.concat(['shieldRegenerationModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get unitTargetPriority() {
    return this._hasUnitTargetPriority ? this._unitTargetPriority : BehaviorModifier.default;
  }
  get hasUnitTargetPriority() {
    return this._hasUnitTargetPriority;
  }
  setUnitTargetPriority(path, value) {
    return {type: 'SET', path: path.concat(['unitTargetPriority']), value: value.toJson()};
  }
  deleteUnitTargetPriority(path) {
    return {type: 'DELETE', path: path.concat(['unitTargetPriority'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get unitRadiusModifier() {
    return this._hasUnitRadiusModifier ? this._unitRadiusModifier : BehaviorModifier.default;
  }
  get hasUnitRadiusModifier() {
    return this._hasUnitRadiusModifier;
  }
  setUnitRadiusModifier(path, value) {
    return {type: 'SET', path: path.concat(['unitRadiusModifier']), value: value.toJson()};
  }
  deleteUnitRadiusModifier(path) {
    return {type: 'DELETE', path: path.concat(['unitRadiusModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get moveSpeedModifier() {
    return this._hasMoveSpeedModifier ? this._moveSpeedModifier : BehaviorModifier.default;
  }
  get hasMoveSpeedModifier() {
    return this._hasMoveSpeedModifier;
  }
  setMoveSpeedModifier(path, value) {
    return {type: 'SET', path: path.concat(['moveSpeedModifier']), value: value.toJson()};
  }
  deleteMoveSpeedModifier(path) {
    return {type: 'DELETE', path: path.concat(['moveSpeedModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get attackSpeedModifier() {
    return this._hasAttackSpeedModifier ? this._attackSpeedModifier : BehaviorModifier.default;
  }
  get hasAttackSpeedModifier() {
    return this._hasAttackSpeedModifier;
  }
  setAttackSpeedModifier(path, value) {
    return {type: 'SET', path: path.concat(['attackSpeedModifier']), value: value.toJson()};
  }
  deleteAttackSpeedModifier(path) {
    return {type: 'DELETE', path: path.concat(['attackSpeedModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get weaponDamageModifier() {
    return this._hasWeaponDamageModifier ? this._weaponDamageModifier : BehaviorModifier.default;
  }
  get hasWeaponDamageModifier() {
    return this._hasWeaponDamageModifier;
  }
  setWeaponDamageModifier(path, value) {
    return {type: 'SET', path: path.concat(['weaponDamageModifier']), value: value.toJson()};
  }
  deleteWeaponDamageModifier(path) {
    return {type: 'DELETE', path: path.concat(['weaponDamageModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityDamageModifier() {
    return this._hasAbilityDamageModifier ? this._abilityDamageModifier : BehaviorModifier.default;
  }
  get hasAbilityDamageModifier() {
    return this._hasAbilityDamageModifier;
  }
  setAbilityDamageModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityDamageModifier']), value: value.toJson()};
  }
  deleteAbilityDamageModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityDamageModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get weaponDamageTakenModifier() {
    return this._hasWeaponDamageTakenModifier ? this._weaponDamageTakenModifier : BehaviorModifier.default;
  }
  get hasWeaponDamageTakenModifier() {
    return this._hasWeaponDamageTakenModifier;
  }
  setWeaponDamageTakenModifier(path, value) {
    return {type: 'SET', path: path.concat(['weaponDamageTakenModifier']), value: value.toJson()};
  }
  deleteWeaponDamageTakenModifier(path) {
    return {type: 'DELETE', path: path.concat(['weaponDamageTakenModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityDamageTakenModifier() {
    return this._hasAbilityDamageTakenModifier ? this._abilityDamageTakenModifier : BehaviorModifier.default;
  }
  get hasAbilityDamageTakenModifier() {
    return this._hasAbilityDamageTakenModifier;
  }
  setAbilityDamageTakenModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityDamageTakenModifier']), value: value.toJson()};
  }
  deleteAbilityDamageTakenModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityDamageTakenModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get criticalChanceModifier() {
    return this._hasCriticalChanceModifier ? this._criticalChanceModifier : BehaviorModifier.default;
  }
  get hasCriticalChanceModifier() {
    return this._hasCriticalChanceModifier;
  }
  setCriticalChanceModifier(path, value) {
    return {type: 'SET', path: path.concat(['criticalChanceModifier']), value: value.toJson()};
  }
  deleteCriticalChanceModifier(path) {
    return {type: 'DELETE', path: path.concat(['criticalChanceModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityCriticalChanceModifier() {
    return this._hasAbilityCriticalChanceModifier ? this._abilityCriticalChanceModifier : BehaviorModifier.default;
  }
  get hasAbilityCriticalChanceModifier() {
    return this._hasAbilityCriticalChanceModifier;
  }
  setAbilityCriticalChanceModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityCriticalChanceModifier']), value: value.toJson()};
  }
  deleteAbilityCriticalChanceModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityCriticalChanceModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityGoldCostModifier() {
    return this._hasAbilityGoldCostModifier ? this._abilityGoldCostModifier : BehaviorModifier.default;
  }
  get hasAbilityGoldCostModifier() {
    return this._hasAbilityGoldCostModifier;
  }
  setAbilityGoldCostModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityGoldCostModifier']), value: value.toJson()};
  }
  deleteAbilityGoldCostModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityGoldCostModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityManaCostModifier() {
    return this._hasAbilityManaCostModifier ? this._abilityManaCostModifier : BehaviorModifier.default;
  }
  get hasAbilityManaCostModifier() {
    return this._hasAbilityManaCostModifier;
  }
  setAbilityManaCostModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityManaCostModifier']), value: value.toJson()};
  }
  deleteAbilityManaCostModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityManaCostModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityHealthCostModifier() {
    return this._hasAbilityHealthCostModifier ? this._abilityHealthCostModifier : BehaviorModifier.default;
  }
  get hasAbilityHealthCostModifier() {
    return this._hasAbilityHealthCostModifier;
  }
  setAbilityHealthCostModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityHealthCostModifier']), value: value.toJson()};
  }
  deleteAbilityHealthCostModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityHealthCostModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get healModifier() {
    return this._hasHealModifier ? this._healModifier : BehaviorModifier.default;
  }
  get hasHealModifier() {
    return this._hasHealModifier;
  }
  setHealModifier(path, value) {
    return {type: 'SET', path: path.concat(['healModifier']), value: value.toJson()};
  }
  deleteHealModifier(path) {
    return {type: 'DELETE', path: path.concat(['healModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get weaponRangeModifier() {
    return this._hasWeaponRangeModifier ? this._weaponRangeModifier : BehaviorModifier.default;
  }
  get hasWeaponRangeModifier() {
    return this._hasWeaponRangeModifier;
  }
  setWeaponRangeModifier(path, value) {
    return {type: 'SET', path: path.concat(['weaponRangeModifier']), value: value.toJson()};
  }
  deleteWeaponRangeModifier(path) {
    return {type: 'DELETE', path: path.concat(['weaponRangeModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get weaponScanRangeModifier() {
    return this._hasWeaponScanRangeModifier ? this._weaponScanRangeModifier : BehaviorModifier.default;
  }
  get hasWeaponScanRangeModifier() {
    return this._hasWeaponScanRangeModifier;
  }
  setWeaponScanRangeModifier(path, value) {
    return {type: 'SET', path: path.concat(['weaponScanRangeModifier']), value: value.toJson()};
  }
  deleteWeaponScanRangeModifier(path) {
    return {type: 'DELETE', path: path.concat(['weaponScanRangeModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityCooldownModifier() {
    return this._hasAbilityCooldownModifier ? this._abilityCooldownModifier : BehaviorModifier.default;
  }
  get hasAbilityCooldownModifier() {
    return this._hasAbilityCooldownModifier;
  }
  setAbilityCooldownModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityCooldownModifier']), value: value.toJson()};
  }
  deleteAbilityCooldownModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityCooldownModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get chargeTimeModifier() {
    return this._hasChargeTimeModifier ? this._chargeTimeModifier : BehaviorModifier.default;
  }
  get hasChargeTimeModifier() {
    return this._hasChargeTimeModifier;
  }
  setChargeTimeModifier(path, value) {
    return {type: 'SET', path: path.concat(['chargeTimeModifier']), value: value.toJson()};
  }
  deleteChargeTimeModifier(path) {
    return {type: 'DELETE', path: path.concat(['chargeTimeModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilitySpeedModifier() {
    return this._hasAbilitySpeedModifier ? this._abilitySpeedModifier : BehaviorModifier.default;
  }
  get hasAbilitySpeedModifier() {
    return this._hasAbilitySpeedModifier;
  }
  setAbilitySpeedModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilitySpeedModifier']), value: value.toJson()};
  }
  deleteAbilitySpeedModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilitySpeedModifier'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get abilityCooldownPeriodModifier() {
    return this._hasAbilityCooldownPeriodModifier ? this._abilityCooldownPeriodModifier : BehaviorModifier.default;
  }
  get hasAbilityCooldownPeriodModifier() {
    return this._hasAbilityCooldownPeriodModifier;
  }
  setAbilityCooldownPeriodModifier(path, value) {
    return {type: 'SET', path: path.concat(['abilityCooldownPeriodModifier']), value: value.toJson()};
  }
  deleteAbilityCooldownPeriodModifier(path) {
    return {type: 'DELETE', path: path.concat(['abilityCooldownPeriodModifier'])};
  }
  /**
   * @returns {string[]}
   */
  get disabledWeapons() {
    return this._disabledWeapons;
  }
  addDisabledWeapons(path, value) {
    return {type: 'ADD', path: path.concat(['disabledWeapons']), value};
  }
  setDisabledWeapons(path, value) {
    return {type: 'SET', path: path.concat(['disabledWeapons']), value: ArrayToJson(value, JsonToString)};
  }
  setDisabledWeaponsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['disabledWeapons', key]), value};
  }
  deleteDisabledWeapons(path) {
    return {type: 'DELETE', path: path.concat(['disabledWeapons'])};
  }
  deleteDisabledWeaponsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['disabledWeapons', key])};
  }
  /**
   * @returns {string[]}
   */
  get enabledWeapons() {
    return this._enabledWeapons;
  }
  addEnabledWeapons(path, value) {
    return {type: 'ADD', path: path.concat(['enabledWeapons']), value};
  }
  setEnabledWeapons(path, value) {
    return {type: 'SET', path: path.concat(['enabledWeapons']), value: ArrayToJson(value, JsonToString)};
  }
  setEnabledWeaponsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['enabledWeapons', key]), value};
  }
  deleteEnabledWeapons(path) {
    return {type: 'DELETE', path: path.concat(['enabledWeapons'])};
  }
  deleteEnabledWeaponsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['enabledWeapons', key])};
  }
  /**
   * @returns {string[]}
   */
  get disabledWeaponFamilies() {
    return this._disabledWeaponFamilies;
  }
  addDisabledWeaponFamilies(path, value) {
    return {type: 'ADD', path: path.concat(['disabledWeaponFamilies']), value};
  }
  setDisabledWeaponFamilies(path, value) {
    return {type: 'SET', path: path.concat(['disabledWeaponFamilies']), value: ArrayToJson(value, JsonToString)};
  }
  setDisabledWeaponFamiliesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['disabledWeaponFamilies', key]), value};
  }
  deleteDisabledWeaponFamilies(path) {
    return {type: 'DELETE', path: path.concat(['disabledWeaponFamilies'])};
  }
  deleteDisabledWeaponFamiliesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['disabledWeaponFamilies', key])};
  }
  /**
   * @returns {string[]}
   */
  get enabledWeaponFamilies() {
    return this._enabledWeaponFamilies;
  }
  addEnabledWeaponFamilies(path, value) {
    return {type: 'ADD', path: path.concat(['enabledWeaponFamilies']), value};
  }
  setEnabledWeaponFamilies(path, value) {
    return {type: 'SET', path: path.concat(['enabledWeaponFamilies']), value: ArrayToJson(value, JsonToString)};
  }
  setEnabledWeaponFamiliesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['enabledWeaponFamilies', key]), value};
  }
  deleteEnabledWeaponFamilies(path) {
    return {type: 'DELETE', path: path.concat(['enabledWeaponFamilies'])};
  }
  deleteEnabledWeaponFamiliesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['enabledWeaponFamilies', key])};
  }
  /**
   * @returns {string[]}
   */
  get weaponModifierGroup() {
    return this._weaponModifierGroup;
  }
  addWeaponModifierGroup(path, value) {
    return {type: 'ADD', path: path.concat(['weaponModifierGroup']), value};
  }
  setWeaponModifierGroup(path, value) {
    return {type: 'SET', path: path.concat(['weaponModifierGroup']), value: ArrayToJson(value, JsonToString)};
  }
  setWeaponModifierGroupByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['weaponModifierGroup', key]), value};
  }
  deleteWeaponModifierGroup(path) {
    return {type: 'DELETE', path: path.concat(['weaponModifierGroup'])};
  }
  deleteWeaponModifierGroupByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['weaponModifierGroup', key])};
  }
  /**
   * @returns {string[]}
   */
  get abilityModifierGroup() {
    return this._abilityModifierGroup;
  }
  addAbilityModifierGroup(path, value) {
    return {type: 'ADD', path: path.concat(['abilityModifierGroup']), value};
  }
  setAbilityModifierGroup(path, value) {
    return {type: 'SET', path: path.concat(['abilityModifierGroup']), value: ArrayToJson(value, JsonToString)};
  }
  setAbilityModifierGroupByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['abilityModifierGroup', key]), value};
  }
  deleteAbilityModifierGroup(path) {
    return {type: 'DELETE', path: path.concat(['abilityModifierGroup'])};
  }
  deleteAbilityModifierGroupByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['abilityModifierGroup', key])};
  }
  /**
   * @returns {string[]}
   */
  get disabledAbilities() {
    return this._disabledAbilities;
  }
  addDisabledAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['disabledAbilities']), value};
  }
  setDisabledAbilities(path, value) {
    return {type: 'SET', path: path.concat(['disabledAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setDisabledAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['disabledAbilities', key]), value};
  }
  deleteDisabledAbilities(path) {
    return {type: 'DELETE', path: path.concat(['disabledAbilities'])};
  }
  deleteDisabledAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['disabledAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get enabledAbilities() {
    return this._enabledAbilities;
  }
  addEnabledAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['enabledAbilities']), value};
  }
  setEnabledAbilities(path, value) {
    return {type: 'SET', path: path.concat(['enabledAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setEnabledAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['enabledAbilities', key]), value};
  }
  deleteEnabledAbilities(path) {
    return {type: 'DELETE', path: path.concat(['enabledAbilities'])};
  }
  deleteEnabledAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['enabledAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get hideAbilities() {
    return this._hideAbilities;
  }
  addHideAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['hideAbilities']), value};
  }
  setHideAbilities(path, value) {
    return {type: 'SET', path: path.concat(['hideAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setHideAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['hideAbilities', key]), value};
  }
  deleteHideAbilities(path) {
    return {type: 'DELETE', path: path.concat(['hideAbilities'])};
  }
  deleteHideAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['hideAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get showAbilities() {
    return this._showAbilities;
  }
  addShowAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['showAbilities']), value};
  }
  setShowAbilities(path, value) {
    return {type: 'SET', path: path.concat(['showAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setShowAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['showAbilities', key]), value};
  }
  deleteShowAbilities(path) {
    return {type: 'DELETE', path: path.concat(['showAbilities'])};
  }
  deleteShowAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['showAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get addHighlightToAbilities() {
    return this._addHighlightToAbilities;
  }
  addAddHighlightToAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['addHighlightToAbilities']), value};
  }
  setAddHighlightToAbilities(path, value) {
    return {type: 'SET', path: path.concat(['addHighlightToAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setAddHighlightToAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['addHighlightToAbilities', key]), value};
  }
  deleteAddHighlightToAbilities(path) {
    return {type: 'DELETE', path: path.concat(['addHighlightToAbilities'])};
  }
  deleteAddHighlightToAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['addHighlightToAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get removeHighlightFromAbilities() {
    return this._removeHighlightFromAbilities;
  }
  addRemoveHighlightFromAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['removeHighlightFromAbilities']), value};
  }
  setRemoveHighlightFromAbilities(path, value) {
    return {type: 'SET', path: path.concat(['removeHighlightFromAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setRemoveHighlightFromAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['removeHighlightFromAbilities', key]), value};
  }
  deleteRemoveHighlightFromAbilities(path) {
    return {type: 'DELETE', path: path.concat(['removeHighlightFromAbilities'])};
  }
  deleteRemoveHighlightFromAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['removeHighlightFromAbilities', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "flags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasFlags = true;
              copy._flags = BehaviorFlags.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlags) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasFlags = false;
              copy._flags = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFlags) {
            const copy = new BehaviorModifiers(this);
            copy._hasFlags = true;
            copy._flags = BehaviorFlags.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._flags.apply(type, path.slice(1), value);
          if (newValue === this._flags) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._flags = copy._flags.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "maxHealthModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasMaxHealthModifier = true;
              copy._maxHealthModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxHealthModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasMaxHealthModifier = false;
              copy._maxHealthModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMaxHealthModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasMaxHealthModifier = true;
            copy._maxHealthModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._maxHealthModifier.apply(type, path.slice(1), value);
          if (newValue === this._maxHealthModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._maxHealthModifier = copy._maxHealthModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "maxManaModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasMaxManaModifier = true;
              copy._maxManaModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxManaModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasMaxManaModifier = false;
              copy._maxManaModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMaxManaModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasMaxManaModifier = true;
            copy._maxManaModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._maxManaModifier.apply(type, path.slice(1), value);
          if (newValue === this._maxManaModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._maxManaModifier = copy._maxManaModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "maxShieldModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasMaxShieldModifier = true;
              copy._maxShieldModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxShieldModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasMaxShieldModifier = false;
              copy._maxShieldModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMaxShieldModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasMaxShieldModifier = true;
            copy._maxShieldModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._maxShieldModifier.apply(type, path.slice(1), value);
          if (newValue === this._maxShieldModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._maxShieldModifier = copy._maxShieldModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "healthRegenerationModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasHealthRegenerationModifier = true;
              copy._healthRegenerationModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealthRegenerationModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasHealthRegenerationModifier = false;
              copy._healthRegenerationModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealthRegenerationModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasHealthRegenerationModifier = true;
            copy._healthRegenerationModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healthRegenerationModifier.apply(type, path.slice(1), value);
          if (newValue === this._healthRegenerationModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._healthRegenerationModifier = copy._healthRegenerationModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "manaRegenerationModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasManaRegenerationModifier = true;
              copy._manaRegenerationModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasManaRegenerationModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasManaRegenerationModifier = false;
              copy._manaRegenerationModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasManaRegenerationModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasManaRegenerationModifier = true;
            copy._manaRegenerationModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._manaRegenerationModifier.apply(type, path.slice(1), value);
          if (newValue === this._manaRegenerationModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._manaRegenerationModifier = copy._manaRegenerationModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "shieldRegenerationModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasShieldRegenerationModifier = true;
              copy._shieldRegenerationModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShieldRegenerationModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasShieldRegenerationModifier = false;
              copy._shieldRegenerationModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasShieldRegenerationModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasShieldRegenerationModifier = true;
            copy._shieldRegenerationModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._shieldRegenerationModifier.apply(type, path.slice(1), value);
          if (newValue === this._shieldRegenerationModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._shieldRegenerationModifier = copy._shieldRegenerationModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitTargetPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasUnitTargetPriority = true;
              copy._unitTargetPriority = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitTargetPriority) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasUnitTargetPriority = false;
              copy._unitTargetPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitTargetPriority) {
            const copy = new BehaviorModifiers(this);
            copy._hasUnitTargetPriority = true;
            copy._unitTargetPriority = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitTargetPriority.apply(type, path.slice(1), value);
          if (newValue === this._unitTargetPriority) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._unitTargetPriority = copy._unitTargetPriority.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitRadiusModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasUnitRadiusModifier = true;
              copy._unitRadiusModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitRadiusModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasUnitRadiusModifier = false;
              copy._unitRadiusModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitRadiusModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasUnitRadiusModifier = true;
            copy._unitRadiusModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitRadiusModifier.apply(type, path.slice(1), value);
          if (newValue === this._unitRadiusModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._unitRadiusModifier = copy._unitRadiusModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "moveSpeedModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasMoveSpeedModifier = true;
              copy._moveSpeedModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMoveSpeedModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasMoveSpeedModifier = false;
              copy._moveSpeedModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMoveSpeedModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasMoveSpeedModifier = true;
            copy._moveSpeedModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._moveSpeedModifier.apply(type, path.slice(1), value);
          if (newValue === this._moveSpeedModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._moveSpeedModifier = copy._moveSpeedModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "attackSpeedModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAttackSpeedModifier = true;
              copy._attackSpeedModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAttackSpeedModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAttackSpeedModifier = false;
              copy._attackSpeedModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAttackSpeedModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAttackSpeedModifier = true;
            copy._attackSpeedModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._attackSpeedModifier.apply(type, path.slice(1), value);
          if (newValue === this._attackSpeedModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._attackSpeedModifier = copy._attackSpeedModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "weaponDamageModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponDamageModifier = true;
              copy._weaponDamageModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeaponDamageModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponDamageModifier = false;
              copy._weaponDamageModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWeaponDamageModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasWeaponDamageModifier = true;
            copy._weaponDamageModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._weaponDamageModifier.apply(type, path.slice(1), value);
          if (newValue === this._weaponDamageModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._weaponDamageModifier = copy._weaponDamageModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityDamageModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityDamageModifier = true;
              copy._abilityDamageModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityDamageModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityDamageModifier = false;
              copy._abilityDamageModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityDamageModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityDamageModifier = true;
            copy._abilityDamageModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityDamageModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityDamageModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityDamageModifier = copy._abilityDamageModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "weaponDamageTakenModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponDamageTakenModifier = true;
              copy._weaponDamageTakenModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeaponDamageTakenModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponDamageTakenModifier = false;
              copy._weaponDamageTakenModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWeaponDamageTakenModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasWeaponDamageTakenModifier = true;
            copy._weaponDamageTakenModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._weaponDamageTakenModifier.apply(type, path.slice(1), value);
          if (newValue === this._weaponDamageTakenModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._weaponDamageTakenModifier = copy._weaponDamageTakenModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityDamageTakenModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityDamageTakenModifier = true;
              copy._abilityDamageTakenModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityDamageTakenModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityDamageTakenModifier = false;
              copy._abilityDamageTakenModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityDamageTakenModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityDamageTakenModifier = true;
            copy._abilityDamageTakenModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityDamageTakenModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityDamageTakenModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityDamageTakenModifier = copy._abilityDamageTakenModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "criticalChanceModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasCriticalChanceModifier = true;
              copy._criticalChanceModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalChanceModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasCriticalChanceModifier = false;
              copy._criticalChanceModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCriticalChanceModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasCriticalChanceModifier = true;
            copy._criticalChanceModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._criticalChanceModifier.apply(type, path.slice(1), value);
          if (newValue === this._criticalChanceModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._criticalChanceModifier = copy._criticalChanceModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityCriticalChanceModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCriticalChanceModifier = true;
              copy._abilityCriticalChanceModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityCriticalChanceModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCriticalChanceModifier = false;
              copy._abilityCriticalChanceModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityCriticalChanceModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityCriticalChanceModifier = true;
            copy._abilityCriticalChanceModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityCriticalChanceModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityCriticalChanceModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityCriticalChanceModifier = copy._abilityCriticalChanceModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityGoldCostModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityGoldCostModifier = true;
              copy._abilityGoldCostModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityGoldCostModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityGoldCostModifier = false;
              copy._abilityGoldCostModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityGoldCostModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityGoldCostModifier = true;
            copy._abilityGoldCostModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityGoldCostModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityGoldCostModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityGoldCostModifier = copy._abilityGoldCostModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityManaCostModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityManaCostModifier = true;
              copy._abilityManaCostModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityManaCostModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityManaCostModifier = false;
              copy._abilityManaCostModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityManaCostModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityManaCostModifier = true;
            copy._abilityManaCostModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityManaCostModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityManaCostModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityManaCostModifier = copy._abilityManaCostModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityHealthCostModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityHealthCostModifier = true;
              copy._abilityHealthCostModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityHealthCostModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityHealthCostModifier = false;
              copy._abilityHealthCostModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityHealthCostModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityHealthCostModifier = true;
            copy._abilityHealthCostModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityHealthCostModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityHealthCostModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityHealthCostModifier = copy._abilityHealthCostModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "healModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasHealModifier = true;
              copy._healModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasHealModifier = false;
              copy._healModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasHealModifier = true;
            copy._healModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healModifier.apply(type, path.slice(1), value);
          if (newValue === this._healModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._healModifier = copy._healModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "weaponRangeModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponRangeModifier = true;
              copy._weaponRangeModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeaponRangeModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponRangeModifier = false;
              copy._weaponRangeModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWeaponRangeModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasWeaponRangeModifier = true;
            copy._weaponRangeModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._weaponRangeModifier.apply(type, path.slice(1), value);
          if (newValue === this._weaponRangeModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._weaponRangeModifier = copy._weaponRangeModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "weaponScanRangeModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponScanRangeModifier = true;
              copy._weaponScanRangeModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeaponScanRangeModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasWeaponScanRangeModifier = false;
              copy._weaponScanRangeModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWeaponScanRangeModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasWeaponScanRangeModifier = true;
            copy._weaponScanRangeModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._weaponScanRangeModifier.apply(type, path.slice(1), value);
          if (newValue === this._weaponScanRangeModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._weaponScanRangeModifier = copy._weaponScanRangeModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityCooldownModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCooldownModifier = true;
              copy._abilityCooldownModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityCooldownModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCooldownModifier = false;
              copy._abilityCooldownModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityCooldownModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityCooldownModifier = true;
            copy._abilityCooldownModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityCooldownModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityCooldownModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityCooldownModifier = copy._abilityCooldownModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chargeTimeModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasChargeTimeModifier = true;
              copy._chargeTimeModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChargeTimeModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasChargeTimeModifier = false;
              copy._chargeTimeModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChargeTimeModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasChargeTimeModifier = true;
            copy._chargeTimeModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chargeTimeModifier.apply(type, path.slice(1), value);
          if (newValue === this._chargeTimeModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._chargeTimeModifier = copy._chargeTimeModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilitySpeedModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilitySpeedModifier = true;
              copy._abilitySpeedModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilitySpeedModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilitySpeedModifier = false;
              copy._abilitySpeedModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilitySpeedModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilitySpeedModifier = true;
            copy._abilitySpeedModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilitySpeedModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilitySpeedModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilitySpeedModifier = copy._abilitySpeedModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "abilityCooldownPeriodModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCooldownPeriodModifier = true;
              copy._abilityCooldownPeriodModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityCooldownPeriodModifier) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hasAbilityCooldownPeriodModifier = false;
              copy._abilityCooldownPeriodModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAbilityCooldownPeriodModifier) {
            const copy = new BehaviorModifiers(this);
            copy._hasAbilityCooldownPeriodModifier = true;
            copy._abilityCooldownPeriodModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._abilityCooldownPeriodModifier.apply(type, path.slice(1), value);
          if (newValue === this._abilityCooldownPeriodModifier) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityCooldownPeriodModifier = copy._abilityCooldownPeriodModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "disabledWeapons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeapons = [];        for (let i of value) {
                copy._disabledWeapons.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeapons = copy._disabledWeapons.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._disabledWeapons.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._disabledWeapons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._disabledWeapons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeapons = copy._disabledWeapons.slice();
              copy._disabledWeapons[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeapons = copy._disabledWeapons.slice(0, path[1]).concat(copy._disabledWeapons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._disabledWeapons.length) {
            return this;
          }
          const oldValue = this._disabledWeapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._disabledWeapons = copy._disabledWeapons.slice();
          copy._disabledWeapons[key] = newValue;
          return copy;
        }
      }
      case "enabledWeapons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeapons = [];        for (let i of value) {
                copy._enabledWeapons.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeapons = copy._enabledWeapons.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._enabledWeapons.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._enabledWeapons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._enabledWeapons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeapons = copy._enabledWeapons.slice();
              copy._enabledWeapons[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeapons = copy._enabledWeapons.slice(0, path[1]).concat(copy._enabledWeapons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._enabledWeapons.length) {
            return this;
          }
          const oldValue = this._enabledWeapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._enabledWeapons = copy._enabledWeapons.slice();
          copy._enabledWeapons[key] = newValue;
          return copy;
        }
      }
      case "disabledWeaponFamilies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeaponFamilies = [];        for (let i of value) {
                copy._disabledWeaponFamilies.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeaponFamilies = copy._disabledWeaponFamilies.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._disabledWeaponFamilies.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._disabledWeaponFamilies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._disabledWeaponFamilies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeaponFamilies = copy._disabledWeaponFamilies.slice();
              copy._disabledWeaponFamilies[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._disabledWeaponFamilies = copy._disabledWeaponFamilies.slice(0, path[1]).concat(copy._disabledWeaponFamilies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._disabledWeaponFamilies.length) {
            return this;
          }
          const oldValue = this._disabledWeaponFamilies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._disabledWeaponFamilies = copy._disabledWeaponFamilies.slice();
          copy._disabledWeaponFamilies[key] = newValue;
          return copy;
        }
      }
      case "enabledWeaponFamilies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeaponFamilies = [];        for (let i of value) {
                copy._enabledWeaponFamilies.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeaponFamilies = copy._enabledWeaponFamilies.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._enabledWeaponFamilies.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._enabledWeaponFamilies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._enabledWeaponFamilies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeaponFamilies = copy._enabledWeaponFamilies.slice();
              copy._enabledWeaponFamilies[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._enabledWeaponFamilies = copy._enabledWeaponFamilies.slice(0, path[1]).concat(copy._enabledWeaponFamilies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._enabledWeaponFamilies.length) {
            return this;
          }
          const oldValue = this._enabledWeaponFamilies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._enabledWeaponFamilies = copy._enabledWeaponFamilies.slice();
          copy._enabledWeaponFamilies[key] = newValue;
          return copy;
        }
      }
      case "weaponModifierGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._weaponModifierGroup = [];        for (let i of value) {
                copy._weaponModifierGroup.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._weaponModifierGroup = copy._weaponModifierGroup.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._weaponModifierGroup.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._weaponModifierGroup = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._weaponModifierGroup.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._weaponModifierGroup = copy._weaponModifierGroup.slice();
              copy._weaponModifierGroup[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._weaponModifierGroup = copy._weaponModifierGroup.slice(0, path[1]).concat(copy._weaponModifierGroup.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._weaponModifierGroup.length) {
            return this;
          }
          const oldValue = this._weaponModifierGroup[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._weaponModifierGroup = copy._weaponModifierGroup.slice();
          copy._weaponModifierGroup[key] = newValue;
          return copy;
        }
      }
      case "abilityModifierGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._abilityModifierGroup = [];        for (let i of value) {
                copy._abilityModifierGroup.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._abilityModifierGroup = copy._abilityModifierGroup.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._abilityModifierGroup.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._abilityModifierGroup = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._abilityModifierGroup.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._abilityModifierGroup = copy._abilityModifierGroup.slice();
              copy._abilityModifierGroup[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._abilityModifierGroup = copy._abilityModifierGroup.slice(0, path[1]).concat(copy._abilityModifierGroup.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._abilityModifierGroup.length) {
            return this;
          }
          const oldValue = this._abilityModifierGroup[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._abilityModifierGroup = copy._abilityModifierGroup.slice();
          copy._abilityModifierGroup[key] = newValue;
          return copy;
        }
      }
      case "disabledAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledAbilities = [];        for (let i of value) {
                copy._disabledAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._disabledAbilities = copy._disabledAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._disabledAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._disabledAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._disabledAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._disabledAbilities = copy._disabledAbilities.slice();
              copy._disabledAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._disabledAbilities = copy._disabledAbilities.slice(0, path[1]).concat(copy._disabledAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._disabledAbilities.length) {
            return this;
          }
          const oldValue = this._disabledAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._disabledAbilities = copy._disabledAbilities.slice();
          copy._disabledAbilities[key] = newValue;
          return copy;
        }
      }
      case "enabledAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledAbilities = [];        for (let i of value) {
                copy._enabledAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._enabledAbilities = copy._enabledAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._enabledAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._enabledAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._enabledAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._enabledAbilities = copy._enabledAbilities.slice();
              copy._enabledAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._enabledAbilities = copy._enabledAbilities.slice(0, path[1]).concat(copy._enabledAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._enabledAbilities.length) {
            return this;
          }
          const oldValue = this._enabledAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._enabledAbilities = copy._enabledAbilities.slice();
          copy._enabledAbilities[key] = newValue;
          return copy;
        }
      }
      case "hideAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hideAbilities = [];        for (let i of value) {
                copy._hideAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._hideAbilities = copy._hideAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._hideAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._hideAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._hideAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._hideAbilities = copy._hideAbilities.slice();
              copy._hideAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._hideAbilities = copy._hideAbilities.slice(0, path[1]).concat(copy._hideAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._hideAbilities.length) {
            return this;
          }
          const oldValue = this._hideAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._hideAbilities = copy._hideAbilities.slice();
          copy._hideAbilities[key] = newValue;
          return copy;
        }
      }
      case "showAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._showAbilities = [];        for (let i of value) {
                copy._showAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._showAbilities = copy._showAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._showAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._showAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._showAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._showAbilities = copy._showAbilities.slice();
              copy._showAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._showAbilities = copy._showAbilities.slice(0, path[1]).concat(copy._showAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._showAbilities.length) {
            return this;
          }
          const oldValue = this._showAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._showAbilities = copy._showAbilities.slice();
          copy._showAbilities[key] = newValue;
          return copy;
        }
      }
      case "addHighlightToAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._addHighlightToAbilities = [];        for (let i of value) {
                copy._addHighlightToAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._addHighlightToAbilities = copy._addHighlightToAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._addHighlightToAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._addHighlightToAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._addHighlightToAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._addHighlightToAbilities = copy._addHighlightToAbilities.slice();
              copy._addHighlightToAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._addHighlightToAbilities = copy._addHighlightToAbilities.slice(0, path[1]).concat(copy._addHighlightToAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._addHighlightToAbilities.length) {
            return this;
          }
          const oldValue = this._addHighlightToAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._addHighlightToAbilities = copy._addHighlightToAbilities.slice();
          copy._addHighlightToAbilities[key] = newValue;
          return copy;
        }
      }
      case "removeHighlightFromAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._removeHighlightFromAbilities = [];        for (let i of value) {
                copy._removeHighlightFromAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BehaviorModifiers(this);
              copy._removeHighlightFromAbilities = copy._removeHighlightFromAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._removeHighlightFromAbilities.length === 0) {
                return this;
              }
              const copy = new BehaviorModifiers(this);
              copy._removeHighlightFromAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._removeHighlightFromAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BehaviorModifiers(this);
              copy._removeHighlightFromAbilities = copy._removeHighlightFromAbilities.slice();
              copy._removeHighlightFromAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BehaviorModifiers(this);
              copy._removeHighlightFromAbilities = copy._removeHighlightFromAbilities.slice(0, path[1]).concat(copy._removeHighlightFromAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._removeHighlightFromAbilities.length) {
            return this;
          }
          const oldValue = this._removeHighlightFromAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BehaviorModifiers(this);
          copy._removeHighlightFromAbilities = copy._removeHighlightFromAbilities.slice();
          copy._removeHighlightFromAbilities[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorModifiers} other
   * @returns {BehaviorModifiers}
   */
  merge(other) {
    const copy = new BehaviorModifiers(this);
    if (other._hasFlags) {
      if (copy._hasFlags) {
        copy._flags = copy.flags.merge(other.flags);
      } else {
        copy._flags = other._flags;
      }
      copy._hasFlags = true;
    }
    if (other._hasMaxHealthModifier) {
      if (copy._hasMaxHealthModifier) {
        copy._maxHealthModifier = copy.maxHealthModifier.merge(other.maxHealthModifier);
      } else {
        copy._maxHealthModifier = other._maxHealthModifier;
      }
      copy._hasMaxHealthModifier = true;
    }
    if (other._hasMaxManaModifier) {
      if (copy._hasMaxManaModifier) {
        copy._maxManaModifier = copy.maxManaModifier.merge(other.maxManaModifier);
      } else {
        copy._maxManaModifier = other._maxManaModifier;
      }
      copy._hasMaxManaModifier = true;
    }
    if (other._hasMaxShieldModifier) {
      if (copy._hasMaxShieldModifier) {
        copy._maxShieldModifier = copy.maxShieldModifier.merge(other.maxShieldModifier);
      } else {
        copy._maxShieldModifier = other._maxShieldModifier;
      }
      copy._hasMaxShieldModifier = true;
    }
    if (other._hasHealthRegenerationModifier) {
      if (copy._hasHealthRegenerationModifier) {
        copy._healthRegenerationModifier = copy.healthRegenerationModifier.merge(other.healthRegenerationModifier);
      } else {
        copy._healthRegenerationModifier = other._healthRegenerationModifier;
      }
      copy._hasHealthRegenerationModifier = true;
    }
    if (other._hasManaRegenerationModifier) {
      if (copy._hasManaRegenerationModifier) {
        copy._manaRegenerationModifier = copy.manaRegenerationModifier.merge(other.manaRegenerationModifier);
      } else {
        copy._manaRegenerationModifier = other._manaRegenerationModifier;
      }
      copy._hasManaRegenerationModifier = true;
    }
    if (other._hasShieldRegenerationModifier) {
      if (copy._hasShieldRegenerationModifier) {
        copy._shieldRegenerationModifier = copy.shieldRegenerationModifier.merge(other.shieldRegenerationModifier);
      } else {
        copy._shieldRegenerationModifier = other._shieldRegenerationModifier;
      }
      copy._hasShieldRegenerationModifier = true;
    }
    if (other._hasUnitTargetPriority) {
      if (copy._hasUnitTargetPriority) {
        copy._unitTargetPriority = copy.unitTargetPriority.merge(other.unitTargetPriority);
      } else {
        copy._unitTargetPriority = other._unitTargetPriority;
      }
      copy._hasUnitTargetPriority = true;
    }
    if (other._hasUnitRadiusModifier) {
      if (copy._hasUnitRadiusModifier) {
        copy._unitRadiusModifier = copy.unitRadiusModifier.merge(other.unitRadiusModifier);
      } else {
        copy._unitRadiusModifier = other._unitRadiusModifier;
      }
      copy._hasUnitRadiusModifier = true;
    }
    if (other._hasMoveSpeedModifier) {
      if (copy._hasMoveSpeedModifier) {
        copy._moveSpeedModifier = copy.moveSpeedModifier.merge(other.moveSpeedModifier);
      } else {
        copy._moveSpeedModifier = other._moveSpeedModifier;
      }
      copy._hasMoveSpeedModifier = true;
    }
    if (other._hasAttackSpeedModifier) {
      if (copy._hasAttackSpeedModifier) {
        copy._attackSpeedModifier = copy.attackSpeedModifier.merge(other.attackSpeedModifier);
      } else {
        copy._attackSpeedModifier = other._attackSpeedModifier;
      }
      copy._hasAttackSpeedModifier = true;
    }
    if (other._hasWeaponDamageModifier) {
      if (copy._hasWeaponDamageModifier) {
        copy._weaponDamageModifier = copy.weaponDamageModifier.merge(other.weaponDamageModifier);
      } else {
        copy._weaponDamageModifier = other._weaponDamageModifier;
      }
      copy._hasWeaponDamageModifier = true;
    }
    if (other._hasAbilityDamageModifier) {
      if (copy._hasAbilityDamageModifier) {
        copy._abilityDamageModifier = copy.abilityDamageModifier.merge(other.abilityDamageModifier);
      } else {
        copy._abilityDamageModifier = other._abilityDamageModifier;
      }
      copy._hasAbilityDamageModifier = true;
    }
    if (other._hasWeaponDamageTakenModifier) {
      if (copy._hasWeaponDamageTakenModifier) {
        copy._weaponDamageTakenModifier = copy.weaponDamageTakenModifier.merge(other.weaponDamageTakenModifier);
      } else {
        copy._weaponDamageTakenModifier = other._weaponDamageTakenModifier;
      }
      copy._hasWeaponDamageTakenModifier = true;
    }
    if (other._hasAbilityDamageTakenModifier) {
      if (copy._hasAbilityDamageTakenModifier) {
        copy._abilityDamageTakenModifier = copy.abilityDamageTakenModifier.merge(other.abilityDamageTakenModifier);
      } else {
        copy._abilityDamageTakenModifier = other._abilityDamageTakenModifier;
      }
      copy._hasAbilityDamageTakenModifier = true;
    }
    if (other._hasCriticalChanceModifier) {
      if (copy._hasCriticalChanceModifier) {
        copy._criticalChanceModifier = copy.criticalChanceModifier.merge(other.criticalChanceModifier);
      } else {
        copy._criticalChanceModifier = other._criticalChanceModifier;
      }
      copy._hasCriticalChanceModifier = true;
    }
    if (other._hasAbilityCriticalChanceModifier) {
      if (copy._hasAbilityCriticalChanceModifier) {
        copy._abilityCriticalChanceModifier = copy.abilityCriticalChanceModifier.merge(other.abilityCriticalChanceModifier);
      } else {
        copy._abilityCriticalChanceModifier = other._abilityCriticalChanceModifier;
      }
      copy._hasAbilityCriticalChanceModifier = true;
    }
    if (other._hasAbilityGoldCostModifier) {
      if (copy._hasAbilityGoldCostModifier) {
        copy._abilityGoldCostModifier = copy.abilityGoldCostModifier.merge(other.abilityGoldCostModifier);
      } else {
        copy._abilityGoldCostModifier = other._abilityGoldCostModifier;
      }
      copy._hasAbilityGoldCostModifier = true;
    }
    if (other._hasAbilityManaCostModifier) {
      if (copy._hasAbilityManaCostModifier) {
        copy._abilityManaCostModifier = copy.abilityManaCostModifier.merge(other.abilityManaCostModifier);
      } else {
        copy._abilityManaCostModifier = other._abilityManaCostModifier;
      }
      copy._hasAbilityManaCostModifier = true;
    }
    if (other._hasAbilityHealthCostModifier) {
      if (copy._hasAbilityHealthCostModifier) {
        copy._abilityHealthCostModifier = copy.abilityHealthCostModifier.merge(other.abilityHealthCostModifier);
      } else {
        copy._abilityHealthCostModifier = other._abilityHealthCostModifier;
      }
      copy._hasAbilityHealthCostModifier = true;
    }
    if (other._hasHealModifier) {
      if (copy._hasHealModifier) {
        copy._healModifier = copy.healModifier.merge(other.healModifier);
      } else {
        copy._healModifier = other._healModifier;
      }
      copy._hasHealModifier = true;
    }
    if (other._hasWeaponRangeModifier) {
      if (copy._hasWeaponRangeModifier) {
        copy._weaponRangeModifier = copy.weaponRangeModifier.merge(other.weaponRangeModifier);
      } else {
        copy._weaponRangeModifier = other._weaponRangeModifier;
      }
      copy._hasWeaponRangeModifier = true;
    }
    if (other._hasWeaponScanRangeModifier) {
      if (copy._hasWeaponScanRangeModifier) {
        copy._weaponScanRangeModifier = copy.weaponScanRangeModifier.merge(other.weaponScanRangeModifier);
      } else {
        copy._weaponScanRangeModifier = other._weaponScanRangeModifier;
      }
      copy._hasWeaponScanRangeModifier = true;
    }
    if (other._hasAbilityCooldownModifier) {
      if (copy._hasAbilityCooldownModifier) {
        copy._abilityCooldownModifier = copy.abilityCooldownModifier.merge(other.abilityCooldownModifier);
      } else {
        copy._abilityCooldownModifier = other._abilityCooldownModifier;
      }
      copy._hasAbilityCooldownModifier = true;
    }
    if (other._hasChargeTimeModifier) {
      if (copy._hasChargeTimeModifier) {
        copy._chargeTimeModifier = copy.chargeTimeModifier.merge(other.chargeTimeModifier);
      } else {
        copy._chargeTimeModifier = other._chargeTimeModifier;
      }
      copy._hasChargeTimeModifier = true;
    }
    if (other._hasAbilitySpeedModifier) {
      if (copy._hasAbilitySpeedModifier) {
        copy._abilitySpeedModifier = copy.abilitySpeedModifier.merge(other.abilitySpeedModifier);
      } else {
        copy._abilitySpeedModifier = other._abilitySpeedModifier;
      }
      copy._hasAbilitySpeedModifier = true;
    }
    if (other._hasAbilityCooldownPeriodModifier) {
      if (copy._hasAbilityCooldownPeriodModifier) {
        copy._abilityCooldownPeriodModifier = copy.abilityCooldownPeriodModifier.merge(other.abilityCooldownPeriodModifier);
      } else {
        copy._abilityCooldownPeriodModifier = other._abilityCooldownPeriodModifier;
      }
      copy._hasAbilityCooldownPeriodModifier = true;
    }
    copy._disabledWeapons = this._disabledWeapons.concat(other._disabledWeapons);
    copy._enabledWeapons = this._enabledWeapons.concat(other._enabledWeapons);
    copy._disabledWeaponFamilies = this._disabledWeaponFamilies.concat(other._disabledWeaponFamilies);
    copy._enabledWeaponFamilies = this._enabledWeaponFamilies.concat(other._enabledWeaponFamilies);
    copy._weaponModifierGroup = this._weaponModifierGroup.concat(other._weaponModifierGroup);
    copy._abilityModifierGroup = this._abilityModifierGroup.concat(other._abilityModifierGroup);
    copy._disabledAbilities = this._disabledAbilities.concat(other._disabledAbilities);
    copy._enabledAbilities = this._enabledAbilities.concat(other._enabledAbilities);
    copy._hideAbilities = this._hideAbilities.concat(other._hideAbilities);
    copy._showAbilities = this._showAbilities.concat(other._showAbilities);
    copy._addHighlightToAbilities = this._addHighlightToAbilities.concat(other._addHighlightToAbilities);
    copy._removeHighlightFromAbilities = this._removeHighlightFromAbilities.concat(other._removeHighlightFromAbilities);
    return copy;
  }
}
BehaviorModifiers.default = new BehaviorModifiers();
class BehaviorModifiers_Builder {
  constructor(value) {
    this._value = new BehaviorModifiers(value);
  }
  build() {
    return new BehaviorModifiers(this._value);
  }
  setFlags(value) {
    this._value._hasFlags = true;
    this._value._flags = value;
    return this;
  }
  deleteFlags() {
    this._value._hasFlags = false;
    this._value._flags = null;
    return this;
  }
  setMaxHealthModifier(value) {
    this._value._hasMaxHealthModifier = true;
    this._value._maxHealthModifier = value;
    return this;
  }
  deleteMaxHealthModifier() {
    this._value._hasMaxHealthModifier = false;
    this._value._maxHealthModifier = null;
    return this;
  }
  setMaxManaModifier(value) {
    this._value._hasMaxManaModifier = true;
    this._value._maxManaModifier = value;
    return this;
  }
  deleteMaxManaModifier() {
    this._value._hasMaxManaModifier = false;
    this._value._maxManaModifier = null;
    return this;
  }
  setMaxShieldModifier(value) {
    this._value._hasMaxShieldModifier = true;
    this._value._maxShieldModifier = value;
    return this;
  }
  deleteMaxShieldModifier() {
    this._value._hasMaxShieldModifier = false;
    this._value._maxShieldModifier = null;
    return this;
  }
  setHealthRegenerationModifier(value) {
    this._value._hasHealthRegenerationModifier = true;
    this._value._healthRegenerationModifier = value;
    return this;
  }
  deleteHealthRegenerationModifier() {
    this._value._hasHealthRegenerationModifier = false;
    this._value._healthRegenerationModifier = null;
    return this;
  }
  setManaRegenerationModifier(value) {
    this._value._hasManaRegenerationModifier = true;
    this._value._manaRegenerationModifier = value;
    return this;
  }
  deleteManaRegenerationModifier() {
    this._value._hasManaRegenerationModifier = false;
    this._value._manaRegenerationModifier = null;
    return this;
  }
  setShieldRegenerationModifier(value) {
    this._value._hasShieldRegenerationModifier = true;
    this._value._shieldRegenerationModifier = value;
    return this;
  }
  deleteShieldRegenerationModifier() {
    this._value._hasShieldRegenerationModifier = false;
    this._value._shieldRegenerationModifier = null;
    return this;
  }
  setUnitTargetPriority(value) {
    this._value._hasUnitTargetPriority = true;
    this._value._unitTargetPriority = value;
    return this;
  }
  deleteUnitTargetPriority() {
    this._value._hasUnitTargetPriority = false;
    this._value._unitTargetPriority = null;
    return this;
  }
  setUnitRadiusModifier(value) {
    this._value._hasUnitRadiusModifier = true;
    this._value._unitRadiusModifier = value;
    return this;
  }
  deleteUnitRadiusModifier() {
    this._value._hasUnitRadiusModifier = false;
    this._value._unitRadiusModifier = null;
    return this;
  }
  setMoveSpeedModifier(value) {
    this._value._hasMoveSpeedModifier = true;
    this._value._moveSpeedModifier = value;
    return this;
  }
  deleteMoveSpeedModifier() {
    this._value._hasMoveSpeedModifier = false;
    this._value._moveSpeedModifier = null;
    return this;
  }
  setAttackSpeedModifier(value) {
    this._value._hasAttackSpeedModifier = true;
    this._value._attackSpeedModifier = value;
    return this;
  }
  deleteAttackSpeedModifier() {
    this._value._hasAttackSpeedModifier = false;
    this._value._attackSpeedModifier = null;
    return this;
  }
  setWeaponDamageModifier(value) {
    this._value._hasWeaponDamageModifier = true;
    this._value._weaponDamageModifier = value;
    return this;
  }
  deleteWeaponDamageModifier() {
    this._value._hasWeaponDamageModifier = false;
    this._value._weaponDamageModifier = null;
    return this;
  }
  setAbilityDamageModifier(value) {
    this._value._hasAbilityDamageModifier = true;
    this._value._abilityDamageModifier = value;
    return this;
  }
  deleteAbilityDamageModifier() {
    this._value._hasAbilityDamageModifier = false;
    this._value._abilityDamageModifier = null;
    return this;
  }
  setWeaponDamageTakenModifier(value) {
    this._value._hasWeaponDamageTakenModifier = true;
    this._value._weaponDamageTakenModifier = value;
    return this;
  }
  deleteWeaponDamageTakenModifier() {
    this._value._hasWeaponDamageTakenModifier = false;
    this._value._weaponDamageTakenModifier = null;
    return this;
  }
  setAbilityDamageTakenModifier(value) {
    this._value._hasAbilityDamageTakenModifier = true;
    this._value._abilityDamageTakenModifier = value;
    return this;
  }
  deleteAbilityDamageTakenModifier() {
    this._value._hasAbilityDamageTakenModifier = false;
    this._value._abilityDamageTakenModifier = null;
    return this;
  }
  setCriticalChanceModifier(value) {
    this._value._hasCriticalChanceModifier = true;
    this._value._criticalChanceModifier = value;
    return this;
  }
  deleteCriticalChanceModifier() {
    this._value._hasCriticalChanceModifier = false;
    this._value._criticalChanceModifier = null;
    return this;
  }
  setAbilityCriticalChanceModifier(value) {
    this._value._hasAbilityCriticalChanceModifier = true;
    this._value._abilityCriticalChanceModifier = value;
    return this;
  }
  deleteAbilityCriticalChanceModifier() {
    this._value._hasAbilityCriticalChanceModifier = false;
    this._value._abilityCriticalChanceModifier = null;
    return this;
  }
  setAbilityGoldCostModifier(value) {
    this._value._hasAbilityGoldCostModifier = true;
    this._value._abilityGoldCostModifier = value;
    return this;
  }
  deleteAbilityGoldCostModifier() {
    this._value._hasAbilityGoldCostModifier = false;
    this._value._abilityGoldCostModifier = null;
    return this;
  }
  setAbilityManaCostModifier(value) {
    this._value._hasAbilityManaCostModifier = true;
    this._value._abilityManaCostModifier = value;
    return this;
  }
  deleteAbilityManaCostModifier() {
    this._value._hasAbilityManaCostModifier = false;
    this._value._abilityManaCostModifier = null;
    return this;
  }
  setAbilityHealthCostModifier(value) {
    this._value._hasAbilityHealthCostModifier = true;
    this._value._abilityHealthCostModifier = value;
    return this;
  }
  deleteAbilityHealthCostModifier() {
    this._value._hasAbilityHealthCostModifier = false;
    this._value._abilityHealthCostModifier = null;
    return this;
  }
  setHealModifier(value) {
    this._value._hasHealModifier = true;
    this._value._healModifier = value;
    return this;
  }
  deleteHealModifier() {
    this._value._hasHealModifier = false;
    this._value._healModifier = null;
    return this;
  }
  setWeaponRangeModifier(value) {
    this._value._hasWeaponRangeModifier = true;
    this._value._weaponRangeModifier = value;
    return this;
  }
  deleteWeaponRangeModifier() {
    this._value._hasWeaponRangeModifier = false;
    this._value._weaponRangeModifier = null;
    return this;
  }
  setWeaponScanRangeModifier(value) {
    this._value._hasWeaponScanRangeModifier = true;
    this._value._weaponScanRangeModifier = value;
    return this;
  }
  deleteWeaponScanRangeModifier() {
    this._value._hasWeaponScanRangeModifier = false;
    this._value._weaponScanRangeModifier = null;
    return this;
  }
  setAbilityCooldownModifier(value) {
    this._value._hasAbilityCooldownModifier = true;
    this._value._abilityCooldownModifier = value;
    return this;
  }
  deleteAbilityCooldownModifier() {
    this._value._hasAbilityCooldownModifier = false;
    this._value._abilityCooldownModifier = null;
    return this;
  }
  setChargeTimeModifier(value) {
    this._value._hasChargeTimeModifier = true;
    this._value._chargeTimeModifier = value;
    return this;
  }
  deleteChargeTimeModifier() {
    this._value._hasChargeTimeModifier = false;
    this._value._chargeTimeModifier = null;
    return this;
  }
  setAbilitySpeedModifier(value) {
    this._value._hasAbilitySpeedModifier = true;
    this._value._abilitySpeedModifier = value;
    return this;
  }
  deleteAbilitySpeedModifier() {
    this._value._hasAbilitySpeedModifier = false;
    this._value._abilitySpeedModifier = null;
    return this;
  }
  setAbilityCooldownPeriodModifier(value) {
    this._value._hasAbilityCooldownPeriodModifier = true;
    this._value._abilityCooldownPeriodModifier = value;
    return this;
  }
  deleteAbilityCooldownPeriodModifier() {
    this._value._hasAbilityCooldownPeriodModifier = false;
    this._value._abilityCooldownPeriodModifier = null;
    return this;
  }
  addAllDisabledWeapons(values) {
    this._value._disabledWeapons = this._value._disabledWeapons.concat(values);
    return this;
  }
  addDisabledWeapons(value) {
    this._value._disabledWeapons = this._value._disabledWeapons.concat([value]);
    return this;
  }
  setDisabledWeapons(index, value) {
    this._value._disabledWeapons = this._value._disabledWeapons.concat();
    this._value._disabledWeapons[index] = value;
    return this;
  }
  clearDisabledWeapons() {
    this._value._disabledWeapons = [];
    return this;
  }
  addAllEnabledWeapons(values) {
    this._value._enabledWeapons = this._value._enabledWeapons.concat(values);
    return this;
  }
  addEnabledWeapons(value) {
    this._value._enabledWeapons = this._value._enabledWeapons.concat([value]);
    return this;
  }
  setEnabledWeapons(index, value) {
    this._value._enabledWeapons = this._value._enabledWeapons.concat();
    this._value._enabledWeapons[index] = value;
    return this;
  }
  clearEnabledWeapons() {
    this._value._enabledWeapons = [];
    return this;
  }
  addAllDisabledWeaponFamilies(values) {
    this._value._disabledWeaponFamilies = this._value._disabledWeaponFamilies.concat(values);
    return this;
  }
  addDisabledWeaponFamilies(value) {
    this._value._disabledWeaponFamilies = this._value._disabledWeaponFamilies.concat([value]);
    return this;
  }
  setDisabledWeaponFamilies(index, value) {
    this._value._disabledWeaponFamilies = this._value._disabledWeaponFamilies.concat();
    this._value._disabledWeaponFamilies[index] = value;
    return this;
  }
  clearDisabledWeaponFamilies() {
    this._value._disabledWeaponFamilies = [];
    return this;
  }
  addAllEnabledWeaponFamilies(values) {
    this._value._enabledWeaponFamilies = this._value._enabledWeaponFamilies.concat(values);
    return this;
  }
  addEnabledWeaponFamilies(value) {
    this._value._enabledWeaponFamilies = this._value._enabledWeaponFamilies.concat([value]);
    return this;
  }
  setEnabledWeaponFamilies(index, value) {
    this._value._enabledWeaponFamilies = this._value._enabledWeaponFamilies.concat();
    this._value._enabledWeaponFamilies[index] = value;
    return this;
  }
  clearEnabledWeaponFamilies() {
    this._value._enabledWeaponFamilies = [];
    return this;
  }
  addAllWeaponModifierGroup(values) {
    this._value._weaponModifierGroup = this._value._weaponModifierGroup.concat(values);
    return this;
  }
  addWeaponModifierGroup(value) {
    this._value._weaponModifierGroup = this._value._weaponModifierGroup.concat([value]);
    return this;
  }
  setWeaponModifierGroup(index, value) {
    this._value._weaponModifierGroup = this._value._weaponModifierGroup.concat();
    this._value._weaponModifierGroup[index] = value;
    return this;
  }
  clearWeaponModifierGroup() {
    this._value._weaponModifierGroup = [];
    return this;
  }
  addAllAbilityModifierGroup(values) {
    this._value._abilityModifierGroup = this._value._abilityModifierGroup.concat(values);
    return this;
  }
  addAbilityModifierGroup(value) {
    this._value._abilityModifierGroup = this._value._abilityModifierGroup.concat([value]);
    return this;
  }
  setAbilityModifierGroup(index, value) {
    this._value._abilityModifierGroup = this._value._abilityModifierGroup.concat();
    this._value._abilityModifierGroup[index] = value;
    return this;
  }
  clearAbilityModifierGroup() {
    this._value._abilityModifierGroup = [];
    return this;
  }
  addAllDisabledAbilities(values) {
    this._value._disabledAbilities = this._value._disabledAbilities.concat(values);
    return this;
  }
  addDisabledAbilities(value) {
    this._value._disabledAbilities = this._value._disabledAbilities.concat([value]);
    return this;
  }
  setDisabledAbilities(index, value) {
    this._value._disabledAbilities = this._value._disabledAbilities.concat();
    this._value._disabledAbilities[index] = value;
    return this;
  }
  clearDisabledAbilities() {
    this._value._disabledAbilities = [];
    return this;
  }
  addAllEnabledAbilities(values) {
    this._value._enabledAbilities = this._value._enabledAbilities.concat(values);
    return this;
  }
  addEnabledAbilities(value) {
    this._value._enabledAbilities = this._value._enabledAbilities.concat([value]);
    return this;
  }
  setEnabledAbilities(index, value) {
    this._value._enabledAbilities = this._value._enabledAbilities.concat();
    this._value._enabledAbilities[index] = value;
    return this;
  }
  clearEnabledAbilities() {
    this._value._enabledAbilities = [];
    return this;
  }
  addAllHideAbilities(values) {
    this._value._hideAbilities = this._value._hideAbilities.concat(values);
    return this;
  }
  addHideAbilities(value) {
    this._value._hideAbilities = this._value._hideAbilities.concat([value]);
    return this;
  }
  setHideAbilities(index, value) {
    this._value._hideAbilities = this._value._hideAbilities.concat();
    this._value._hideAbilities[index] = value;
    return this;
  }
  clearHideAbilities() {
    this._value._hideAbilities = [];
    return this;
  }
  addAllShowAbilities(values) {
    this._value._showAbilities = this._value._showAbilities.concat(values);
    return this;
  }
  addShowAbilities(value) {
    this._value._showAbilities = this._value._showAbilities.concat([value]);
    return this;
  }
  setShowAbilities(index, value) {
    this._value._showAbilities = this._value._showAbilities.concat();
    this._value._showAbilities[index] = value;
    return this;
  }
  clearShowAbilities() {
    this._value._showAbilities = [];
    return this;
  }
  addAllAddHighlightToAbilities(values) {
    this._value._addHighlightToAbilities = this._value._addHighlightToAbilities.concat(values);
    return this;
  }
  addAddHighlightToAbilities(value) {
    this._value._addHighlightToAbilities = this._value._addHighlightToAbilities.concat([value]);
    return this;
  }
  setAddHighlightToAbilities(index, value) {
    this._value._addHighlightToAbilities = this._value._addHighlightToAbilities.concat();
    this._value._addHighlightToAbilities[index] = value;
    return this;
  }
  clearAddHighlightToAbilities() {
    this._value._addHighlightToAbilities = [];
    return this;
  }
  addAllRemoveHighlightFromAbilities(values) {
    this._value._removeHighlightFromAbilities = this._value._removeHighlightFromAbilities.concat(values);
    return this;
  }
  addRemoveHighlightFromAbilities(value) {
    this._value._removeHighlightFromAbilities = this._value._removeHighlightFromAbilities.concat([value]);
    return this;
  }
  setRemoveHighlightFromAbilities(index, value) {
    this._value._removeHighlightFromAbilities = this._value._removeHighlightFromAbilities.concat();
    this._value._removeHighlightFromAbilities[index] = value;
    return this;
  }
  clearRemoveHighlightFromAbilities() {
    this._value._removeHighlightFromAbilities = [];
    return this;
  }
}
BehaviorModifiers.Builder = BehaviorModifiers_Builder;
class BehaviorModifiers_WithParent {
  /**
   * @param {BehaviorModifiers} value
   * @param {BehaviorModifiers_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorModifiers.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFlags() {
    if (this._cachedHasFlags === undefined) {
      if (this._value.hasFlags) {
        this._cachedHasFlags = true;
      } else {
        this._cachedHasFlags = this._parent ? this._parent.hasFlags : false;
      }
    }
    return this._cachedHasFlags;
  }
  get flags() {
    if (!this._cachedFlags) {
      if (this._value.hasFlags) {
        this._cachedFlags = new BehaviorFlags.WithParent(this._value.flags, this._parent && this._parent.hasFlags ? this._parent.flags : null);
      } else {
        this._cachedFlags = this._parent ? new BehaviorFlags.WithParent(BehaviorFlags.default, this._parent.flags) : BehaviorFlags.WithParent.default;
      }
    }
    return this._cachedFlags;
  }
  get hasMaxHealthModifier() {
    if (this._cachedHasMaxHealthModifier === undefined) {
      if (this._value.hasMaxHealthModifier) {
        this._cachedHasMaxHealthModifier = true;
      } else {
        this._cachedHasMaxHealthModifier = this._parent ? this._parent.hasMaxHealthModifier : false;
      }
    }
    return this._cachedHasMaxHealthModifier;
  }
  get maxHealthModifier() {
    if (!this._cachedMaxHealthModifier) {
      if (this._value.hasMaxHealthModifier) {
        this._cachedMaxHealthModifier = new BehaviorModifier.WithParent(this._value.maxHealthModifier, this._parent && this._parent.hasMaxHealthModifier ? this._parent.maxHealthModifier : null);
      } else {
        this._cachedMaxHealthModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.maxHealthModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedMaxHealthModifier;
  }
  get hasMaxManaModifier() {
    if (this._cachedHasMaxManaModifier === undefined) {
      if (this._value.hasMaxManaModifier) {
        this._cachedHasMaxManaModifier = true;
      } else {
        this._cachedHasMaxManaModifier = this._parent ? this._parent.hasMaxManaModifier : false;
      }
    }
    return this._cachedHasMaxManaModifier;
  }
  get maxManaModifier() {
    if (!this._cachedMaxManaModifier) {
      if (this._value.hasMaxManaModifier) {
        this._cachedMaxManaModifier = new BehaviorModifier.WithParent(this._value.maxManaModifier, this._parent && this._parent.hasMaxManaModifier ? this._parent.maxManaModifier : null);
      } else {
        this._cachedMaxManaModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.maxManaModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedMaxManaModifier;
  }
  get hasMaxShieldModifier() {
    if (this._cachedHasMaxShieldModifier === undefined) {
      if (this._value.hasMaxShieldModifier) {
        this._cachedHasMaxShieldModifier = true;
      } else {
        this._cachedHasMaxShieldModifier = this._parent ? this._parent.hasMaxShieldModifier : false;
      }
    }
    return this._cachedHasMaxShieldModifier;
  }
  get maxShieldModifier() {
    if (!this._cachedMaxShieldModifier) {
      if (this._value.hasMaxShieldModifier) {
        this._cachedMaxShieldModifier = new BehaviorModifier.WithParent(this._value.maxShieldModifier, this._parent && this._parent.hasMaxShieldModifier ? this._parent.maxShieldModifier : null);
      } else {
        this._cachedMaxShieldModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.maxShieldModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedMaxShieldModifier;
  }
  get hasHealthRegenerationModifier() {
    if (this._cachedHasHealthRegenerationModifier === undefined) {
      if (this._value.hasHealthRegenerationModifier) {
        this._cachedHasHealthRegenerationModifier = true;
      } else {
        this._cachedHasHealthRegenerationModifier = this._parent ? this._parent.hasHealthRegenerationModifier : false;
      }
    }
    return this._cachedHasHealthRegenerationModifier;
  }
  get healthRegenerationModifier() {
    if (!this._cachedHealthRegenerationModifier) {
      if (this._value.hasHealthRegenerationModifier) {
        this._cachedHealthRegenerationModifier = new BehaviorModifier.WithParent(this._value.healthRegenerationModifier, this._parent && this._parent.hasHealthRegenerationModifier ? this._parent.healthRegenerationModifier : null);
      } else {
        this._cachedHealthRegenerationModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.healthRegenerationModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedHealthRegenerationModifier;
  }
  get hasManaRegenerationModifier() {
    if (this._cachedHasManaRegenerationModifier === undefined) {
      if (this._value.hasManaRegenerationModifier) {
        this._cachedHasManaRegenerationModifier = true;
      } else {
        this._cachedHasManaRegenerationModifier = this._parent ? this._parent.hasManaRegenerationModifier : false;
      }
    }
    return this._cachedHasManaRegenerationModifier;
  }
  get manaRegenerationModifier() {
    if (!this._cachedManaRegenerationModifier) {
      if (this._value.hasManaRegenerationModifier) {
        this._cachedManaRegenerationModifier = new BehaviorModifier.WithParent(this._value.manaRegenerationModifier, this._parent && this._parent.hasManaRegenerationModifier ? this._parent.manaRegenerationModifier : null);
      } else {
        this._cachedManaRegenerationModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.manaRegenerationModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedManaRegenerationModifier;
  }
  get hasShieldRegenerationModifier() {
    if (this._cachedHasShieldRegenerationModifier === undefined) {
      if (this._value.hasShieldRegenerationModifier) {
        this._cachedHasShieldRegenerationModifier = true;
      } else {
        this._cachedHasShieldRegenerationModifier = this._parent ? this._parent.hasShieldRegenerationModifier : false;
      }
    }
    return this._cachedHasShieldRegenerationModifier;
  }
  get shieldRegenerationModifier() {
    if (!this._cachedShieldRegenerationModifier) {
      if (this._value.hasShieldRegenerationModifier) {
        this._cachedShieldRegenerationModifier = new BehaviorModifier.WithParent(this._value.shieldRegenerationModifier, this._parent && this._parent.hasShieldRegenerationModifier ? this._parent.shieldRegenerationModifier : null);
      } else {
        this._cachedShieldRegenerationModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.shieldRegenerationModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedShieldRegenerationModifier;
  }
  get hasUnitTargetPriority() {
    if (this._cachedHasUnitTargetPriority === undefined) {
      if (this._value.hasUnitTargetPriority) {
        this._cachedHasUnitTargetPriority = true;
      } else {
        this._cachedHasUnitTargetPriority = this._parent ? this._parent.hasUnitTargetPriority : false;
      }
    }
    return this._cachedHasUnitTargetPriority;
  }
  get unitTargetPriority() {
    if (!this._cachedUnitTargetPriority) {
      if (this._value.hasUnitTargetPriority) {
        this._cachedUnitTargetPriority = new BehaviorModifier.WithParent(this._value.unitTargetPriority, this._parent && this._parent.hasUnitTargetPriority ? this._parent.unitTargetPriority : null);
      } else {
        this._cachedUnitTargetPriority = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.unitTargetPriority) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedUnitTargetPriority;
  }
  get hasUnitRadiusModifier() {
    if (this._cachedHasUnitRadiusModifier === undefined) {
      if (this._value.hasUnitRadiusModifier) {
        this._cachedHasUnitRadiusModifier = true;
      } else {
        this._cachedHasUnitRadiusModifier = this._parent ? this._parent.hasUnitRadiusModifier : false;
      }
    }
    return this._cachedHasUnitRadiusModifier;
  }
  get unitRadiusModifier() {
    if (!this._cachedUnitRadiusModifier) {
      if (this._value.hasUnitRadiusModifier) {
        this._cachedUnitRadiusModifier = new BehaviorModifier.WithParent(this._value.unitRadiusModifier, this._parent && this._parent.hasUnitRadiusModifier ? this._parent.unitRadiusModifier : null);
      } else {
        this._cachedUnitRadiusModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.unitRadiusModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedUnitRadiusModifier;
  }
  get hasMoveSpeedModifier() {
    if (this._cachedHasMoveSpeedModifier === undefined) {
      if (this._value.hasMoveSpeedModifier) {
        this._cachedHasMoveSpeedModifier = true;
      } else {
        this._cachedHasMoveSpeedModifier = this._parent ? this._parent.hasMoveSpeedModifier : false;
      }
    }
    return this._cachedHasMoveSpeedModifier;
  }
  get moveSpeedModifier() {
    if (!this._cachedMoveSpeedModifier) {
      if (this._value.hasMoveSpeedModifier) {
        this._cachedMoveSpeedModifier = new BehaviorModifier.WithParent(this._value.moveSpeedModifier, this._parent && this._parent.hasMoveSpeedModifier ? this._parent.moveSpeedModifier : null);
      } else {
        this._cachedMoveSpeedModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.moveSpeedModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedMoveSpeedModifier;
  }
  get hasAttackSpeedModifier() {
    if (this._cachedHasAttackSpeedModifier === undefined) {
      if (this._value.hasAttackSpeedModifier) {
        this._cachedHasAttackSpeedModifier = true;
      } else {
        this._cachedHasAttackSpeedModifier = this._parent ? this._parent.hasAttackSpeedModifier : false;
      }
    }
    return this._cachedHasAttackSpeedModifier;
  }
  get attackSpeedModifier() {
    if (!this._cachedAttackSpeedModifier) {
      if (this._value.hasAttackSpeedModifier) {
        this._cachedAttackSpeedModifier = new BehaviorModifier.WithParent(this._value.attackSpeedModifier, this._parent && this._parent.hasAttackSpeedModifier ? this._parent.attackSpeedModifier : null);
      } else {
        this._cachedAttackSpeedModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.attackSpeedModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAttackSpeedModifier;
  }
  get hasWeaponDamageModifier() {
    if (this._cachedHasWeaponDamageModifier === undefined) {
      if (this._value.hasWeaponDamageModifier) {
        this._cachedHasWeaponDamageModifier = true;
      } else {
        this._cachedHasWeaponDamageModifier = this._parent ? this._parent.hasWeaponDamageModifier : false;
      }
    }
    return this._cachedHasWeaponDamageModifier;
  }
  get weaponDamageModifier() {
    if (!this._cachedWeaponDamageModifier) {
      if (this._value.hasWeaponDamageModifier) {
        this._cachedWeaponDamageModifier = new BehaviorModifier.WithParent(this._value.weaponDamageModifier, this._parent && this._parent.hasWeaponDamageModifier ? this._parent.weaponDamageModifier : null);
      } else {
        this._cachedWeaponDamageModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.weaponDamageModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedWeaponDamageModifier;
  }
  get hasAbilityDamageModifier() {
    if (this._cachedHasAbilityDamageModifier === undefined) {
      if (this._value.hasAbilityDamageModifier) {
        this._cachedHasAbilityDamageModifier = true;
      } else {
        this._cachedHasAbilityDamageModifier = this._parent ? this._parent.hasAbilityDamageModifier : false;
      }
    }
    return this._cachedHasAbilityDamageModifier;
  }
  get abilityDamageModifier() {
    if (!this._cachedAbilityDamageModifier) {
      if (this._value.hasAbilityDamageModifier) {
        this._cachedAbilityDamageModifier = new BehaviorModifier.WithParent(this._value.abilityDamageModifier, this._parent && this._parent.hasAbilityDamageModifier ? this._parent.abilityDamageModifier : null);
      } else {
        this._cachedAbilityDamageModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityDamageModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityDamageModifier;
  }
  get hasWeaponDamageTakenModifier() {
    if (this._cachedHasWeaponDamageTakenModifier === undefined) {
      if (this._value.hasWeaponDamageTakenModifier) {
        this._cachedHasWeaponDamageTakenModifier = true;
      } else {
        this._cachedHasWeaponDamageTakenModifier = this._parent ? this._parent.hasWeaponDamageTakenModifier : false;
      }
    }
    return this._cachedHasWeaponDamageTakenModifier;
  }
  get weaponDamageTakenModifier() {
    if (!this._cachedWeaponDamageTakenModifier) {
      if (this._value.hasWeaponDamageTakenModifier) {
        this._cachedWeaponDamageTakenModifier = new BehaviorModifier.WithParent(this._value.weaponDamageTakenModifier, this._parent && this._parent.hasWeaponDamageTakenModifier ? this._parent.weaponDamageTakenModifier : null);
      } else {
        this._cachedWeaponDamageTakenModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.weaponDamageTakenModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedWeaponDamageTakenModifier;
  }
  get hasAbilityDamageTakenModifier() {
    if (this._cachedHasAbilityDamageTakenModifier === undefined) {
      if (this._value.hasAbilityDamageTakenModifier) {
        this._cachedHasAbilityDamageTakenModifier = true;
      } else {
        this._cachedHasAbilityDamageTakenModifier = this._parent ? this._parent.hasAbilityDamageTakenModifier : false;
      }
    }
    return this._cachedHasAbilityDamageTakenModifier;
  }
  get abilityDamageTakenModifier() {
    if (!this._cachedAbilityDamageTakenModifier) {
      if (this._value.hasAbilityDamageTakenModifier) {
        this._cachedAbilityDamageTakenModifier = new BehaviorModifier.WithParent(this._value.abilityDamageTakenModifier, this._parent && this._parent.hasAbilityDamageTakenModifier ? this._parent.abilityDamageTakenModifier : null);
      } else {
        this._cachedAbilityDamageTakenModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityDamageTakenModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityDamageTakenModifier;
  }
  get hasCriticalChanceModifier() {
    if (this._cachedHasCriticalChanceModifier === undefined) {
      if (this._value.hasCriticalChanceModifier) {
        this._cachedHasCriticalChanceModifier = true;
      } else {
        this._cachedHasCriticalChanceModifier = this._parent ? this._parent.hasCriticalChanceModifier : false;
      }
    }
    return this._cachedHasCriticalChanceModifier;
  }
  get criticalChanceModifier() {
    if (!this._cachedCriticalChanceModifier) {
      if (this._value.hasCriticalChanceModifier) {
        this._cachedCriticalChanceModifier = new BehaviorModifier.WithParent(this._value.criticalChanceModifier, this._parent && this._parent.hasCriticalChanceModifier ? this._parent.criticalChanceModifier : null);
      } else {
        this._cachedCriticalChanceModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.criticalChanceModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedCriticalChanceModifier;
  }
  get hasAbilityCriticalChanceModifier() {
    if (this._cachedHasAbilityCriticalChanceModifier === undefined) {
      if (this._value.hasAbilityCriticalChanceModifier) {
        this._cachedHasAbilityCriticalChanceModifier = true;
      } else {
        this._cachedHasAbilityCriticalChanceModifier = this._parent ? this._parent.hasAbilityCriticalChanceModifier : false;
      }
    }
    return this._cachedHasAbilityCriticalChanceModifier;
  }
  get abilityCriticalChanceModifier() {
    if (!this._cachedAbilityCriticalChanceModifier) {
      if (this._value.hasAbilityCriticalChanceModifier) {
        this._cachedAbilityCriticalChanceModifier = new BehaviorModifier.WithParent(this._value.abilityCriticalChanceModifier, this._parent && this._parent.hasAbilityCriticalChanceModifier ? this._parent.abilityCriticalChanceModifier : null);
      } else {
        this._cachedAbilityCriticalChanceModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityCriticalChanceModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityCriticalChanceModifier;
  }
  get hasAbilityGoldCostModifier() {
    if (this._cachedHasAbilityGoldCostModifier === undefined) {
      if (this._value.hasAbilityGoldCostModifier) {
        this._cachedHasAbilityGoldCostModifier = true;
      } else {
        this._cachedHasAbilityGoldCostModifier = this._parent ? this._parent.hasAbilityGoldCostModifier : false;
      }
    }
    return this._cachedHasAbilityGoldCostModifier;
  }
  get abilityGoldCostModifier() {
    if (!this._cachedAbilityGoldCostModifier) {
      if (this._value.hasAbilityGoldCostModifier) {
        this._cachedAbilityGoldCostModifier = new BehaviorModifier.WithParent(this._value.abilityGoldCostModifier, this._parent && this._parent.hasAbilityGoldCostModifier ? this._parent.abilityGoldCostModifier : null);
      } else {
        this._cachedAbilityGoldCostModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityGoldCostModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityGoldCostModifier;
  }
  get hasAbilityManaCostModifier() {
    if (this._cachedHasAbilityManaCostModifier === undefined) {
      if (this._value.hasAbilityManaCostModifier) {
        this._cachedHasAbilityManaCostModifier = true;
      } else {
        this._cachedHasAbilityManaCostModifier = this._parent ? this._parent.hasAbilityManaCostModifier : false;
      }
    }
    return this._cachedHasAbilityManaCostModifier;
  }
  get abilityManaCostModifier() {
    if (!this._cachedAbilityManaCostModifier) {
      if (this._value.hasAbilityManaCostModifier) {
        this._cachedAbilityManaCostModifier = new BehaviorModifier.WithParent(this._value.abilityManaCostModifier, this._parent && this._parent.hasAbilityManaCostModifier ? this._parent.abilityManaCostModifier : null);
      } else {
        this._cachedAbilityManaCostModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityManaCostModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityManaCostModifier;
  }
  get hasAbilityHealthCostModifier() {
    if (this._cachedHasAbilityHealthCostModifier === undefined) {
      if (this._value.hasAbilityHealthCostModifier) {
        this._cachedHasAbilityHealthCostModifier = true;
      } else {
        this._cachedHasAbilityHealthCostModifier = this._parent ? this._parent.hasAbilityHealthCostModifier : false;
      }
    }
    return this._cachedHasAbilityHealthCostModifier;
  }
  get abilityHealthCostModifier() {
    if (!this._cachedAbilityHealthCostModifier) {
      if (this._value.hasAbilityHealthCostModifier) {
        this._cachedAbilityHealthCostModifier = new BehaviorModifier.WithParent(this._value.abilityHealthCostModifier, this._parent && this._parent.hasAbilityHealthCostModifier ? this._parent.abilityHealthCostModifier : null);
      } else {
        this._cachedAbilityHealthCostModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityHealthCostModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityHealthCostModifier;
  }
  get hasHealModifier() {
    if (this._cachedHasHealModifier === undefined) {
      if (this._value.hasHealModifier) {
        this._cachedHasHealModifier = true;
      } else {
        this._cachedHasHealModifier = this._parent ? this._parent.hasHealModifier : false;
      }
    }
    return this._cachedHasHealModifier;
  }
  get healModifier() {
    if (!this._cachedHealModifier) {
      if (this._value.hasHealModifier) {
        this._cachedHealModifier = new BehaviorModifier.WithParent(this._value.healModifier, this._parent && this._parent.hasHealModifier ? this._parent.healModifier : null);
      } else {
        this._cachedHealModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.healModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedHealModifier;
  }
  get hasWeaponRangeModifier() {
    if (this._cachedHasWeaponRangeModifier === undefined) {
      if (this._value.hasWeaponRangeModifier) {
        this._cachedHasWeaponRangeModifier = true;
      } else {
        this._cachedHasWeaponRangeModifier = this._parent ? this._parent.hasWeaponRangeModifier : false;
      }
    }
    return this._cachedHasWeaponRangeModifier;
  }
  get weaponRangeModifier() {
    if (!this._cachedWeaponRangeModifier) {
      if (this._value.hasWeaponRangeModifier) {
        this._cachedWeaponRangeModifier = new BehaviorModifier.WithParent(this._value.weaponRangeModifier, this._parent && this._parent.hasWeaponRangeModifier ? this._parent.weaponRangeModifier : null);
      } else {
        this._cachedWeaponRangeModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.weaponRangeModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedWeaponRangeModifier;
  }
  get hasWeaponScanRangeModifier() {
    if (this._cachedHasWeaponScanRangeModifier === undefined) {
      if (this._value.hasWeaponScanRangeModifier) {
        this._cachedHasWeaponScanRangeModifier = true;
      } else {
        this._cachedHasWeaponScanRangeModifier = this._parent ? this._parent.hasWeaponScanRangeModifier : false;
      }
    }
    return this._cachedHasWeaponScanRangeModifier;
  }
  get weaponScanRangeModifier() {
    if (!this._cachedWeaponScanRangeModifier) {
      if (this._value.hasWeaponScanRangeModifier) {
        this._cachedWeaponScanRangeModifier = new BehaviorModifier.WithParent(this._value.weaponScanRangeModifier, this._parent && this._parent.hasWeaponScanRangeModifier ? this._parent.weaponScanRangeModifier : null);
      } else {
        this._cachedWeaponScanRangeModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.weaponScanRangeModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedWeaponScanRangeModifier;
  }
  get hasAbilityCooldownModifier() {
    if (this._cachedHasAbilityCooldownModifier === undefined) {
      if (this._value.hasAbilityCooldownModifier) {
        this._cachedHasAbilityCooldownModifier = true;
      } else {
        this._cachedHasAbilityCooldownModifier = this._parent ? this._parent.hasAbilityCooldownModifier : false;
      }
    }
    return this._cachedHasAbilityCooldownModifier;
  }
  get abilityCooldownModifier() {
    if (!this._cachedAbilityCooldownModifier) {
      if (this._value.hasAbilityCooldownModifier) {
        this._cachedAbilityCooldownModifier = new BehaviorModifier.WithParent(this._value.abilityCooldownModifier, this._parent && this._parent.hasAbilityCooldownModifier ? this._parent.abilityCooldownModifier : null);
      } else {
        this._cachedAbilityCooldownModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityCooldownModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityCooldownModifier;
  }
  get hasChargeTimeModifier() {
    if (this._cachedHasChargeTimeModifier === undefined) {
      if (this._value.hasChargeTimeModifier) {
        this._cachedHasChargeTimeModifier = true;
      } else {
        this._cachedHasChargeTimeModifier = this._parent ? this._parent.hasChargeTimeModifier : false;
      }
    }
    return this._cachedHasChargeTimeModifier;
  }
  get chargeTimeModifier() {
    if (!this._cachedChargeTimeModifier) {
      if (this._value.hasChargeTimeModifier) {
        this._cachedChargeTimeModifier = new BehaviorModifier.WithParent(this._value.chargeTimeModifier, this._parent && this._parent.hasChargeTimeModifier ? this._parent.chargeTimeModifier : null);
      } else {
        this._cachedChargeTimeModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.chargeTimeModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedChargeTimeModifier;
  }
  get hasAbilitySpeedModifier() {
    if (this._cachedHasAbilitySpeedModifier === undefined) {
      if (this._value.hasAbilitySpeedModifier) {
        this._cachedHasAbilitySpeedModifier = true;
      } else {
        this._cachedHasAbilitySpeedModifier = this._parent ? this._parent.hasAbilitySpeedModifier : false;
      }
    }
    return this._cachedHasAbilitySpeedModifier;
  }
  get abilitySpeedModifier() {
    if (!this._cachedAbilitySpeedModifier) {
      if (this._value.hasAbilitySpeedModifier) {
        this._cachedAbilitySpeedModifier = new BehaviorModifier.WithParent(this._value.abilitySpeedModifier, this._parent && this._parent.hasAbilitySpeedModifier ? this._parent.abilitySpeedModifier : null);
      } else {
        this._cachedAbilitySpeedModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilitySpeedModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilitySpeedModifier;
  }
  get hasAbilityCooldownPeriodModifier() {
    if (this._cachedHasAbilityCooldownPeriodModifier === undefined) {
      if (this._value.hasAbilityCooldownPeriodModifier) {
        this._cachedHasAbilityCooldownPeriodModifier = true;
      } else {
        this._cachedHasAbilityCooldownPeriodModifier = this._parent ? this._parent.hasAbilityCooldownPeriodModifier : false;
      }
    }
    return this._cachedHasAbilityCooldownPeriodModifier;
  }
  get abilityCooldownPeriodModifier() {
    if (!this._cachedAbilityCooldownPeriodModifier) {
      if (this._value.hasAbilityCooldownPeriodModifier) {
        this._cachedAbilityCooldownPeriodModifier = new BehaviorModifier.WithParent(this._value.abilityCooldownPeriodModifier, this._parent && this._parent.hasAbilityCooldownPeriodModifier ? this._parent.abilityCooldownPeriodModifier : null);
      } else {
        this._cachedAbilityCooldownPeriodModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.abilityCooldownPeriodModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedAbilityCooldownPeriodModifier;
  }
  get selfDisabledWeapons() {
    return this._value.disabledWeapons;
  }
  get inherentDisabledWeapons() {
    if (!this._inherentDisabledWeapons) {
      this._inherentDisabledWeapons = this._parent ? this._parent.disabledWeapons : [];
    }
    return this._inherentDisabledWeapons;
  }
  get disabledWeapons() {
    if (!this._allDisabledWeapons) {
      this._allDisabledWeapons = this._parent ? this._parent.disabledWeapons.concat(this.selfDisabledWeapons) : this.selfDisabledWeapons;
    }
    return this._allDisabledWeapons;
  }
  get selfEnabledWeapons() {
    return this._value.enabledWeapons;
  }
  get inherentEnabledWeapons() {
    if (!this._inherentEnabledWeapons) {
      this._inherentEnabledWeapons = this._parent ? this._parent.enabledWeapons : [];
    }
    return this._inherentEnabledWeapons;
  }
  get enabledWeapons() {
    if (!this._allEnabledWeapons) {
      this._allEnabledWeapons = this._parent ? this._parent.enabledWeapons.concat(this.selfEnabledWeapons) : this.selfEnabledWeapons;
    }
    return this._allEnabledWeapons;
  }
  get selfDisabledWeaponFamilies() {
    return this._value.disabledWeaponFamilies;
  }
  get inherentDisabledWeaponFamilies() {
    if (!this._inherentDisabledWeaponFamilies) {
      this._inherentDisabledWeaponFamilies = this._parent ? this._parent.disabledWeaponFamilies : [];
    }
    return this._inherentDisabledWeaponFamilies;
  }
  get disabledWeaponFamilies() {
    if (!this._allDisabledWeaponFamilies) {
      this._allDisabledWeaponFamilies = this._parent ? this._parent.disabledWeaponFamilies.concat(this.selfDisabledWeaponFamilies) : this.selfDisabledWeaponFamilies;
    }
    return this._allDisabledWeaponFamilies;
  }
  get selfEnabledWeaponFamilies() {
    return this._value.enabledWeaponFamilies;
  }
  get inherentEnabledWeaponFamilies() {
    if (!this._inherentEnabledWeaponFamilies) {
      this._inherentEnabledWeaponFamilies = this._parent ? this._parent.enabledWeaponFamilies : [];
    }
    return this._inherentEnabledWeaponFamilies;
  }
  get enabledWeaponFamilies() {
    if (!this._allEnabledWeaponFamilies) {
      this._allEnabledWeaponFamilies = this._parent ? this._parent.enabledWeaponFamilies.concat(this.selfEnabledWeaponFamilies) : this.selfEnabledWeaponFamilies;
    }
    return this._allEnabledWeaponFamilies;
  }
  get selfWeaponModifierGroup() {
    return this._value.weaponModifierGroup;
  }
  get inherentWeaponModifierGroup() {
    if (!this._inherentWeaponModifierGroup) {
      this._inherentWeaponModifierGroup = this._parent ? this._parent.weaponModifierGroup : [];
    }
    return this._inherentWeaponModifierGroup;
  }
  get weaponModifierGroup() {
    if (!this._allWeaponModifierGroup) {
      this._allWeaponModifierGroup = this._parent ? this._parent.weaponModifierGroup.concat(this.selfWeaponModifierGroup) : this.selfWeaponModifierGroup;
    }
    return this._allWeaponModifierGroup;
  }
  get selfAbilityModifierGroup() {
    return this._value.abilityModifierGroup;
  }
  get inherentAbilityModifierGroup() {
    if (!this._inherentAbilityModifierGroup) {
      this._inherentAbilityModifierGroup = this._parent ? this._parent.abilityModifierGroup : [];
    }
    return this._inherentAbilityModifierGroup;
  }
  get abilityModifierGroup() {
    if (!this._allAbilityModifierGroup) {
      this._allAbilityModifierGroup = this._parent ? this._parent.abilityModifierGroup.concat(this.selfAbilityModifierGroup) : this.selfAbilityModifierGroup;
    }
    return this._allAbilityModifierGroup;
  }
  get selfDisabledAbilities() {
    return this._value.disabledAbilities;
  }
  get inherentDisabledAbilities() {
    if (!this._inherentDisabledAbilities) {
      this._inherentDisabledAbilities = this._parent ? this._parent.disabledAbilities : [];
    }
    return this._inherentDisabledAbilities;
  }
  get disabledAbilities() {
    if (!this._allDisabledAbilities) {
      this._allDisabledAbilities = this._parent ? this._parent.disabledAbilities.concat(this.selfDisabledAbilities) : this.selfDisabledAbilities;
    }
    return this._allDisabledAbilities;
  }
  get selfEnabledAbilities() {
    return this._value.enabledAbilities;
  }
  get inherentEnabledAbilities() {
    if (!this._inherentEnabledAbilities) {
      this._inherentEnabledAbilities = this._parent ? this._parent.enabledAbilities : [];
    }
    return this._inherentEnabledAbilities;
  }
  get enabledAbilities() {
    if (!this._allEnabledAbilities) {
      this._allEnabledAbilities = this._parent ? this._parent.enabledAbilities.concat(this.selfEnabledAbilities) : this.selfEnabledAbilities;
    }
    return this._allEnabledAbilities;
  }
  get selfHideAbilities() {
    return this._value.hideAbilities;
  }
  get inherentHideAbilities() {
    if (!this._inherentHideAbilities) {
      this._inherentHideAbilities = this._parent ? this._parent.hideAbilities : [];
    }
    return this._inherentHideAbilities;
  }
  get hideAbilities() {
    if (!this._allHideAbilities) {
      this._allHideAbilities = this._parent ? this._parent.hideAbilities.concat(this.selfHideAbilities) : this.selfHideAbilities;
    }
    return this._allHideAbilities;
  }
  get selfShowAbilities() {
    return this._value.showAbilities;
  }
  get inherentShowAbilities() {
    if (!this._inherentShowAbilities) {
      this._inherentShowAbilities = this._parent ? this._parent.showAbilities : [];
    }
    return this._inherentShowAbilities;
  }
  get showAbilities() {
    if (!this._allShowAbilities) {
      this._allShowAbilities = this._parent ? this._parent.showAbilities.concat(this.selfShowAbilities) : this.selfShowAbilities;
    }
    return this._allShowAbilities;
  }
  get selfAddHighlightToAbilities() {
    return this._value.addHighlightToAbilities;
  }
  get inherentAddHighlightToAbilities() {
    if (!this._inherentAddHighlightToAbilities) {
      this._inherentAddHighlightToAbilities = this._parent ? this._parent.addHighlightToAbilities : [];
    }
    return this._inherentAddHighlightToAbilities;
  }
  get addHighlightToAbilities() {
    if (!this._allAddHighlightToAbilities) {
      this._allAddHighlightToAbilities = this._parent ? this._parent.addHighlightToAbilities.concat(this.selfAddHighlightToAbilities) : this.selfAddHighlightToAbilities;
    }
    return this._allAddHighlightToAbilities;
  }
  get selfRemoveHighlightFromAbilities() {
    return this._value.removeHighlightFromAbilities;
  }
  get inherentRemoveHighlightFromAbilities() {
    if (!this._inherentRemoveHighlightFromAbilities) {
      this._inherentRemoveHighlightFromAbilities = this._parent ? this._parent.removeHighlightFromAbilities : [];
    }
    return this._inherentRemoveHighlightFromAbilities;
  }
  get removeHighlightFromAbilities() {
    if (!this._allRemoveHighlightFromAbilities) {
      this._allRemoveHighlightFromAbilities = this._parent ? this._parent.removeHighlightFromAbilities.concat(this.selfRemoveHighlightFromAbilities) : this.selfRemoveHighlightFromAbilities;
    }
    return this._allRemoveHighlightFromAbilities;
  }
  update(current, parent) {
    const result = new BehaviorModifiers_WithParent(current, parent);
    if (this._cachedFlags && this._value.hasFlags && current.hasFlags) {
      if (this._value.flags === current.flags && this._parent === parent) {
        result._cachedFlags = this._cachedFlags;
      } else {
        result._cachedFlags = this._cachedFlags.update(current.flags, parent && parent.hasFlags ? parent.flags : null);
      }
    }
    if (this._cachedMaxHealthModifier && this._value.hasMaxHealthModifier && current.hasMaxHealthModifier) {
      if (this._value.maxHealthModifier === current.maxHealthModifier && this._parent === parent) {
        result._cachedMaxHealthModifier = this._cachedMaxHealthModifier;
      } else {
        result._cachedMaxHealthModifier = this._cachedMaxHealthModifier.update(current.maxHealthModifier, parent && parent.hasMaxHealthModifier ? parent.maxHealthModifier : null);
      }
    }
    if (this._cachedMaxManaModifier && this._value.hasMaxManaModifier && current.hasMaxManaModifier) {
      if (this._value.maxManaModifier === current.maxManaModifier && this._parent === parent) {
        result._cachedMaxManaModifier = this._cachedMaxManaModifier;
      } else {
        result._cachedMaxManaModifier = this._cachedMaxManaModifier.update(current.maxManaModifier, parent && parent.hasMaxManaModifier ? parent.maxManaModifier : null);
      }
    }
    if (this._cachedMaxShieldModifier && this._value.hasMaxShieldModifier && current.hasMaxShieldModifier) {
      if (this._value.maxShieldModifier === current.maxShieldModifier && this._parent === parent) {
        result._cachedMaxShieldModifier = this._cachedMaxShieldModifier;
      } else {
        result._cachedMaxShieldModifier = this._cachedMaxShieldModifier.update(current.maxShieldModifier, parent && parent.hasMaxShieldModifier ? parent.maxShieldModifier : null);
      }
    }
    if (this._cachedHealthRegenerationModifier && this._value.hasHealthRegenerationModifier && current.hasHealthRegenerationModifier) {
      if (this._value.healthRegenerationModifier === current.healthRegenerationModifier && this._parent === parent) {
        result._cachedHealthRegenerationModifier = this._cachedHealthRegenerationModifier;
      } else {
        result._cachedHealthRegenerationModifier = this._cachedHealthRegenerationModifier.update(current.healthRegenerationModifier, parent && parent.hasHealthRegenerationModifier ? parent.healthRegenerationModifier : null);
      }
    }
    if (this._cachedManaRegenerationModifier && this._value.hasManaRegenerationModifier && current.hasManaRegenerationModifier) {
      if (this._value.manaRegenerationModifier === current.manaRegenerationModifier && this._parent === parent) {
        result._cachedManaRegenerationModifier = this._cachedManaRegenerationModifier;
      } else {
        result._cachedManaRegenerationModifier = this._cachedManaRegenerationModifier.update(current.manaRegenerationModifier, parent && parent.hasManaRegenerationModifier ? parent.manaRegenerationModifier : null);
      }
    }
    if (this._cachedShieldRegenerationModifier && this._value.hasShieldRegenerationModifier && current.hasShieldRegenerationModifier) {
      if (this._value.shieldRegenerationModifier === current.shieldRegenerationModifier && this._parent === parent) {
        result._cachedShieldRegenerationModifier = this._cachedShieldRegenerationModifier;
      } else {
        result._cachedShieldRegenerationModifier = this._cachedShieldRegenerationModifier.update(current.shieldRegenerationModifier, parent && parent.hasShieldRegenerationModifier ? parent.shieldRegenerationModifier : null);
      }
    }
    if (this._cachedUnitTargetPriority && this._value.hasUnitTargetPriority && current.hasUnitTargetPriority) {
      if (this._value.unitTargetPriority === current.unitTargetPriority && this._parent === parent) {
        result._cachedUnitTargetPriority = this._cachedUnitTargetPriority;
      } else {
        result._cachedUnitTargetPriority = this._cachedUnitTargetPriority.update(current.unitTargetPriority, parent && parent.hasUnitTargetPriority ? parent.unitTargetPriority : null);
      }
    }
    if (this._cachedUnitRadiusModifier && this._value.hasUnitRadiusModifier && current.hasUnitRadiusModifier) {
      if (this._value.unitRadiusModifier === current.unitRadiusModifier && this._parent === parent) {
        result._cachedUnitRadiusModifier = this._cachedUnitRadiusModifier;
      } else {
        result._cachedUnitRadiusModifier = this._cachedUnitRadiusModifier.update(current.unitRadiusModifier, parent && parent.hasUnitRadiusModifier ? parent.unitRadiusModifier : null);
      }
    }
    if (this._cachedMoveSpeedModifier && this._value.hasMoveSpeedModifier && current.hasMoveSpeedModifier) {
      if (this._value.moveSpeedModifier === current.moveSpeedModifier && this._parent === parent) {
        result._cachedMoveSpeedModifier = this._cachedMoveSpeedModifier;
      } else {
        result._cachedMoveSpeedModifier = this._cachedMoveSpeedModifier.update(current.moveSpeedModifier, parent && parent.hasMoveSpeedModifier ? parent.moveSpeedModifier : null);
      }
    }
    if (this._cachedAttackSpeedModifier && this._value.hasAttackSpeedModifier && current.hasAttackSpeedModifier) {
      if (this._value.attackSpeedModifier === current.attackSpeedModifier && this._parent === parent) {
        result._cachedAttackSpeedModifier = this._cachedAttackSpeedModifier;
      } else {
        result._cachedAttackSpeedModifier = this._cachedAttackSpeedModifier.update(current.attackSpeedModifier, parent && parent.hasAttackSpeedModifier ? parent.attackSpeedModifier : null);
      }
    }
    if (this._cachedWeaponDamageModifier && this._value.hasWeaponDamageModifier && current.hasWeaponDamageModifier) {
      if (this._value.weaponDamageModifier === current.weaponDamageModifier && this._parent === parent) {
        result._cachedWeaponDamageModifier = this._cachedWeaponDamageModifier;
      } else {
        result._cachedWeaponDamageModifier = this._cachedWeaponDamageModifier.update(current.weaponDamageModifier, parent && parent.hasWeaponDamageModifier ? parent.weaponDamageModifier : null);
      }
    }
    if (this._cachedAbilityDamageModifier && this._value.hasAbilityDamageModifier && current.hasAbilityDamageModifier) {
      if (this._value.abilityDamageModifier === current.abilityDamageModifier && this._parent === parent) {
        result._cachedAbilityDamageModifier = this._cachedAbilityDamageModifier;
      } else {
        result._cachedAbilityDamageModifier = this._cachedAbilityDamageModifier.update(current.abilityDamageModifier, parent && parent.hasAbilityDamageModifier ? parent.abilityDamageModifier : null);
      }
    }
    if (this._cachedWeaponDamageTakenModifier && this._value.hasWeaponDamageTakenModifier && current.hasWeaponDamageTakenModifier) {
      if (this._value.weaponDamageTakenModifier === current.weaponDamageTakenModifier && this._parent === parent) {
        result._cachedWeaponDamageTakenModifier = this._cachedWeaponDamageTakenModifier;
      } else {
        result._cachedWeaponDamageTakenModifier = this._cachedWeaponDamageTakenModifier.update(current.weaponDamageTakenModifier, parent && parent.hasWeaponDamageTakenModifier ? parent.weaponDamageTakenModifier : null);
      }
    }
    if (this._cachedAbilityDamageTakenModifier && this._value.hasAbilityDamageTakenModifier && current.hasAbilityDamageTakenModifier) {
      if (this._value.abilityDamageTakenModifier === current.abilityDamageTakenModifier && this._parent === parent) {
        result._cachedAbilityDamageTakenModifier = this._cachedAbilityDamageTakenModifier;
      } else {
        result._cachedAbilityDamageTakenModifier = this._cachedAbilityDamageTakenModifier.update(current.abilityDamageTakenModifier, parent && parent.hasAbilityDamageTakenModifier ? parent.abilityDamageTakenModifier : null);
      }
    }
    if (this._cachedCriticalChanceModifier && this._value.hasCriticalChanceModifier && current.hasCriticalChanceModifier) {
      if (this._value.criticalChanceModifier === current.criticalChanceModifier && this._parent === parent) {
        result._cachedCriticalChanceModifier = this._cachedCriticalChanceModifier;
      } else {
        result._cachedCriticalChanceModifier = this._cachedCriticalChanceModifier.update(current.criticalChanceModifier, parent && parent.hasCriticalChanceModifier ? parent.criticalChanceModifier : null);
      }
    }
    if (this._cachedAbilityCriticalChanceModifier && this._value.hasAbilityCriticalChanceModifier && current.hasAbilityCriticalChanceModifier) {
      if (this._value.abilityCriticalChanceModifier === current.abilityCriticalChanceModifier && this._parent === parent) {
        result._cachedAbilityCriticalChanceModifier = this._cachedAbilityCriticalChanceModifier;
      } else {
        result._cachedAbilityCriticalChanceModifier = this._cachedAbilityCriticalChanceModifier.update(current.abilityCriticalChanceModifier, parent && parent.hasAbilityCriticalChanceModifier ? parent.abilityCriticalChanceModifier : null);
      }
    }
    if (this._cachedAbilityGoldCostModifier && this._value.hasAbilityGoldCostModifier && current.hasAbilityGoldCostModifier) {
      if (this._value.abilityGoldCostModifier === current.abilityGoldCostModifier && this._parent === parent) {
        result._cachedAbilityGoldCostModifier = this._cachedAbilityGoldCostModifier;
      } else {
        result._cachedAbilityGoldCostModifier = this._cachedAbilityGoldCostModifier.update(current.abilityGoldCostModifier, parent && parent.hasAbilityGoldCostModifier ? parent.abilityGoldCostModifier : null);
      }
    }
    if (this._cachedAbilityManaCostModifier && this._value.hasAbilityManaCostModifier && current.hasAbilityManaCostModifier) {
      if (this._value.abilityManaCostModifier === current.abilityManaCostModifier && this._parent === parent) {
        result._cachedAbilityManaCostModifier = this._cachedAbilityManaCostModifier;
      } else {
        result._cachedAbilityManaCostModifier = this._cachedAbilityManaCostModifier.update(current.abilityManaCostModifier, parent && parent.hasAbilityManaCostModifier ? parent.abilityManaCostModifier : null);
      }
    }
    if (this._cachedAbilityHealthCostModifier && this._value.hasAbilityHealthCostModifier && current.hasAbilityHealthCostModifier) {
      if (this._value.abilityHealthCostModifier === current.abilityHealthCostModifier && this._parent === parent) {
        result._cachedAbilityHealthCostModifier = this._cachedAbilityHealthCostModifier;
      } else {
        result._cachedAbilityHealthCostModifier = this._cachedAbilityHealthCostModifier.update(current.abilityHealthCostModifier, parent && parent.hasAbilityHealthCostModifier ? parent.abilityHealthCostModifier : null);
      }
    }
    if (this._cachedHealModifier && this._value.hasHealModifier && current.hasHealModifier) {
      if (this._value.healModifier === current.healModifier && this._parent === parent) {
        result._cachedHealModifier = this._cachedHealModifier;
      } else {
        result._cachedHealModifier = this._cachedHealModifier.update(current.healModifier, parent && parent.hasHealModifier ? parent.healModifier : null);
      }
    }
    if (this._cachedWeaponRangeModifier && this._value.hasWeaponRangeModifier && current.hasWeaponRangeModifier) {
      if (this._value.weaponRangeModifier === current.weaponRangeModifier && this._parent === parent) {
        result._cachedWeaponRangeModifier = this._cachedWeaponRangeModifier;
      } else {
        result._cachedWeaponRangeModifier = this._cachedWeaponRangeModifier.update(current.weaponRangeModifier, parent && parent.hasWeaponRangeModifier ? parent.weaponRangeModifier : null);
      }
    }
    if (this._cachedWeaponScanRangeModifier && this._value.hasWeaponScanRangeModifier && current.hasWeaponScanRangeModifier) {
      if (this._value.weaponScanRangeModifier === current.weaponScanRangeModifier && this._parent === parent) {
        result._cachedWeaponScanRangeModifier = this._cachedWeaponScanRangeModifier;
      } else {
        result._cachedWeaponScanRangeModifier = this._cachedWeaponScanRangeModifier.update(current.weaponScanRangeModifier, parent && parent.hasWeaponScanRangeModifier ? parent.weaponScanRangeModifier : null);
      }
    }
    if (this._cachedAbilityCooldownModifier && this._value.hasAbilityCooldownModifier && current.hasAbilityCooldownModifier) {
      if (this._value.abilityCooldownModifier === current.abilityCooldownModifier && this._parent === parent) {
        result._cachedAbilityCooldownModifier = this._cachedAbilityCooldownModifier;
      } else {
        result._cachedAbilityCooldownModifier = this._cachedAbilityCooldownModifier.update(current.abilityCooldownModifier, parent && parent.hasAbilityCooldownModifier ? parent.abilityCooldownModifier : null);
      }
    }
    if (this._cachedChargeTimeModifier && this._value.hasChargeTimeModifier && current.hasChargeTimeModifier) {
      if (this._value.chargeTimeModifier === current.chargeTimeModifier && this._parent === parent) {
        result._cachedChargeTimeModifier = this._cachedChargeTimeModifier;
      } else {
        result._cachedChargeTimeModifier = this._cachedChargeTimeModifier.update(current.chargeTimeModifier, parent && parent.hasChargeTimeModifier ? parent.chargeTimeModifier : null);
      }
    }
    if (this._cachedAbilitySpeedModifier && this._value.hasAbilitySpeedModifier && current.hasAbilitySpeedModifier) {
      if (this._value.abilitySpeedModifier === current.abilitySpeedModifier && this._parent === parent) {
        result._cachedAbilitySpeedModifier = this._cachedAbilitySpeedModifier;
      } else {
        result._cachedAbilitySpeedModifier = this._cachedAbilitySpeedModifier.update(current.abilitySpeedModifier, parent && parent.hasAbilitySpeedModifier ? parent.abilitySpeedModifier : null);
      }
    }
    if (this._cachedAbilityCooldownPeriodModifier && this._value.hasAbilityCooldownPeriodModifier && current.hasAbilityCooldownPeriodModifier) {
      if (this._value.abilityCooldownPeriodModifier === current.abilityCooldownPeriodModifier && this._parent === parent) {
        result._cachedAbilityCooldownPeriodModifier = this._cachedAbilityCooldownPeriodModifier;
      } else {
        result._cachedAbilityCooldownPeriodModifier = this._cachedAbilityCooldownPeriodModifier.update(current.abilityCooldownPeriodModifier, parent && parent.hasAbilityCooldownPeriodModifier ? parent.abilityCooldownPeriodModifier : null);
      }
    }
    return result;
  }
}
BehaviorModifiers_WithParent.default = new BehaviorModifiers_WithParent(BehaviorModifiers.default, null);
BehaviorModifiers.WithParent = BehaviorModifiers_WithParent;
class BehaviorModifiers_Descriptor {
  get flags() {
    if (!this._flags) {
      this._flags = {
        name: "flags",
        Name: "Flags",
        number: 1,
        protoType: 11,
        protoName: "flags",
        type: BehaviorFlags,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flags;
  }
  get maxHealthModifier() {
    if (!this._maxHealthModifier) {
      this._maxHealthModifier = {
        name: "maxHealthModifier",
        Name: "MaxHealthModifier",
        number: 2,
        protoType: 11,
        protoName: "max_health_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s health.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxHealthModifier;
  }
  get maxManaModifier() {
    if (!this._maxManaModifier) {
      this._maxManaModifier = {
        name: "maxManaModifier",
        Name: "MaxManaModifier",
        number: 3,
        protoType: 11,
        protoName: "max_mana_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s mana.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxManaModifier;
  }
  get maxShieldModifier() {
    if (!this._maxShieldModifier) {
      this._maxShieldModifier = {
        name: "maxShieldModifier",
        Name: "MaxShieldModifier",
        number: 4,
        protoType: 11,
        protoName: "max_shield_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s shield.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxShieldModifier;
  }
  get healthRegenerationModifier() {
    if (!this._healthRegenerationModifier) {
      this._healthRegenerationModifier = {
        name: "healthRegenerationModifier",
        Name: "HealthRegenerationModifier",
        number: 5,
        protoType: 11,
        protoName: "health_regeneration_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s health regen.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthRegenerationModifier;
  }
  get manaRegenerationModifier() {
    if (!this._manaRegenerationModifier) {
      this._manaRegenerationModifier = {
        name: "manaRegenerationModifier",
        Name: "ManaRegenerationModifier",
        number: 6,
        protoType: 11,
        protoName: "mana_regeneration_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s mana regen.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._manaRegenerationModifier;
  }
  get shieldRegenerationModifier() {
    if (!this._shieldRegenerationModifier) {
      this._shieldRegenerationModifier = {
        name: "shieldRegenerationModifier",
        Name: "ShieldRegenerationModifier",
        number: 7,
        protoType: 11,
        protoName: "shield_regeneration_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s shield regen.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shieldRegenerationModifier;
  }
  get unitTargetPriority() {
    if (!this._unitTargetPriority) {
      this._unitTargetPriority = {
        name: "unitTargetPriority",
        Name: "UnitTargetPriority",
        number: 8,
        protoType: 11,
        protoName: "unit_target_priority",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s target priority.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitTargetPriority;
  }
  get unitRadiusModifier() {
    if (!this._unitRadiusModifier) {
      this._unitRadiusModifier = {
        name: "unitRadiusModifier",
        Name: "UnitRadiusModifier",
        number: 9,
        protoType: 11,
        protoName: "unit_radius_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitRadiusModifier;
  }
  get moveSpeedModifier() {
    if (!this._moveSpeedModifier) {
      this._moveSpeedModifier = {
        name: "moveSpeedModifier",
        Name: "MoveSpeedModifier",
        number: 11,
        protoType: 11,
        protoName: "move_speed_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s movement speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._moveSpeedModifier;
  }
  get attackSpeedModifier() {
    if (!this._attackSpeedModifier) {
      this._attackSpeedModifier = {
        name: "attackSpeedModifier",
        Name: "AttackSpeedModifier",
        number: 12,
        protoType: 11,
        protoName: "attack_speed_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s weapon attack speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._attackSpeedModifier;
  }
  get weaponDamageModifier() {
    if (!this._weaponDamageModifier) {
      this._weaponDamageModifier = {
        name: "weaponDamageModifier",
        Name: "WeaponDamageModifier",
        number: 21,
        protoType: 11,
        protoName: "weapon_damage_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s weapon damage.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponDamageModifier;
  }
  get abilityDamageModifier() {
    if (!this._abilityDamageModifier) {
      this._abilityDamageModifier = {
        name: "abilityDamageModifier",
        Name: "AbilityDamageModifier",
        number: 22,
        protoType: 11,
        protoName: "ability_damage_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s ability damage.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityDamageModifier;
  }
  get weaponDamageTakenModifier() {
    if (!this._weaponDamageTakenModifier) {
      this._weaponDamageTakenModifier = {
        name: "weaponDamageTakenModifier",
        Name: "WeaponDamageTakenModifier",
        number: 23,
        protoType: 11,
        protoName: "weapon_damage_taken_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s damage taken (from weapons).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponDamageTakenModifier;
  }
  get abilityDamageTakenModifier() {
    if (!this._abilityDamageTakenModifier) {
      this._abilityDamageTakenModifier = {
        name: "abilityDamageTakenModifier",
        Name: "AbilityDamageTakenModifier",
        number: 24,
        protoType: 11,
        protoName: "ability_damage_taken_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s damage taken (from abilities).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityDamageTakenModifier;
  }
  get criticalChanceModifier() {
    if (!this._criticalChanceModifier) {
      this._criticalChanceModifier = {
        name: "criticalChanceModifier",
        Name: "CriticalChanceModifier",
        number: 25,
        protoType: 11,
        protoName: "critical_chance_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s critical chance with weapons.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalChanceModifier;
  }
  get abilityCriticalChanceModifier() {
    if (!this._abilityCriticalChanceModifier) {
      this._abilityCriticalChanceModifier = {
        name: "abilityCriticalChanceModifier",
        Name: "AbilityCriticalChanceModifier",
        number: 27,
        protoType: 11,
        protoName: "ability_critical_chance_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s critical chance with abilities.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityCriticalChanceModifier;
  }
  get abilityGoldCostModifier() {
    if (!this._abilityGoldCostModifier) {
      this._abilityGoldCostModifier = {
        name: "abilityGoldCostModifier",
        Name: "AbilityGoldCostModifier",
        number: 71,
        protoType: 11,
        protoName: "ability_gold_cost_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the gold cost of the unit\'s abilities.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityGoldCostModifier;
  }
  get abilityManaCostModifier() {
    if (!this._abilityManaCostModifier) {
      this._abilityManaCostModifier = {
        name: "abilityManaCostModifier",
        Name: "AbilityManaCostModifier",
        number: 72,
        protoType: 11,
        protoName: "ability_mana_cost_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the mana cost of the unit\'s abilities.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityManaCostModifier;
  }
  get abilityHealthCostModifier() {
    if (!this._abilityHealthCostModifier) {
      this._abilityHealthCostModifier = {
        name: "abilityHealthCostModifier",
        Name: "AbilityHealthCostModifier",
        number: 73,
        protoType: 11,
        protoName: "ability_health_cost_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the health cost of the unit\'s abilities.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityHealthCostModifier;
  }
  get healModifier() {
    if (!this._healModifier) {
      this._healModifier = {
        name: "healModifier",
        Name: "HealModifier",
        number: 26,
        protoType: 11,
        protoName: "heal_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s healing effects. Note that this modifier only applies to flat (non-percentage) healing effects.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healModifier;
  }
  get weaponRangeModifier() {
    if (!this._weaponRangeModifier) {
      this._weaponRangeModifier = {
        name: "weaponRangeModifier",
        Name: "WeaponRangeModifier",
        number: 31,
        protoType: 11,
        protoName: "weapon_range_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s weapon range.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponRangeModifier;
  }
  get weaponScanRangeModifier() {
    if (!this._weaponScanRangeModifier) {
      this._weaponScanRangeModifier = {
        name: "weaponScanRangeModifier",
        Name: "WeaponScanRangeModifier",
        number: 32,
        protoType: 11,
        protoName: "weapon_scan_range_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s weapon scan range.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponScanRangeModifier;
  }
  get abilityCooldownModifier() {
    if (!this._abilityCooldownModifier) {
      this._abilityCooldownModifier = {
        name: "abilityCooldownModifier",
        Name: "AbilityCooldownModifier",
        number: 41,
        protoType: 11,
        protoName: "ability_cooldown_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s cooldown recharge speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityCooldownModifier;
  }
  get chargeTimeModifier() {
    if (!this._chargeTimeModifier) {
      this._chargeTimeModifier = {
        name: "chargeTimeModifier",
        Name: "ChargeTimeModifier",
        number: 42,
        protoType: 11,
        protoName: "charge_time_modifier",
        type: BehaviorModifier,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chargeTimeModifier;
  }
  get abilitySpeedModifier() {
    if (!this._abilitySpeedModifier) {
      this._abilitySpeedModifier = {
        name: "abilitySpeedModifier",
        Name: "AbilitySpeedModifier",
        number: 43,
        protoType: 11,
        protoName: "ability_speed_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s ability cast speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilitySpeedModifier;
  }
  get abilityCooldownPeriodModifier() {
    if (!this._abilityCooldownPeriodModifier) {
      this._abilityCooldownPeriodModifier = {
        name: "abilityCooldownPeriodModifier",
        Name: "AbilityCooldownPeriodModifier",
        number: 44,
        protoType: 11,
        protoName: "ability_cooldown_period_modifier",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the unit\'s ability cooldown reduction.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityCooldownPeriodModifier;
  }
  get disabledWeapons() {
    if (!this._disabledWeapons) {
      this._disabledWeapons = {
        name: "disabledWeapons",
        Name: "DisabledWeapons",
        number: 51,
        protoType: 9,
        protoName: "disabled_weapons",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Prevents the unit from using these weapons.",
          valueDropdown: "SupportedWeaponListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabledWeapons;
  }
  get enabledWeapons() {
    if (!this._enabledWeapons) {
      this._enabledWeapons = {
        name: "enabledWeapons",
        Name: "EnabledWeapons",
        number: 52,
        protoType: 9,
        protoName: "enabled_weapons",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Enables these weapons if they are disabled.",
          valueDropdown: "SupportedWeaponListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enabledWeapons;
  }
  get disabledWeaponFamilies() {
    if (!this._disabledWeaponFamilies) {
      this._disabledWeaponFamilies = {
        name: "disabledWeaponFamilies",
        Name: "DisabledWeaponFamilies",
        number: 101,
        protoType: 9,
        protoName: "disabled_weapon_families",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Prevents the unit from using weapons under these families.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabledWeaponFamilies;
  }
  get enabledWeaponFamilies() {
    if (!this._enabledWeaponFamilies) {
      this._enabledWeaponFamilies = {
        name: "enabledWeaponFamilies",
        Name: "EnabledWeaponFamilies",
        number: 102,
        protoType: 9,
        protoName: "enabled_weapon_families",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Enables weapons under these families if they are disabled.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enabledWeaponFamilies;
  }
  get weaponModifierGroup() {
    if (!this._weaponModifierGroup) {
      this._weaponModifierGroup = {
        name: "weaponModifierGroup",
        Name: "WeaponModifierGroup",
        number: 53,
        protoType: 9,
        protoName: "weapon_modifier_group",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If set, modifiers affecting weapons (such as weapon damage, weapon range, attack speed, etc) only apply to weapons listed here rather than to all weapons.",
          valueDropdown: "SupportedWeaponListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponModifierGroup;
  }
  get abilityModifierGroup() {
    if (!this._abilityModifierGroup) {
      this._abilityModifierGroup = {
        name: "abilityModifierGroup",
        Name: "AbilityModifierGroup",
        number: 54,
        protoType: 9,
        protoName: "ability_modifier_group",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If set, modifiers affecting abilities (such as ability damage, ability cooldown, ability speed, etc) only apply to abilities listed here rather than to all abilities.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityModifierGroup;
  }
  get disabledAbilities() {
    if (!this._disabledAbilities) {
      this._disabledAbilities = {
        name: "disabledAbilities",
        Name: "DisabledAbilities",
        number: 61,
        protoType: 9,
        protoName: "disabled_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Prevents the unit from using these abilities.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabledAbilities;
  }
  get enabledAbilities() {
    if (!this._enabledAbilities) {
      this._enabledAbilities = {
        name: "enabledAbilities",
        Name: "EnabledAbilities",
        number: 62,
        protoType: 9,
        protoName: "enabled_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Enables these abilities if they are disabled.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enabledAbilities;
  }
  get hideAbilities() {
    if (!this._hideAbilities) {
      this._hideAbilities = {
        name: "hideAbilities",
        Name: "HideAbilities",
        number: 63,
        protoType: 9,
        protoName: "hide_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Hide these abilities from the built-in UI.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideAbilities;
  }
  get showAbilities() {
    if (!this._showAbilities) {
      this._showAbilities = {
        name: "showAbilities",
        Name: "ShowAbilities",
        number: 64,
        protoType: 9,
        protoName: "show_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Show these abilities in the built-in UI if hidden.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showAbilities;
  }
  get addHighlightToAbilities() {
    if (!this._addHighlightToAbilities) {
      this._addHighlightToAbilities = {
        name: "addHighlightToAbilities",
        Name: "AddHighlightToAbilities",
        number: 65,
        protoType: 9,
        protoName: "add_highlight_to_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Highlight these abilities in the built-in UI.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addHighlightToAbilities;
  }
  get removeHighlightFromAbilities() {
    if (!this._removeHighlightFromAbilities) {
      this._removeHighlightFromAbilities = {
        name: "removeHighlightFromAbilities",
        Name: "RemoveHighlightFromAbilities",
        number: 66,
        protoType: 9,
        protoName: "remove_highlight_from_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Remove highlight from these abilities in the built-in UI.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._removeHighlightFromAbilities;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.flags,
        this.maxHealthModifier,
        this.maxManaModifier,
        this.maxShieldModifier,
        this.healthRegenerationModifier,
        this.manaRegenerationModifier,
        this.shieldRegenerationModifier,
        this.unitTargetPriority,
        this.unitRadiusModifier,
        this.moveSpeedModifier,
        this.attackSpeedModifier,
        this.weaponDamageModifier,
        this.abilityDamageModifier,
        this.weaponDamageTakenModifier,
        this.abilityDamageTakenModifier,
        this.criticalChanceModifier,
        this.abilityCriticalChanceModifier,
        this.abilityGoldCostModifier,
        this.abilityManaCostModifier,
        this.abilityHealthCostModifier,
        this.healModifier,
        this.weaponRangeModifier,
        this.weaponScanRangeModifier,
        this.abilityCooldownModifier,
        this.chargeTimeModifier,
        this.abilitySpeedModifier,
        this.abilityCooldownPeriodModifier,
        this.disabledWeapons,
        this.enabledWeapons,
        this.disabledWeaponFamilies,
        this.enabledWeaponFamilies,
        this.weaponModifierGroup,
        this.abilityModifierGroup,
        this.disabledAbilities,
        this.enabledAbilities,
        this.hideAbilities,
        this.showAbilities,
        this.addHighlightToAbilities,
        this.removeHighlightFromAbilities,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFlags",
        Name: "DummyOneofForFlags",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxHealthModifier",
        Name: "DummyOneofForMaxHealthModifier",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxManaModifier",
        Name: "DummyOneofForMaxManaModifier",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxShieldModifier",
        Name: "DummyOneofForMaxShieldModifier",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealthRegenerationModifier",
        Name: "DummyOneofForHealthRegenerationModifier",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForManaRegenerationModifier",
        Name: "DummyOneofForManaRegenerationModifier",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShieldRegenerationModifier",
        Name: "DummyOneofForShieldRegenerationModifier",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitTargetPriority",
        Name: "DummyOneofForUnitTargetPriority",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitRadiusModifier",
        Name: "DummyOneofForUnitRadiusModifier",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMoveSpeedModifier",
        Name: "DummyOneofForMoveSpeedModifier",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAttackSpeedModifier",
        Name: "DummyOneofForAttackSpeedModifier",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeaponDamageModifier",
        Name: "DummyOneofForWeaponDamageModifier",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityDamageModifier",
        Name: "DummyOneofForAbilityDamageModifier",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeaponDamageTakenModifier",
        Name: "DummyOneofForWeaponDamageTakenModifier",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityDamageTakenModifier",
        Name: "DummyOneofForAbilityDamageTakenModifier",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCriticalChanceModifier",
        Name: "DummyOneofForCriticalChanceModifier",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityCriticalChanceModifier",
        Name: "DummyOneofForAbilityCriticalChanceModifier",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityGoldCostModifier",
        Name: "DummyOneofForAbilityGoldCostModifier",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityManaCostModifier",
        Name: "DummyOneofForAbilityManaCostModifier",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityHealthCostModifier",
        Name: "DummyOneofForAbilityHealthCostModifier",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealModifier",
        Name: "DummyOneofForHealModifier",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeaponRangeModifier",
        Name: "DummyOneofForWeaponRangeModifier",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeaponScanRangeModifier",
        Name: "DummyOneofForWeaponScanRangeModifier",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityCooldownModifier",
        Name: "DummyOneofForAbilityCooldownModifier",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChargeTimeModifier",
        Name: "DummyOneofForChargeTimeModifier",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilitySpeedModifier",
        Name: "DummyOneofForAbilitySpeedModifier",
        fields: [
          this.fields[25],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityCooldownPeriodModifier",
        Name: "DummyOneofForAbilityCooldownPeriodModifier",
        fields: [
          this.fields[26],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorModifiers.descriptor = new BehaviorModifiers_Descriptor();
class DamageResponse_LocationType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "DEFENDER": return 0;
        case "ATTACKER": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return DamageResponse_LocationType.fromJson(value);
  }
  static fromReact(e) {
    return DamageResponse_LocationType.fromJson(e);
  }
}
DamageResponse_LocationType.DEFENDER = 0;
DamageResponse_LocationType.ATTACKER = 1;
DamageResponse_LocationType.default = 0;
DamageResponse_LocationType.values = {
  DEFENDER: 0,
  ATTACKER: 1,
};
DamageResponse_LocationType.names = {
  0: "DEFENDER",
  1: "ATTACKER",
};
export class DamageResponse {
  get descriptor() {
    return DamageResponse.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasChance = false;
    this._chance = null;
    this._hasCooldown = false;
    this._cooldown = null;
    this._hasLocation = false;
    this._location = null;
    this._hasFatalOnly = false;
    this._fatalOnly = null;
    this._hasEffect = false;
    this._effect = null;
    this._hasDamageModifier = false;
    this._damageModifier = null;
    this._validators = [];
    this._hasChanceModifierPerStack = false;
    this._chanceModifierPerStack = null;
    this._hasDamageClampMin = false;
    this._damageClampMin = null;
    this._hasDamageClampMax = false;
    this._damageClampMax = null;
  }
  isEmpty() {
    if (this._hasChance) return false;
    if (this._hasCooldown) return false;
    if (this._hasLocation) return false;
    if (this._hasFatalOnly) return false;
    if (this._hasEffect) return false;
    if (this._hasDamageModifier && !this._damageModifier.isEmpty()) return false;
    if (this._validators.length > 0) return false;
    if (this._hasChanceModifierPerStack && !this._chanceModifierPerStack.isEmpty()) return false;
    if (this._hasDamageClampMin) return false;
    if (this._hasDamageClampMax) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DamageResponse) {
      return value;
    }
    return DamageResponse.fromJson(value);
  }
  static fromJson(json) {
    const result = new DamageResponse();
    if (json.chance != null) {
      result._hasChance = true;
      result._chance = JsonToDouble.fromJson(json.chance);
    }
    if (json.cooldown != null) {
      result._hasCooldown = true;
      result._cooldown = JsonToDouble.fromJson(json.cooldown);
    }
    if (json.location != null) {
      result._hasLocation = true;
      result._location = DamageResponse_LocationType.fromJson(json.location);
    }
    if (json.fatalOnly != null) {
      result._hasFatalOnly = true;
      result._fatalOnly = JsonToBoolean.fromJson(json.fatalOnly);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.damageModifier != null) {
      result._hasDamageModifier = true;
      result._damageModifier = BehaviorModifier.fromJson(json.damageModifier);
    }
    result._validators = JsonToList(json.validators, JsonToString);
    if (json.chanceModifierPerStack != null) {
      result._hasChanceModifierPerStack = true;
      result._chanceModifierPerStack = BehaviorModifier.fromJson(json.chanceModifierPerStack);
    }
    if (json.damageClampMin != null) {
      result._hasDamageClampMin = true;
      result._damageClampMin = JsonToDouble.fromJson(json.damageClampMin);
    }
    if (json.damageClampMax != null) {
      result._hasDamageClampMax = true;
      result._damageClampMax = JsonToDouble.fromJson(json.damageClampMax);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasChance) {
      result.chance = JsonToDouble.toJson(this._chance);
    }
    if (this._hasCooldown) {
      result.cooldown = JsonToDouble.toJson(this._cooldown);
    }
    if (this._hasLocation) {
      result.location = DamageResponse_LocationType.toJson(this._location);
    }
    if (this._hasFatalOnly) {
      result.fatalOnly = JsonToBoolean.toJson(this._fatalOnly);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasDamageModifier && !this._damageModifier.isEmpty()) {
      result.damageModifier = BehaviorModifier.toJson(this._damageModifier);
    }
    if (this._validators.length > 0) {
      result.validators = ArrayToJson(this._validators, JsonToString);
    }
    if (this._hasChanceModifierPerStack && !this._chanceModifierPerStack.isEmpty()) {
      result.chanceModifierPerStack = BehaviorModifier.toJson(this._chanceModifierPerStack);
    }
    if (this._hasDamageClampMin) {
      result.damageClampMin = JsonToDouble.toJson(this._damageClampMin);
    }
    if (this._hasDamageClampMax) {
      result.damageClampMax = JsonToDouble.toJson(this._damageClampMax);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get chance() {
    return this._hasChance ? this._chance : JsonToDouble.default;
  }
  get hasChance() {
    return this._hasChance;
  }
  setChance(path, value) {
    return {type: 'SET', path: path.concat(['chance']), value};
  }
  deleteChance(path) {
    return {type: 'DELETE', path: path.concat(['chance'])};
  }
  /**
   * @returns {number}
   */
  get cooldown() {
    return this._hasCooldown ? this._cooldown : JsonToDouble.default;
  }
  get hasCooldown() {
    return this._hasCooldown;
  }
  setCooldown(path, value) {
    return {type: 'SET', path: path.concat(['cooldown']), value};
  }
  deleteCooldown(path) {
    return {type: 'DELETE', path: path.concat(['cooldown'])};
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : DamageResponse_LocationType.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  /**
   * @returns {boolean}
   */
  get fatalOnly() {
    return this._hasFatalOnly ? this._fatalOnly : JsonToBoolean.default;
  }
  get hasFatalOnly() {
    return this._hasFatalOnly;
  }
  setFatalOnly(path, value) {
    return {type: 'SET', path: path.concat(['fatalOnly']), value};
  }
  deleteFatalOnly(path) {
    return {type: 'DELETE', path: path.concat(['fatalOnly'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get damageModifier() {
    return this._hasDamageModifier ? this._damageModifier : BehaviorModifier.default;
  }
  get hasDamageModifier() {
    return this._hasDamageModifier;
  }
  setDamageModifier(path, value) {
    return {type: 'SET', path: path.concat(['damageModifier']), value: value.toJson()};
  }
  deleteDamageModifier(path) {
    return {type: 'DELETE', path: path.concat(['damageModifier'])};
  }
  /**
   * @returns {string[]}
   */
  get validators() {
    return this._validators;
  }
  addValidators(path, value) {
    return {type: 'ADD', path: path.concat(['validators']), value};
  }
  setValidators(path, value) {
    return {type: 'SET', path: path.concat(['validators']), value: ArrayToJson(value, JsonToString)};
  }
  setValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['validators', key]), value};
  }
  deleteValidators(path) {
    return {type: 'DELETE', path: path.concat(['validators'])};
  }
  deleteValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['validators', key])};
  }
  /**
   * @returns {BehaviorModifier}
   */
  get chanceModifierPerStack() {
    return this._hasChanceModifierPerStack ? this._chanceModifierPerStack : BehaviorModifier.default;
  }
  get hasChanceModifierPerStack() {
    return this._hasChanceModifierPerStack;
  }
  setChanceModifierPerStack(path, value) {
    return {type: 'SET', path: path.concat(['chanceModifierPerStack']), value: value.toJson()};
  }
  deleteChanceModifierPerStack(path) {
    return {type: 'DELETE', path: path.concat(['chanceModifierPerStack'])};
  }
  /**
   * @returns {number}
   */
  get damageClampMin() {
    return this._hasDamageClampMin ? this._damageClampMin : JsonToDouble.default;
  }
  get hasDamageClampMin() {
    return this._hasDamageClampMin;
  }
  setDamageClampMin(path, value) {
    return {type: 'SET', path: path.concat(['damageClampMin']), value};
  }
  deleteDamageClampMin(path) {
    return {type: 'DELETE', path: path.concat(['damageClampMin'])};
  }
  /**
   * @returns {number}
   */
  get damageClampMax() {
    return this._hasDamageClampMax ? this._damageClampMax : JsonToDouble.default;
  }
  get hasDamageClampMax() {
    return this._hasDamageClampMax;
  }
  setDamageClampMax(path, value) {
    return {type: 'SET', path: path.concat(['damageClampMax']), value};
  }
  deleteDamageClampMax(path) {
    return {type: 'DELETE', path: path.concat(['damageClampMax'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "chance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasChance = true;
              copy._chance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChance) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasChance = false;
              copy._chance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasCooldown = true;
              copy._cooldown = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCooldown) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasCooldown = false;
              copy._cooldown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasLocation = true;
              copy._location = DamageResponse_LocationType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fatalOnly": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasFatalOnly = true;
              copy._fatalOnly = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFatalOnly) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasFatalOnly = false;
              copy._fatalOnly = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "damageModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasDamageModifier = true;
              copy._damageModifier = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageModifier) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasDamageModifier = false;
              copy._damageModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDamageModifier) {
            const copy = new DamageResponse(this);
            copy._hasDamageModifier = true;
            copy._damageModifier = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._damageModifier.apply(type, path.slice(1), value);
          if (newValue === this._damageModifier) {
            return this;
          }
          const copy = new DamageResponse(this);
          copy._damageModifier = copy._damageModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "validators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._validators = [];        for (let i of value) {
                copy._validators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DamageResponse(this);
              copy._validators = copy._validators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._validators.length === 0) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._validators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._validators = copy._validators.slice();
              copy._validators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DamageResponse(this);
              copy._validators = copy._validators.slice(0, path[1]).concat(copy._validators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          const oldValue = this._validators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DamageResponse(this);
          copy._validators = copy._validators.slice();
          copy._validators[key] = newValue;
          return copy;
        }
      }
      case "chanceModifierPerStack": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasChanceModifierPerStack = true;
              copy._chanceModifierPerStack = BehaviorModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChanceModifierPerStack) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasChanceModifierPerStack = false;
              copy._chanceModifierPerStack = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChanceModifierPerStack) {
            const copy = new DamageResponse(this);
            copy._hasChanceModifierPerStack = true;
            copy._chanceModifierPerStack = BehaviorModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chanceModifierPerStack.apply(type, path.slice(1), value);
          if (newValue === this._chanceModifierPerStack) {
            return this;
          }
          const copy = new DamageResponse(this);
          copy._chanceModifierPerStack = copy._chanceModifierPerStack.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "damageClampMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasDamageClampMin = true;
              copy._damageClampMin = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageClampMin) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasDamageClampMin = false;
              copy._damageClampMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "damageClampMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DamageResponse(this);
              copy._hasDamageClampMax = true;
              copy._damageClampMax = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageClampMax) {
                return this;
              }
              const copy = new DamageResponse(this);
              copy._hasDamageClampMax = false;
              copy._damageClampMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DamageResponse} other
   * @returns {DamageResponse}
   */
  merge(other) {
    const copy = new DamageResponse(this);
    if (other._hasChance) {
      copy._hasChance = true;
      copy._chance = other._chance;
    }
    if (other._hasCooldown) {
      copy._hasCooldown = true;
      copy._cooldown = other._cooldown;
    }
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    if (other._hasFatalOnly) {
      copy._hasFatalOnly = true;
      copy._fatalOnly = other._fatalOnly;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasDamageModifier) {
      if (copy._hasDamageModifier) {
        copy._damageModifier = copy.damageModifier.merge(other.damageModifier);
      } else {
        copy._damageModifier = other._damageModifier;
      }
      copy._hasDamageModifier = true;
    }
    copy._validators = this._validators.concat(other._validators);
    if (other._hasChanceModifierPerStack) {
      if (copy._hasChanceModifierPerStack) {
        copy._chanceModifierPerStack = copy.chanceModifierPerStack.merge(other.chanceModifierPerStack);
      } else {
        copy._chanceModifierPerStack = other._chanceModifierPerStack;
      }
      copy._hasChanceModifierPerStack = true;
    }
    if (other._hasDamageClampMin) {
      copy._hasDamageClampMin = true;
      copy._damageClampMin = other._damageClampMin;
    }
    if (other._hasDamageClampMax) {
      copy._hasDamageClampMax = true;
      copy._damageClampMax = other._damageClampMax;
    }
    return copy;
  }
}
DamageResponse.default = new DamageResponse();
DamageResponse.LocationType = DamageResponse_LocationType;
class DamageResponse_Builder {
  constructor(value) {
    this._value = new DamageResponse(value);
  }
  build() {
    return new DamageResponse(this._value);
  }
  setChance(value) {
    this._value._hasChance = true;
    this._value._chance = value;
    return this;
  }
  deleteChance() {
    this._value._hasChance = false;
    this._value._chance = null;
    return this;
  }
  setCooldown(value) {
    this._value._hasCooldown = true;
    this._value._cooldown = value;
    return this;
  }
  deleteCooldown() {
    this._value._hasCooldown = false;
    this._value._cooldown = null;
    return this;
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
  setFatalOnly(value) {
    this._value._hasFatalOnly = true;
    this._value._fatalOnly = value;
    return this;
  }
  deleteFatalOnly() {
    this._value._hasFatalOnly = false;
    this._value._fatalOnly = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setDamageModifier(value) {
    this._value._hasDamageModifier = true;
    this._value._damageModifier = value;
    return this;
  }
  deleteDamageModifier() {
    this._value._hasDamageModifier = false;
    this._value._damageModifier = null;
    return this;
  }
  addAllValidators(values) {
    this._value._validators = this._value._validators.concat(values);
    return this;
  }
  addValidators(value) {
    this._value._validators = this._value._validators.concat([value]);
    return this;
  }
  setValidators(index, value) {
    this._value._validators = this._value._validators.concat();
    this._value._validators[index] = value;
    return this;
  }
  clearValidators() {
    this._value._validators = [];
    return this;
  }
  setChanceModifierPerStack(value) {
    this._value._hasChanceModifierPerStack = true;
    this._value._chanceModifierPerStack = value;
    return this;
  }
  deleteChanceModifierPerStack() {
    this._value._hasChanceModifierPerStack = false;
    this._value._chanceModifierPerStack = null;
    return this;
  }
  setDamageClampMin(value) {
    this._value._hasDamageClampMin = true;
    this._value._damageClampMin = value;
    return this;
  }
  deleteDamageClampMin() {
    this._value._hasDamageClampMin = false;
    this._value._damageClampMin = null;
    return this;
  }
  setDamageClampMax(value) {
    this._value._hasDamageClampMax = true;
    this._value._damageClampMax = value;
    return this;
  }
  deleteDamageClampMax() {
    this._value._hasDamageClampMax = false;
    this._value._damageClampMax = null;
    return this;
  }
}
DamageResponse.Builder = DamageResponse_Builder;
class DamageResponse_WithParent {
  /**
   * @param {DamageResponse} value
   * @param {DamageResponse_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DamageResponse.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasChance() {
    if (this._cachedHasChance === undefined) {
      if (this._value.hasChance) {
        this._cachedHasChance = true;
      } else {
        this._cachedHasChance = this._parent ? this._parent.hasChance : false;
      }
    }
    return this._cachedHasChance;
  }
  get chance() {
    if (this._cachedChance === undefined) {
      if (this._value.hasChance) {
        this._cachedChance = this._value.chance;
      } else {
        this._cachedChance = this._parent ? this._parent.chance : this._value.chance;
      }
    }
    return this._cachedChance;
  }
  get hasCooldown() {
    if (this._cachedHasCooldown === undefined) {
      if (this._value.hasCooldown) {
        this._cachedHasCooldown = true;
      } else {
        this._cachedHasCooldown = this._parent ? this._parent.hasCooldown : false;
      }
    }
    return this._cachedHasCooldown;
  }
  get cooldown() {
    if (this._cachedCooldown === undefined) {
      if (this._value.hasCooldown) {
        this._cachedCooldown = this._value.cooldown;
      } else {
        this._cachedCooldown = this._parent ? this._parent.cooldown : this._value.cooldown;
      }
    }
    return this._cachedCooldown;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  get hasFatalOnly() {
    if (this._cachedHasFatalOnly === undefined) {
      if (this._value.hasFatalOnly) {
        this._cachedHasFatalOnly = true;
      } else {
        this._cachedHasFatalOnly = this._parent ? this._parent.hasFatalOnly : false;
      }
    }
    return this._cachedHasFatalOnly;
  }
  get fatalOnly() {
    if (this._cachedFatalOnly === undefined) {
      if (this._value.hasFatalOnly) {
        this._cachedFatalOnly = this._value.fatalOnly;
      } else {
        this._cachedFatalOnly = this._parent ? this._parent.fatalOnly : this._value.fatalOnly;
      }
    }
    return this._cachedFatalOnly;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasDamageModifier() {
    if (this._cachedHasDamageModifier === undefined) {
      if (this._value.hasDamageModifier) {
        this._cachedHasDamageModifier = true;
      } else {
        this._cachedHasDamageModifier = this._parent ? this._parent.hasDamageModifier : false;
      }
    }
    return this._cachedHasDamageModifier;
  }
  get damageModifier() {
    if (!this._cachedDamageModifier) {
      if (this._value.hasDamageModifier) {
        this._cachedDamageModifier = new BehaviorModifier.WithParent(this._value.damageModifier, this._parent && this._parent.hasDamageModifier ? this._parent.damageModifier : null);
      } else {
        this._cachedDamageModifier = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.damageModifier) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedDamageModifier;
  }
  get selfValidators() {
    return this._value.validators;
  }
  get inherentValidators() {
    if (!this._inherentValidators) {
      this._inherentValidators = this._parent ? this._parent.validators : [];
    }
    return this._inherentValidators;
  }
  get validators() {
    if (!this._allValidators) {
      this._allValidators = this._parent ? this._parent.validators.concat(this.selfValidators) : this.selfValidators;
    }
    return this._allValidators;
  }
  get hasChanceModifierPerStack() {
    if (this._cachedHasChanceModifierPerStack === undefined) {
      if (this._value.hasChanceModifierPerStack) {
        this._cachedHasChanceModifierPerStack = true;
      } else {
        this._cachedHasChanceModifierPerStack = this._parent ? this._parent.hasChanceModifierPerStack : false;
      }
    }
    return this._cachedHasChanceModifierPerStack;
  }
  get chanceModifierPerStack() {
    if (!this._cachedChanceModifierPerStack) {
      if (this._value.hasChanceModifierPerStack) {
        this._cachedChanceModifierPerStack = new BehaviorModifier.WithParent(this._value.chanceModifierPerStack, this._parent && this._parent.hasChanceModifierPerStack ? this._parent.chanceModifierPerStack : null);
      } else {
        this._cachedChanceModifierPerStack = this._parent ? new BehaviorModifier.WithParent(BehaviorModifier.default, this._parent.chanceModifierPerStack) : BehaviorModifier.WithParent.default;
      }
    }
    return this._cachedChanceModifierPerStack;
  }
  get hasDamageClampMin() {
    if (this._cachedHasDamageClampMin === undefined) {
      if (this._value.hasDamageClampMin) {
        this._cachedHasDamageClampMin = true;
      } else {
        this._cachedHasDamageClampMin = this._parent ? this._parent.hasDamageClampMin : false;
      }
    }
    return this._cachedHasDamageClampMin;
  }
  get damageClampMin() {
    if (this._cachedDamageClampMin === undefined) {
      if (this._value.hasDamageClampMin) {
        this._cachedDamageClampMin = this._value.damageClampMin;
      } else {
        this._cachedDamageClampMin = this._parent ? this._parent.damageClampMin : this._value.damageClampMin;
      }
    }
    return this._cachedDamageClampMin;
  }
  get hasDamageClampMax() {
    if (this._cachedHasDamageClampMax === undefined) {
      if (this._value.hasDamageClampMax) {
        this._cachedHasDamageClampMax = true;
      } else {
        this._cachedHasDamageClampMax = this._parent ? this._parent.hasDamageClampMax : false;
      }
    }
    return this._cachedHasDamageClampMax;
  }
  get damageClampMax() {
    if (this._cachedDamageClampMax === undefined) {
      if (this._value.hasDamageClampMax) {
        this._cachedDamageClampMax = this._value.damageClampMax;
      } else {
        this._cachedDamageClampMax = this._parent ? this._parent.damageClampMax : this._value.damageClampMax;
      }
    }
    return this._cachedDamageClampMax;
  }
  update(current, parent) {
    const result = new DamageResponse_WithParent(current, parent);
    if (this._cachedDamageModifier && this._value.hasDamageModifier && current.hasDamageModifier) {
      if (this._value.damageModifier === current.damageModifier && this._parent === parent) {
        result._cachedDamageModifier = this._cachedDamageModifier;
      } else {
        result._cachedDamageModifier = this._cachedDamageModifier.update(current.damageModifier, parent && parent.hasDamageModifier ? parent.damageModifier : null);
      }
    }
    if (this._cachedChanceModifierPerStack && this._value.hasChanceModifierPerStack && current.hasChanceModifierPerStack) {
      if (this._value.chanceModifierPerStack === current.chanceModifierPerStack && this._parent === parent) {
        result._cachedChanceModifierPerStack = this._cachedChanceModifierPerStack;
      } else {
        result._cachedChanceModifierPerStack = this._cachedChanceModifierPerStack.update(current.chanceModifierPerStack, parent && parent.hasChanceModifierPerStack ? parent.chanceModifierPerStack : null);
      }
    }
    return result;
  }
}
DamageResponse_WithParent.default = new DamageResponse_WithParent(DamageResponse.default, null);
DamageResponse.WithParent = DamageResponse_WithParent;
class DamageResponse_Descriptor {
  get chance() {
    if (!this._chance) {
      this._chance = {
        name: "chance",
        Name: "Chance",
        number: 1,
        protoType: 1,
        protoName: "chance",
        type: JsonToDouble,
        options: {
          comments: "The chance that the damage response will occur. If 0, the damage response will never be triggered. If 1 the damage response will always be triggered.",
          propertyRange: "0, 1",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chance;
  }
  get cooldown() {
    if (!this._cooldown) {
      this._cooldown = {
        name: "cooldown",
        Name: "Cooldown",
        number: 2,
        protoType: 1,
        protoName: "cooldown",
        type: JsonToDouble,
        options: {
          comments: "The duration (in seconds) the damage response has to wait before it has a Chance of occurring again.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cooldown;
  }
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 3,
        protoType: 14,
        protoName: "location",
        type: DamageResponse_LocationType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get fatalOnly() {
    if (!this._fatalOnly) {
      this._fatalOnly = {
        name: "fatalOnly",
        Name: "FatalOnly",
        number: 4,
        protoType: 8,
        protoName: "fatal_only",
        type: JsonToBoolean,
        options: {
          comments: "If enabled, the damage response only occurs when taking or dealing fatal damage.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fatalOnly;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 5,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect is created when the damage response succeeds.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get damageModifier() {
    if (!this._damageModifier) {
      this._damageModifier = {
        name: "damageModifier",
        Name: "DamageModifier",
        number: 6,
        protoType: 11,
        protoName: "damage_modifier",
        type: BehaviorModifier,
        options: {
          comments: "The damage that triggered the damage response is modified by these values when the damage response succeeds.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageModifier;
  }
  get validators() {
    if (!this._validators) {
      this._validators = {
        name: "validators",
        Name: "Validators",
        number: 7,
        protoType: 9,
        protoName: "validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "These validators must succeed when the damage response is triggered for the damage response to be executed.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validators;
  }
  get chanceModifierPerStack() {
    if (!this._chanceModifierPerStack) {
      this._chanceModifierPerStack = {
        name: "chanceModifierPerStack",
        Name: "ChanceModifierPerStack",
        number: 8,
        protoType: 11,
        protoName: "chance_modifier_per_stack",
        type: BehaviorModifier,
        options: {
          comments: "Modifies the damage responses chance per stack of the behavior on the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chanceModifierPerStack;
  }
  get damageClampMin() {
    if (!this._damageClampMin) {
      this._damageClampMin = {
        name: "damageClampMin",
        Name: "DamageClampMin",
        number: 9,
        protoType: 1,
        protoName: "damage_clamp_min",
        type: JsonToDouble,
        options: {
          comments: "If set, any damage below this amount will be adjusted to this amount when the damage response is triggered.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageClampMin;
  }
  get damageClampMax() {
    if (!this._damageClampMax) {
      this._damageClampMax = {
        name: "damageClampMax",
        Name: "DamageClampMax",
        number: 10,
        protoType: 1,
        protoName: "damage_clamp_max",
        type: JsonToDouble,
        options: {
          comments: "If set, any damage above this amount will be adjusted to this amount when the damage response is triggered.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageClampMax;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.chance,
        this.cooldown,
        this.location,
        this.fatalOnly,
        this.effect,
        this.damageModifier,
        this.validators,
        this.chanceModifierPerStack,
        this.damageClampMin,
        this.damageClampMax,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForChance",
        Name: "DummyOneofForChance",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCooldown",
        Name: "DummyOneofForCooldown",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFatalOnly",
        Name: "DummyOneofForFatalOnly",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageModifier",
        Name: "DummyOneofForDamageModifier",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChanceModifierPerStack",
        Name: "DummyOneofForChanceModifierPerStack",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageClampMin",
        Name: "DummyOneofForDamageClampMin",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageClampMax",
        Name: "DummyOneofForDamageClampMax",
        fields: [
          this.fields[9],
        ],
      });
    }
    return this._oneofs;
  }
}
DamageResponse.descriptor = new DamageResponse_Descriptor();
export class DeathResponse {
  get descriptor() {
    return DeathResponse.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasChance = false;
    this._chance = null;
    this._hasEffect = false;
    this._effect = null;
    this._hasTargetType = false;
    this._targetType = null;
  }
  isEmpty() {
    if (this._hasChance) return false;
    if (this._hasEffect) return false;
    if (this._hasTargetType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DeathResponse) {
      return value;
    }
    return DeathResponse.fromJson(value);
  }
  static fromJson(json) {
    const result = new DeathResponse();
    if (json.chance != null) {
      result._hasChance = true;
      result._chance = JsonToDouble.fromJson(json.chance);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.targetType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasChance) {
      result.chance = JsonToDouble.toJson(this._chance);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasTargetType) {
      result.targetType = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._targetType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get chance() {
    return this._hasChance ? this._chance : JsonToDouble.default;
  }
  get hasChance() {
    return this._hasChance;
  }
  setChance(path, value) {
    return {type: 'SET', path: path.concat(['chance']), value};
  }
  deleteChance(path) {
    return {type: 'DELETE', path: path.concat(['chance'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "chance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DeathResponse(this);
              copy._hasChance = true;
              copy._chance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChance) {
                return this;
              }
              const copy = new DeathResponse(this);
              copy._hasChance = false;
              copy._chance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DeathResponse(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new DeathResponse(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DeathResponse(this);
              copy._hasTargetType = true;
              copy._targetType = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new DeathResponse(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DeathResponse} other
   * @returns {DeathResponse}
   */
  merge(other) {
    const copy = new DeathResponse(this);
    if (other._hasChance) {
      copy._hasChance = true;
      copy._chance = other._chance;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasTargetType) {
      copy._hasTargetType = true;
      copy._targetType = other._targetType;
    }
    return copy;
  }
}
DeathResponse.default = new DeathResponse();
class DeathResponse_Builder {
  constructor(value) {
    this._value = new DeathResponse(value);
  }
  build() {
    return new DeathResponse(this._value);
  }
  setChance(value) {
    this._value._hasChance = true;
    this._value._chance = value;
    return this;
  }
  deleteChance() {
    this._value._hasChance = false;
    this._value._chance = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
}
DeathResponse.Builder = DeathResponse_Builder;
class DeathResponse_WithParent {
  /**
   * @param {DeathResponse} value
   * @param {DeathResponse_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DeathResponse.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasChance() {
    if (this._cachedHasChance === undefined) {
      if (this._value.hasChance) {
        this._cachedHasChance = true;
      } else {
        this._cachedHasChance = this._parent ? this._parent.hasChance : false;
      }
    }
    return this._cachedHasChance;
  }
  get chance() {
    if (this._cachedChance === undefined) {
      if (this._value.hasChance) {
        this._cachedChance = this._value.chance;
      } else {
        this._cachedChance = this._parent ? this._parent.chance : this._value.chance;
      }
    }
    return this._cachedChance;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (this._cachedTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = this._value.targetType;
      } else {
        this._cachedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedTargetType;
  }
  update(current, parent) {
    const result = new DeathResponse_WithParent(current, parent);
    return result;
  }
}
DeathResponse_WithParent.default = new DeathResponse_WithParent(DeathResponse.default, null);
DeathResponse.WithParent = DeathResponse_WithParent;
class DeathResponse_Descriptor {
  get chance() {
    if (!this._chance) {
      this._chance = {
        name: "chance",
        Name: "Chance",
        number: 1,
        protoType: 1,
        protoName: "chance",
        type: JsonToDouble,
        options: {
          comments: "The chance that the death response will occur. If 0, the death response will never be triggered. If 1 the death response will always be triggered.",
          propertyRange: "0, 1",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chance;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 2,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect created by the death response.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 3,
        protoType: 14,
        protoName: "target_type",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "The location where the death response occurs. In this context Caster/Source refers to the killing unit and Target refers to this unit.",
          default: "SOURCE_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.chance,
        this.effect,
        this.targetType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForChance",
        Name: "DummyOneofForChance",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
DeathResponse.descriptor = new DeathResponse_Descriptor();
class Behavior_TagItem {
  get descriptor() {
    return Behavior_TagItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasCount = false;
    this._count = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Behavior_TagItem) {
      return value;
    }
    return Behavior_TagItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new Behavior_TagItem();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.count != null) {
      result._hasCount = true;
      result._count = JsonToInt32.fromJson(json.count);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasCount) {
      result.count = JsonToInt32.toJson(this._count);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get count() {
    return this._hasCount ? this._count : JsonToInt32.default;
  }
  get hasCount() {
    return this._hasCount;
  }
  setCount(path, value) {
    return {type: 'SET', path: path.concat(['count']), value};
  }
  deleteCount(path) {
    return {type: 'DELETE', path: path.concat(['count'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior_TagItem(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new Behavior_TagItem(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "count": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior_TagItem(this);
              copy._hasCount = true;
              copy._count = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCount) {
                return this;
              }
              const copy = new Behavior_TagItem(this);
              copy._hasCount = false;
              copy._count = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Behavior_TagItem} other
   * @returns {Behavior_TagItem}
   */
  merge(other) {
    const copy = new Behavior_TagItem(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasCount) {
      copy._hasCount = true;
      copy._count = other._count;
    }
    return copy;
  }
}
Behavior_TagItem.default = new Behavior_TagItem();
class Behavior_TagItem_Builder {
  constructor(value) {
    this._value = new Behavior_TagItem(value);
  }
  build() {
    return new Behavior_TagItem(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setCount(value) {
    this._value._hasCount = true;
    this._value._count = value;
    return this;
  }
  deleteCount() {
    this._value._hasCount = false;
    this._value._count = null;
    return this;
  }
}
Behavior_TagItem.Builder = Behavior_TagItem_Builder;
class Behavior_TagItem_WithParent {
  /**
   * @param {Behavior_TagItem} value
   * @param {Behavior_TagItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Behavior_TagItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasCount() {
    if (this._cachedHasCount === undefined) {
      if (this._value.hasCount) {
        this._cachedHasCount = true;
      } else {
        this._cachedHasCount = this._parent ? this._parent.hasCount : false;
      }
    }
    return this._cachedHasCount;
  }
  get count() {
    if (this._cachedCount === undefined) {
      if (this._value.hasCount) {
        this._cachedCount = this._value.count;
      } else {
        this._cachedCount = this._parent ? this._parent.count : this._value.count;
      }
    }
    return this._cachedCount;
  }
  update(current, parent) {
    const result = new Behavior_TagItem_WithParent(current, parent);
    return result;
  }
}
Behavior_TagItem_WithParent.default = new Behavior_TagItem_WithParent(Behavior_TagItem.default, null);
Behavior_TagItem.WithParent = Behavior_TagItem_WithParent;
class Behavior_TagItem_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get count() {
    if (!this._count) {
      this._count = {
        name: "count",
        Name: "Count",
        number: 2,
        protoType: 5,
        protoName: "count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._count;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.count,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCount",
        Name: "DummyOneofForCount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Behavior_TagItem.descriptor = new Behavior_TagItem_Descriptor();
class Behavior_UnitModifier {
  get descriptor() {
    return Behavior_UnitModifier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOwnership = false;
    this._ownership = null;
    this._hasTargetBehaviorType = false;
    this._targetBehaviorType = null;
  }
  isEmpty() {
    if (this._hasOwnership) return false;
    if (this._hasTargetBehaviorType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Behavior_UnitModifier) {
      return value;
    }
    return Behavior_UnitModifier.fromJson(value);
  }
  static fromJson(json) {
    const result = new Behavior_UnitModifier();
    if (json.ownership != null) {
      result._hasOwnership = true;
      result._ownership = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.ownership);
    }
    if (json.targetBehaviorType != null) {
      result._hasTargetBehaviorType = true;
      result._targetBehaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.fromJson(json.targetBehaviorType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOwnership) {
      result.ownership = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._ownership);
    }
    if (this._hasTargetBehaviorType) {
      result.targetBehaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.toJson(this._targetBehaviorType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get ownership() {
    return this._hasOwnership ? this._ownership : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasOwnership() {
    return this._hasOwnership;
  }
  setOwnership(path, value) {
    return {type: 'SET', path: path.concat(['ownership']), value};
  }
  deleteOwnership(path) {
    return {type: 'DELETE', path: path.concat(['ownership'])};
  }
  /**
   * @returns {number}
   */
  get targetBehaviorType() {
    return this._hasTargetBehaviorType ? this._targetBehaviorType : dcei_engine_unit_proto.BehaviorComponent.BehaviorType.default;
  }
  get hasTargetBehaviorType() {
    return this._hasTargetBehaviorType;
  }
  setTargetBehaviorType(path, value) {
    return {type: 'SET', path: path.concat(['targetBehaviorType']), value};
  }
  deleteTargetBehaviorType(path) {
    return {type: 'DELETE', path: path.concat(['targetBehaviorType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "ownership": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior_UnitModifier(this);
              copy._hasOwnership = true;
              copy._ownership = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOwnership) {
                return this;
              }
              const copy = new Behavior_UnitModifier(this);
              copy._hasOwnership = false;
              copy._ownership = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetBehaviorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior_UnitModifier(this);
              copy._hasTargetBehaviorType = true;
              copy._targetBehaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetBehaviorType) {
                return this;
              }
              const copy = new Behavior_UnitModifier(this);
              copy._hasTargetBehaviorType = false;
              copy._targetBehaviorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Behavior_UnitModifier} other
   * @returns {Behavior_UnitModifier}
   */
  merge(other) {
    const copy = new Behavior_UnitModifier(this);
    if (other._hasOwnership) {
      copy._hasOwnership = true;
      copy._ownership = other._ownership;
    }
    if (other._hasTargetBehaviorType) {
      copy._hasTargetBehaviorType = true;
      copy._targetBehaviorType = other._targetBehaviorType;
    }
    return copy;
  }
}
Behavior_UnitModifier.default = new Behavior_UnitModifier();
class Behavior_UnitModifier_Builder {
  constructor(value) {
    this._value = new Behavior_UnitModifier(value);
  }
  build() {
    return new Behavior_UnitModifier(this._value);
  }
  setOwnership(value) {
    this._value._hasOwnership = true;
    this._value._ownership = value;
    return this;
  }
  deleteOwnership() {
    this._value._hasOwnership = false;
    this._value._ownership = null;
    return this;
  }
  setTargetBehaviorType(value) {
    this._value._hasTargetBehaviorType = true;
    this._value._targetBehaviorType = value;
    return this;
  }
  deleteTargetBehaviorType() {
    this._value._hasTargetBehaviorType = false;
    this._value._targetBehaviorType = null;
    return this;
  }
}
Behavior_UnitModifier.Builder = Behavior_UnitModifier_Builder;
class Behavior_UnitModifier_WithParent {
  /**
   * @param {Behavior_UnitModifier} value
   * @param {Behavior_UnitModifier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Behavior_UnitModifier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOwnership() {
    if (this._cachedHasOwnership === undefined) {
      if (this._value.hasOwnership) {
        this._cachedHasOwnership = true;
      } else {
        this._cachedHasOwnership = this._parent ? this._parent.hasOwnership : false;
      }
    }
    return this._cachedHasOwnership;
  }
  get ownership() {
    if (this._cachedOwnership === undefined) {
      if (this._value.hasOwnership) {
        this._cachedOwnership = this._value.ownership;
      } else {
        this._cachedOwnership = this._parent ? this._parent.ownership : this._value.ownership;
      }
    }
    return this._cachedOwnership;
  }
  get hasTargetBehaviorType() {
    if (this._cachedHasTargetBehaviorType === undefined) {
      if (this._value.hasTargetBehaviorType) {
        this._cachedHasTargetBehaviorType = true;
      } else {
        this._cachedHasTargetBehaviorType = this._parent ? this._parent.hasTargetBehaviorType : false;
      }
    }
    return this._cachedHasTargetBehaviorType;
  }
  get targetBehaviorType() {
    if (this._cachedTargetBehaviorType === undefined) {
      if (this._value.hasTargetBehaviorType) {
        this._cachedTargetBehaviorType = this._value.targetBehaviorType;
      } else {
        this._cachedTargetBehaviorType = this._parent ? this._parent.targetBehaviorType : this._value.targetBehaviorType;
      }
    }
    return this._cachedTargetBehaviorType;
  }
  update(current, parent) {
    const result = new Behavior_UnitModifier_WithParent(current, parent);
    return result;
  }
}
Behavior_UnitModifier_WithParent.default = new Behavior_UnitModifier_WithParent(Behavior_UnitModifier.default, null);
Behavior_UnitModifier.WithParent = Behavior_UnitModifier_WithParent;
class Behavior_UnitModifier_Descriptor {
  get ownership() {
    if (!this._ownership) {
      this._ownership = {
        name: "ownership",
        Name: "Ownership",
        number: 1,
        protoType: 14,
        protoName: "ownership",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Used to change the owner of a unit. You typically want to use caster unit or source unit for charm behaviors.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ownership;
  }
  get targetBehaviorType() {
    if (!this._targetBehaviorType) {
      this._targetBehaviorType = {
        name: "targetBehaviorType",
        Name: "TargetBehaviorType",
        number: 2,
        protoType: 14,
        protoName: "target_behavior_type",
        type: dcei_engine_unit_proto.BehaviorComponent.BehaviorType,
        options: {
          comments: "Used to change the unit\'s AI behavior type.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetBehaviorType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.ownership,
        this.targetBehaviorType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOwnership",
        Name: "DummyOneofForOwnership",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetBehaviorType",
        Name: "DummyOneofForTargetBehaviorType",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Behavior_UnitModifier.descriptor = new Behavior_UnitModifier_Descriptor();
class Behavior_Alignment {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NEUTRAL": return 0;
        case "POSITIVE": return 1;
        case "NEGATIVE": return 2;
        case "MIXED": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Behavior_Alignment.fromJson(value);
  }
  static fromReact(e) {
    return Behavior_Alignment.fromJson(e);
  }
}
Behavior_Alignment.NEUTRAL = 0;
Behavior_Alignment.POSITIVE = 1;
Behavior_Alignment.NEGATIVE = 2;
Behavior_Alignment.MIXED = 3;
Behavior_Alignment.default = 0;
Behavior_Alignment.values = {
  NEUTRAL: 0,
  POSITIVE: 1,
  NEGATIVE: 2,
  MIXED: 3,
};
Behavior_Alignment.names = {
  0: "NEUTRAL",
  1: "POSITIVE",
  2: "NEGATIVE",
  3: "MIXED",
};
export class Behavior {
  get descriptor() {
    return Behavior.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._parent = null;
    this._hasAlignment = false;
    this._alignment = null;
    this._hasRefreshStack = false;
    this._refreshStack = null;
    this._hasMaxStackCount = false;
    this._maxStackCount = null;
    this._hasUpdateDurationWhileDisabled = false;
    this._updateDurationWhileDisabled = null;
    this._hasDurationRandomAddition = false;
    this._durationRandomAddition = null;
    this._hasUnitModifier = false;
    this._unitModifier = null;
    this._hasDuration = false;
    this._duration = null;
    this._hasStacksRemovedOnExpire = false;
    this._stacksRemovedOnExpire = null;
    this._hasStartEffect = false;
    this._startEffect = null;
    this._hasFinalEffect = false;
    this._finalEffect = null;
    this._hasRefreshEffect = false;
    this._refreshEffect = null;
    this._hasExpireEffect = false;
    this._expireEffect = null;
    this._hasPeriodicInterval = false;
    this._periodicInterval = null;
    this._periodicIntervalExpressions = [];
    this._hasPeriodicEffect = false;
    this._periodicEffect = null;
    this._hasPeriodicEffectCount = false;
    this._periodicEffectCount = null;
    this._behaviorTagList = [];
    this._behaviorValidatorsApply = [];
    this._behaviorValidatorsRemove = [];
    this._behaviorValidatorsDisable = [];
    this._hasModifiers = false;
    this._modifiers = null;
    this._hasDamageResponse = false;
    this._damageResponse = null;
    this._hasDeathResponse = false;
    this._deathResponse = null;
    this._behaviorTagArray = [];
    this._hasPersistThroughMorph = false;
    this._persistThroughMorph = null;
    this._hasLocked = false;
    this._disabled = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._hasAlignment) return false;
    if (this._hasRefreshStack) return false;
    if (this._hasMaxStackCount) return false;
    if (this._hasUpdateDurationWhileDisabled) return false;
    if (this._hasDurationRandomAddition) return false;
    if (this._hasUnitModifier && !this._unitModifier.isEmpty()) return false;
    if (this._hasDuration) return false;
    if (this._hasStacksRemovedOnExpire) return false;
    if (this._hasStartEffect) return false;
    if (this._hasFinalEffect) return false;
    if (this._hasRefreshEffect) return false;
    if (this._hasExpireEffect) return false;
    if (this._hasPeriodicInterval) return false;
    if (this._periodicIntervalExpressions.length > 0) return false;
    if (this._hasPeriodicEffect) return false;
    if (this._hasPeriodicEffectCount) return false;
    if (this._behaviorTagList.length > 0) return false;
    if (this._behaviorValidatorsApply.length > 0) return false;
    if (this._behaviorValidatorsRemove.length > 0) return false;
    if (this._behaviorValidatorsDisable.length > 0) return false;
    if (this._hasModifiers && !this._modifiers.isEmpty()) return false;
    if (this._hasDamageResponse && !this._damageResponse.isEmpty()) return false;
    if (this._hasDeathResponse && !this._deathResponse.isEmpty()) return false;
    if (this._behaviorTagArray.length > 0) return false;
    if (this._hasPersistThroughMorph) return false;
    if (this._hasLocked) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Behavior) {
      return value;
    }
    return Behavior.fromJson(value);
  }
  static fromJson(json) {
    const result = new Behavior();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.parent != null) {
      result._hasParent = true;
      result._parent = JsonToString.fromJson(json.parent);
    }
    if (json.alignment != null) {
      result._hasAlignment = true;
      result._alignment = Behavior_Alignment.fromJson(json.alignment);
    }
    if (json.refreshStack != null) {
      result._hasRefreshStack = true;
      result._refreshStack = JsonToBoolean.fromJson(json.refreshStack);
    }
    if (json.maxStackCount != null) {
      result._hasMaxStackCount = true;
      result._maxStackCount = JsonToInt32.fromJson(json.maxStackCount);
    }
    if (json.updateDurationWhileDisabled != null) {
      result._hasUpdateDurationWhileDisabled = true;
      result._updateDurationWhileDisabled = JsonToBoolean.fromJson(json.updateDurationWhileDisabled);
    }
    if (json.durationRandomAddition != null) {
      result._hasDurationRandomAddition = true;
      result._durationRandomAddition = JsonToDouble.fromJson(json.durationRandomAddition);
    }
    if (json.unitModifier != null) {
      result._hasUnitModifier = true;
      result._unitModifier = Behavior_UnitModifier.fromJson(json.unitModifier);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.stacksRemovedOnExpire != null) {
      result._hasStacksRemovedOnExpire = true;
      result._stacksRemovedOnExpire = JsonToInt32.fromJson(json.stacksRemovedOnExpire);
    }
    if (json.startEffect != null) {
      result._hasStartEffect = true;
      result._startEffect = JsonToString.fromJson(json.startEffect);
    }
    if (json.finalEffect != null) {
      result._hasFinalEffect = true;
      result._finalEffect = JsonToString.fromJson(json.finalEffect);
    }
    if (json.refreshEffect != null) {
      result._hasRefreshEffect = true;
      result._refreshEffect = JsonToString.fromJson(json.refreshEffect);
    }
    if (json.expireEffect != null) {
      result._hasExpireEffect = true;
      result._expireEffect = JsonToString.fromJson(json.expireEffect);
    }
    if (json.periodicInterval != null) {
      result._hasPeriodicInterval = true;
      result._periodicInterval = JsonToDouble.fromJson(json.periodicInterval);
    }
    result._periodicIntervalExpressions = JsonToList(json.periodicIntervalExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.periodicEffect != null) {
      result._hasPeriodicEffect = true;
      result._periodicEffect = JsonToString.fromJson(json.periodicEffect);
    }
    if (json.periodicEffectCount != null) {
      result._hasPeriodicEffectCount = true;
      result._periodicEffectCount = JsonToInt32.fromJson(json.periodicEffectCount);
    }
    result._behaviorTagList = JsonToList(json.behaviorTagList, JsonToString);
    result._behaviorValidatorsApply = JsonToList(json.behaviorValidatorsApply, JsonToString);
    result._behaviorValidatorsRemove = JsonToList(json.behaviorValidatorsRemove, JsonToString);
    result._behaviorValidatorsDisable = JsonToList(json.behaviorValidatorsDisable, JsonToString);
    if (json.modifiers != null) {
      result._hasModifiers = true;
      result._modifiers = BehaviorModifiers.fromJson(json.modifiers);
    }
    if (json.damageResponse != null) {
      result._hasDamageResponse = true;
      result._damageResponse = DamageResponse.fromJson(json.damageResponse);
    }
    if (json.deathResponse != null) {
      result._hasDeathResponse = true;
      result._deathResponse = DeathResponse.fromJson(json.deathResponse);
    }
    result._behaviorTagArray = JsonToList(json.behaviorTagArray, Behavior_TagItem);
    if (json.persistThroughMorph != null) {
      result._hasPersistThroughMorph = true;
      result._persistThroughMorph = JsonToBoolean.fromJson(json.persistThroughMorph);
    }
    if (json.disabled != null) {
      result._hasLocked = true;
      result._disabled = JsonToBoolean.fromJson(json.disabled);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.parent = JsonToString.toJson(this._parent);
    }
    if (this._hasAlignment) {
      result.alignment = Behavior_Alignment.toJson(this._alignment);
    }
    if (this._hasRefreshStack) {
      result.refreshStack = JsonToBoolean.toJson(this._refreshStack);
    }
    if (this._hasMaxStackCount) {
      result.maxStackCount = JsonToInt32.toJson(this._maxStackCount);
    }
    if (this._hasUpdateDurationWhileDisabled) {
      result.updateDurationWhileDisabled = JsonToBoolean.toJson(this._updateDurationWhileDisabled);
    }
    if (this._hasDurationRandomAddition) {
      result.durationRandomAddition = JsonToDouble.toJson(this._durationRandomAddition);
    }
    if (this._hasUnitModifier && !this._unitModifier.isEmpty()) {
      result.unitModifier = Behavior_UnitModifier.toJson(this._unitModifier);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasStacksRemovedOnExpire) {
      result.stacksRemovedOnExpire = JsonToInt32.toJson(this._stacksRemovedOnExpire);
    }
    if (this._hasStartEffect) {
      result.startEffect = JsonToString.toJson(this._startEffect);
    }
    if (this._hasFinalEffect) {
      result.finalEffect = JsonToString.toJson(this._finalEffect);
    }
    if (this._hasRefreshEffect) {
      result.refreshEffect = JsonToString.toJson(this._refreshEffect);
    }
    if (this._hasExpireEffect) {
      result.expireEffect = JsonToString.toJson(this._expireEffect);
    }
    if (this._hasPeriodicInterval) {
      result.periodicInterval = JsonToDouble.toJson(this._periodicInterval);
    }
    if (this._periodicIntervalExpressions.length > 0) {
      result.periodicIntervalExpressions = ArrayToJson(this._periodicIntervalExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasPeriodicEffect) {
      result.periodicEffect = JsonToString.toJson(this._periodicEffect);
    }
    if (this._hasPeriodicEffectCount) {
      result.periodicEffectCount = JsonToInt32.toJson(this._periodicEffectCount);
    }
    if (this._behaviorTagList.length > 0) {
      result.behaviorTagList = ArrayToJson(this._behaviorTagList, JsonToString);
    }
    if (this._behaviorValidatorsApply.length > 0) {
      result.behaviorValidatorsApply = ArrayToJson(this._behaviorValidatorsApply, JsonToString);
    }
    if (this._behaviorValidatorsRemove.length > 0) {
      result.behaviorValidatorsRemove = ArrayToJson(this._behaviorValidatorsRemove, JsonToString);
    }
    if (this._behaviorValidatorsDisable.length > 0) {
      result.behaviorValidatorsDisable = ArrayToJson(this._behaviorValidatorsDisable, JsonToString);
    }
    if (this._hasModifiers && !this._modifiers.isEmpty()) {
      result.modifiers = BehaviorModifiers.toJson(this._modifiers);
    }
    if (this._hasDamageResponse && !this._damageResponse.isEmpty()) {
      result.damageResponse = DamageResponse.toJson(this._damageResponse);
    }
    if (this._hasDeathResponse && !this._deathResponse.isEmpty()) {
      result.deathResponse = DeathResponse.toJson(this._deathResponse);
    }
    if (this._behaviorTagArray.length > 0) {
      result.behaviorTagArray = ArrayToJson(this._behaviorTagArray, Behavior_TagItem);
    }
    if (this._hasPersistThroughMorph) {
      result.persistThroughMorph = JsonToBoolean.toJson(this._persistThroughMorph);
    }
    if (this._hasLocked) {
      result.disabled = JsonToBoolean.toJson(this._disabled);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get parent() {
    return this._hasParent ? this._parent : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['parent']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['parent'])};
  }
  /**
   * @returns {number}
   */
  get alignment() {
    return this._hasAlignment ? this._alignment : Behavior_Alignment.default;
  }
  get hasAlignment() {
    return this._hasAlignment;
  }
  setAlignment(path, value) {
    return {type: 'SET', path: path.concat(['alignment']), value};
  }
  deleteAlignment(path) {
    return {type: 'DELETE', path: path.concat(['alignment'])};
  }
  /**
   * @returns {boolean}
   */
  get refreshStack() {
    return this._hasRefreshStack ? this._refreshStack : JsonToBoolean.default;
  }
  get hasRefreshStack() {
    return this._hasRefreshStack;
  }
  setRefreshStack(path, value) {
    return {type: 'SET', path: path.concat(['refreshStack']), value};
  }
  deleteRefreshStack(path) {
    return {type: 'DELETE', path: path.concat(['refreshStack'])};
  }
  /**
   * @returns {number}
   */
  get maxStackCount() {
    return this._hasMaxStackCount ? this._maxStackCount : JsonToInt32.default;
  }
  get hasMaxStackCount() {
    return this._hasMaxStackCount;
  }
  setMaxStackCount(path, value) {
    return {type: 'SET', path: path.concat(['maxStackCount']), value};
  }
  deleteMaxStackCount(path) {
    return {type: 'DELETE', path: path.concat(['maxStackCount'])};
  }
  /**
   * @returns {boolean}
   */
  get updateDurationWhileDisabled() {
    return this._hasUpdateDurationWhileDisabled ? this._updateDurationWhileDisabled : JsonToBoolean.default;
  }
  get hasUpdateDurationWhileDisabled() {
    return this._hasUpdateDurationWhileDisabled;
  }
  setUpdateDurationWhileDisabled(path, value) {
    return {type: 'SET', path: path.concat(['updateDurationWhileDisabled']), value};
  }
  deleteUpdateDurationWhileDisabled(path) {
    return {type: 'DELETE', path: path.concat(['updateDurationWhileDisabled'])};
  }
  /**
   * @returns {number}
   */
  get durationRandomAddition() {
    return this._hasDurationRandomAddition ? this._durationRandomAddition : JsonToDouble.default;
  }
  get hasDurationRandomAddition() {
    return this._hasDurationRandomAddition;
  }
  setDurationRandomAddition(path, value) {
    return {type: 'SET', path: path.concat(['durationRandomAddition']), value};
  }
  deleteDurationRandomAddition(path) {
    return {type: 'DELETE', path: path.concat(['durationRandomAddition'])};
  }
  /**
   * @returns {Behavior_UnitModifier}
   */
  get unitModifier() {
    return this._hasUnitModifier ? this._unitModifier : Behavior_UnitModifier.default;
  }
  get hasUnitModifier() {
    return this._hasUnitModifier;
  }
  setUnitModifier(path, value) {
    return {type: 'SET', path: path.concat(['unitModifier']), value: value.toJson()};
  }
  deleteUnitModifier(path) {
    return {type: 'DELETE', path: path.concat(['unitModifier'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {number}
   */
  get stacksRemovedOnExpire() {
    return this._hasStacksRemovedOnExpire ? this._stacksRemovedOnExpire : JsonToInt32.default;
  }
  get hasStacksRemovedOnExpire() {
    return this._hasStacksRemovedOnExpire;
  }
  setStacksRemovedOnExpire(path, value) {
    return {type: 'SET', path: path.concat(['stacksRemovedOnExpire']), value};
  }
  deleteStacksRemovedOnExpire(path) {
    return {type: 'DELETE', path: path.concat(['stacksRemovedOnExpire'])};
  }
  /**
   * @returns {string}
   */
  get startEffect() {
    return this._hasStartEffect ? this._startEffect : JsonToString.default;
  }
  get hasStartEffect() {
    return this._hasStartEffect;
  }
  setStartEffect(path, value) {
    return {type: 'SET', path: path.concat(['startEffect']), value};
  }
  deleteStartEffect(path) {
    return {type: 'DELETE', path: path.concat(['startEffect'])};
  }
  /**
   * @returns {string}
   */
  get finalEffect() {
    return this._hasFinalEffect ? this._finalEffect : JsonToString.default;
  }
  get hasFinalEffect() {
    return this._hasFinalEffect;
  }
  setFinalEffect(path, value) {
    return {type: 'SET', path: path.concat(['finalEffect']), value};
  }
  deleteFinalEffect(path) {
    return {type: 'DELETE', path: path.concat(['finalEffect'])};
  }
  /**
   * @returns {string}
   */
  get refreshEffect() {
    return this._hasRefreshEffect ? this._refreshEffect : JsonToString.default;
  }
  get hasRefreshEffect() {
    return this._hasRefreshEffect;
  }
  setRefreshEffect(path, value) {
    return {type: 'SET', path: path.concat(['refreshEffect']), value};
  }
  deleteRefreshEffect(path) {
    return {type: 'DELETE', path: path.concat(['refreshEffect'])};
  }
  /**
   * @returns {string}
   */
  get expireEffect() {
    return this._hasExpireEffect ? this._expireEffect : JsonToString.default;
  }
  get hasExpireEffect() {
    return this._hasExpireEffect;
  }
  setExpireEffect(path, value) {
    return {type: 'SET', path: path.concat(['expireEffect']), value};
  }
  deleteExpireEffect(path) {
    return {type: 'DELETE', path: path.concat(['expireEffect'])};
  }
  /**
   * @returns {number}
   */
  get periodicInterval() {
    return this._hasPeriodicInterval ? this._periodicInterval : JsonToDouble.default;
  }
  get hasPeriodicInterval() {
    return this._hasPeriodicInterval;
  }
  setPeriodicInterval(path, value) {
    return {type: 'SET', path: path.concat(['periodicInterval']), value};
  }
  deletePeriodicInterval(path) {
    return {type: 'DELETE', path: path.concat(['periodicInterval'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get periodicIntervalExpressions() {
    return this._periodicIntervalExpressions;
  }
  addPeriodicIntervalExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['periodicIntervalExpressions']), value: value.toJson()};
  }
  setPeriodicIntervalExpressions(path, value) {
    return {type: 'SET', path: path.concat(['periodicIntervalExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setPeriodicIntervalExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['periodicIntervalExpressions', key]), value: value.toJson()};
  }
  deletePeriodicIntervalExpressions(path) {
    return {type: 'DELETE', path: path.concat(['periodicIntervalExpressions'])};
  }
  deletePeriodicIntervalExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['periodicIntervalExpressions', key])};
  }
  /**
   * @returns {string}
   */
  get periodicEffect() {
    return this._hasPeriodicEffect ? this._periodicEffect : JsonToString.default;
  }
  get hasPeriodicEffect() {
    return this._hasPeriodicEffect;
  }
  setPeriodicEffect(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffect']), value};
  }
  deletePeriodicEffect(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffect'])};
  }
  /**
   * @returns {number}
   */
  get periodicEffectCount() {
    return this._hasPeriodicEffectCount ? this._periodicEffectCount : JsonToInt32.default;
  }
  get hasPeriodicEffectCount() {
    return this._hasPeriodicEffectCount;
  }
  setPeriodicEffectCount(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffectCount']), value};
  }
  deletePeriodicEffectCount(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffectCount'])};
  }
  /**
   * @returns {string[]}
   */
  get behaviorTagList() {
    return this._behaviorTagList;
  }
  addBehaviorTagList(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorTagList']), value};
  }
  setBehaviorTagList(path, value) {
    return {type: 'SET', path: path.concat(['behaviorTagList']), value: ArrayToJson(value, JsonToString)};
  }
  setBehaviorTagListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorTagList', key]), value};
  }
  deleteBehaviorTagList(path) {
    return {type: 'DELETE', path: path.concat(['behaviorTagList'])};
  }
  deleteBehaviorTagListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorTagList', key])};
  }
  /**
   * @returns {string[]}
   */
  get behaviorValidatorsApply() {
    return this._behaviorValidatorsApply;
  }
  addBehaviorValidatorsApply(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorValidatorsApply']), value};
  }
  setBehaviorValidatorsApply(path, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsApply']), value: ArrayToJson(value, JsonToString)};
  }
  setBehaviorValidatorsApplyByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsApply', key]), value};
  }
  deleteBehaviorValidatorsApply(path) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsApply'])};
  }
  deleteBehaviorValidatorsApplyByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsApply', key])};
  }
  /**
   * @returns {string[]}
   */
  get behaviorValidatorsRemove() {
    return this._behaviorValidatorsRemove;
  }
  addBehaviorValidatorsRemove(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorValidatorsRemove']), value};
  }
  setBehaviorValidatorsRemove(path, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsRemove']), value: ArrayToJson(value, JsonToString)};
  }
  setBehaviorValidatorsRemoveByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsRemove', key]), value};
  }
  deleteBehaviorValidatorsRemove(path) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsRemove'])};
  }
  deleteBehaviorValidatorsRemoveByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsRemove', key])};
  }
  /**
   * @returns {string[]}
   */
  get behaviorValidatorsDisable() {
    return this._behaviorValidatorsDisable;
  }
  addBehaviorValidatorsDisable(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorValidatorsDisable']), value};
  }
  setBehaviorValidatorsDisable(path, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsDisable']), value: ArrayToJson(value, JsonToString)};
  }
  setBehaviorValidatorsDisableByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorValidatorsDisable', key]), value};
  }
  deleteBehaviorValidatorsDisable(path) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsDisable'])};
  }
  deleteBehaviorValidatorsDisableByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorValidatorsDisable', key])};
  }
  /**
   * @returns {BehaviorModifiers}
   */
  get modifiers() {
    return this._hasModifiers ? this._modifiers : BehaviorModifiers.default;
  }
  get hasModifiers() {
    return this._hasModifiers;
  }
  setModifiers(path, value) {
    return {type: 'SET', path: path.concat(['modifiers']), value: value.toJson()};
  }
  deleteModifiers(path) {
    return {type: 'DELETE', path: path.concat(['modifiers'])};
  }
  /**
   * @returns {DamageResponse}
   */
  get damageResponse() {
    return this._hasDamageResponse ? this._damageResponse : DamageResponse.default;
  }
  get hasDamageResponse() {
    return this._hasDamageResponse;
  }
  setDamageResponse(path, value) {
    return {type: 'SET', path: path.concat(['damageResponse']), value: value.toJson()};
  }
  deleteDamageResponse(path) {
    return {type: 'DELETE', path: path.concat(['damageResponse'])};
  }
  /**
   * @returns {DeathResponse}
   */
  get deathResponse() {
    return this._hasDeathResponse ? this._deathResponse : DeathResponse.default;
  }
  get hasDeathResponse() {
    return this._hasDeathResponse;
  }
  setDeathResponse(path, value) {
    return {type: 'SET', path: path.concat(['deathResponse']), value: value.toJson()};
  }
  deleteDeathResponse(path) {
    return {type: 'DELETE', path: path.concat(['deathResponse'])};
  }
  /**
   * @returns {Behavior_TagItem[]}
   */
  get behaviorTagArray() {
    return this._behaviorTagArray;
  }
  addBehaviorTagArray(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorTagArray']), value: value.toJson()};
  }
  setBehaviorTagArray(path, value) {
    return {type: 'SET', path: path.concat(['behaviorTagArray']), value: ArrayToJson(value, Behavior_TagItem)};
  }
  setBehaviorTagArrayByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorTagArray', key]), value: value.toJson()};
  }
  deleteBehaviorTagArray(path) {
    return {type: 'DELETE', path: path.concat(['behaviorTagArray'])};
  }
  deleteBehaviorTagArrayByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorTagArray', key])};
  }
  /**
   * @returns {boolean}
   */
  get persistThroughMorph() {
    return this._hasPersistThroughMorph ? this._persistThroughMorph : JsonToBoolean.default;
  }
  get hasPersistThroughMorph() {
    return this._hasPersistThroughMorph;
  }
  setPersistThroughMorph(path, value) {
    return {type: 'SET', path: path.concat(['persistThroughMorph']), value};
  }
  deletePersistThroughMorph(path) {
    return {type: 'DELETE', path: path.concat(['persistThroughMorph'])};
  }
  /**
   * @returns {boolean}
   */
  get disabled() {
    return this._hasLocked ? this._disabled : JsonToBoolean.default;
  }
  get hasLocked() {
    return this._hasLocked;
  }
  setLocked(path, value) {
    return {type: 'SET', path: path.concat(['disabled']), value};
  }
  deleteLocked(path) {
    return {type: 'DELETE', path: path.concat(['disabled'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasParent = true;
              copy._parent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasParent = false;
              copy._parent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "alignment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasAlignment = true;
              copy._alignment = Behavior_Alignment.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlignment) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasAlignment = false;
              copy._alignment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshStack": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasRefreshStack = true;
              copy._refreshStack = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshStack) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasRefreshStack = false;
              copy._refreshStack = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxStackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasMaxStackCount = true;
              copy._maxStackCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxStackCount) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasMaxStackCount = false;
              copy._maxStackCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "updateDurationWhileDisabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasUpdateDurationWhileDisabled = true;
              copy._updateDurationWhileDisabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpdateDurationWhileDisabled) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasUpdateDurationWhileDisabled = false;
              copy._updateDurationWhileDisabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "durationRandomAddition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasDurationRandomAddition = true;
              copy._durationRandomAddition = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationRandomAddition) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasDurationRandomAddition = false;
              copy._durationRandomAddition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasUnitModifier = true;
              copy._unitModifier = Behavior_UnitModifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitModifier) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasUnitModifier = false;
              copy._unitModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitModifier) {
            const copy = new Behavior(this);
            copy._hasUnitModifier = true;
            copy._unitModifier = Behavior_UnitModifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitModifier.apply(type, path.slice(1), value);
          if (newValue === this._unitModifier) {
            return this;
          }
          const copy = new Behavior(this);
          copy._unitModifier = copy._unitModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stacksRemovedOnExpire": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasStacksRemovedOnExpire = true;
              copy._stacksRemovedOnExpire = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStacksRemovedOnExpire) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasStacksRemovedOnExpire = false;
              copy._stacksRemovedOnExpire = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasStartEffect = true;
              copy._startEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartEffect) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasStartEffect = false;
              copy._startEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "finalEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasFinalEffect = true;
              copy._finalEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinalEffect) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasFinalEffect = false;
              copy._finalEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasRefreshEffect = true;
              copy._refreshEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshEffect) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasRefreshEffect = false;
              copy._refreshEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expireEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasExpireEffect = true;
              copy._expireEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpireEffect) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasExpireEffect = false;
              copy._expireEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicInterval": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasPeriodicInterval = true;
              copy._periodicInterval = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicInterval) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasPeriodicInterval = false;
              copy._periodicInterval = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicIntervalExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._periodicIntervalExpressions = [];        for (let i of value) {
                copy._periodicIntervalExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._periodicIntervalExpressions = copy._periodicIntervalExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._periodicIntervalExpressions.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._periodicIntervalExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._periodicIntervalExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._periodicIntervalExpressions = copy._periodicIntervalExpressions.slice();
              copy._periodicIntervalExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._periodicIntervalExpressions = copy._periodicIntervalExpressions.slice(0, path[1]).concat(copy._periodicIntervalExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._periodicIntervalExpressions.length) {
            return this;
          }
          const oldValue = this._periodicIntervalExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._periodicIntervalExpressions = copy._periodicIntervalExpressions.slice();
          copy._periodicIntervalExpressions[key] = newValue;
          return copy;
        }
      }
      case "periodicEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasPeriodicEffect = true;
              copy._periodicEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicEffect) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasPeriodicEffect = false;
              copy._periodicEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicEffectCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasPeriodicEffectCount = true;
              copy._periodicEffectCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicEffectCount) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasPeriodicEffectCount = false;
              copy._periodicEffectCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "behaviorTagList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorTagList = [];        for (let i of value) {
                copy._behaviorTagList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._behaviorTagList = copy._behaviorTagList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorTagList.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._behaviorTagList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorTagList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorTagList = copy._behaviorTagList.slice();
              copy._behaviorTagList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._behaviorTagList = copy._behaviorTagList.slice(0, path[1]).concat(copy._behaviorTagList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorTagList.length) {
            return this;
          }
          const oldValue = this._behaviorTagList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._behaviorTagList = copy._behaviorTagList.slice();
          copy._behaviorTagList[key] = newValue;
          return copy;
        }
      }
      case "behaviorValidatorsApply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsApply = [];        for (let i of value) {
                copy._behaviorValidatorsApply.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsApply = copy._behaviorValidatorsApply.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorValidatorsApply.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._behaviorValidatorsApply = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsApply.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsApply = copy._behaviorValidatorsApply.slice();
              copy._behaviorValidatorsApply[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsApply = copy._behaviorValidatorsApply.slice(0, path[1]).concat(copy._behaviorValidatorsApply.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsApply.length) {
            return this;
          }
          const oldValue = this._behaviorValidatorsApply[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._behaviorValidatorsApply = copy._behaviorValidatorsApply.slice();
          copy._behaviorValidatorsApply[key] = newValue;
          return copy;
        }
      }
      case "behaviorValidatorsRemove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsRemove = [];        for (let i of value) {
                copy._behaviorValidatorsRemove.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsRemove = copy._behaviorValidatorsRemove.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorValidatorsRemove.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._behaviorValidatorsRemove = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsRemove.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsRemove = copy._behaviorValidatorsRemove.slice();
              copy._behaviorValidatorsRemove[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsRemove = copy._behaviorValidatorsRemove.slice(0, path[1]).concat(copy._behaviorValidatorsRemove.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsRemove.length) {
            return this;
          }
          const oldValue = this._behaviorValidatorsRemove[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._behaviorValidatorsRemove = copy._behaviorValidatorsRemove.slice();
          copy._behaviorValidatorsRemove[key] = newValue;
          return copy;
        }
      }
      case "behaviorValidatorsDisable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsDisable = [];        for (let i of value) {
                copy._behaviorValidatorsDisable.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsDisable = copy._behaviorValidatorsDisable.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorValidatorsDisable.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._behaviorValidatorsDisable = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsDisable.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsDisable = copy._behaviorValidatorsDisable.slice();
              copy._behaviorValidatorsDisable[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._behaviorValidatorsDisable = copy._behaviorValidatorsDisable.slice(0, path[1]).concat(copy._behaviorValidatorsDisable.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorValidatorsDisable.length) {
            return this;
          }
          const oldValue = this._behaviorValidatorsDisable[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._behaviorValidatorsDisable = copy._behaviorValidatorsDisable.slice();
          copy._behaviorValidatorsDisable[key] = newValue;
          return copy;
        }
      }
      case "modifiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasModifiers = true;
              copy._modifiers = BehaviorModifiers.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifiers) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasModifiers = false;
              copy._modifiers = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasModifiers) {
            const copy = new Behavior(this);
            copy._hasModifiers = true;
            copy._modifiers = BehaviorModifiers.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._modifiers.apply(type, path.slice(1), value);
          if (newValue === this._modifiers) {
            return this;
          }
          const copy = new Behavior(this);
          copy._modifiers = copy._modifiers.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "damageResponse": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasDamageResponse = true;
              copy._damageResponse = DamageResponse.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageResponse) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasDamageResponse = false;
              copy._damageResponse = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDamageResponse) {
            const copy = new Behavior(this);
            copy._hasDamageResponse = true;
            copy._damageResponse = DamageResponse.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._damageResponse.apply(type, path.slice(1), value);
          if (newValue === this._damageResponse) {
            return this;
          }
          const copy = new Behavior(this);
          copy._damageResponse = copy._damageResponse.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "deathResponse": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasDeathResponse = true;
              copy._deathResponse = DeathResponse.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeathResponse) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasDeathResponse = false;
              copy._deathResponse = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeathResponse) {
            const copy = new Behavior(this);
            copy._hasDeathResponse = true;
            copy._deathResponse = DeathResponse.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._deathResponse.apply(type, path.slice(1), value);
          if (newValue === this._deathResponse) {
            return this;
          }
          const copy = new Behavior(this);
          copy._deathResponse = copy._deathResponse.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "behaviorTagArray": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorTagArray = [];        for (let i of value) {
                copy._behaviorTagArray.push(Behavior_TagItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Behavior(this);
              copy._behaviorTagArray = copy._behaviorTagArray.concat([Behavior_TagItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorTagArray.length === 0) {
                return this;
              }
              const copy = new Behavior(this);
              copy._behaviorTagArray = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorTagArray.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._behaviorTagArray = copy._behaviorTagArray.slice();
              copy._behaviorTagArray[path[1]] = Behavior_TagItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Behavior(this);
              copy._behaviorTagArray = copy._behaviorTagArray.slice(0, path[1]).concat(copy._behaviorTagArray.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorTagArray.length) {
            return this;
          }
          const oldValue = this._behaviorTagArray[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Behavior(this);
          copy._behaviorTagArray = copy._behaviorTagArray.slice();
          copy._behaviorTagArray[key] = newValue;
          return copy;
        }
      }
      case "persistThroughMorph": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasPersistThroughMorph = true;
              copy._persistThroughMorph = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPersistThroughMorph) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasPersistThroughMorph = false;
              copy._persistThroughMorph = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Behavior(this);
              copy._hasLocked = true;
              copy._disabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocked) {
                return this;
              }
              const copy = new Behavior(this);
              copy._hasLocked = false;
              copy._disabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Behavior} other
   * @returns {Behavior}
   */
  merge(other) {
    const copy = new Behavior(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._parent = other._parent;
    }
    if (other._hasAlignment) {
      copy._hasAlignment = true;
      copy._alignment = other._alignment;
    }
    if (other._hasRefreshStack) {
      copy._hasRefreshStack = true;
      copy._refreshStack = other._refreshStack;
    }
    if (other._hasMaxStackCount) {
      copy._hasMaxStackCount = true;
      copy._maxStackCount = other._maxStackCount;
    }
    if (other._hasUpdateDurationWhileDisabled) {
      copy._hasUpdateDurationWhileDisabled = true;
      copy._updateDurationWhileDisabled = other._updateDurationWhileDisabled;
    }
    if (other._hasDurationRandomAddition) {
      copy._hasDurationRandomAddition = true;
      copy._durationRandomAddition = other._durationRandomAddition;
    }
    if (other._hasUnitModifier) {
      if (copy._hasUnitModifier) {
        copy._unitModifier = copy.unitModifier.merge(other.unitModifier);
      } else {
        copy._unitModifier = other._unitModifier;
      }
      copy._hasUnitModifier = true;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasStacksRemovedOnExpire) {
      copy._hasStacksRemovedOnExpire = true;
      copy._stacksRemovedOnExpire = other._stacksRemovedOnExpire;
    }
    if (other._hasStartEffect) {
      copy._hasStartEffect = true;
      copy._startEffect = other._startEffect;
    }
    if (other._hasFinalEffect) {
      copy._hasFinalEffect = true;
      copy._finalEffect = other._finalEffect;
    }
    if (other._hasRefreshEffect) {
      copy._hasRefreshEffect = true;
      copy._refreshEffect = other._refreshEffect;
    }
    if (other._hasExpireEffect) {
      copy._hasExpireEffect = true;
      copy._expireEffect = other._expireEffect;
    }
    if (other._hasPeriodicInterval) {
      copy._hasPeriodicInterval = true;
      copy._periodicInterval = other._periodicInterval;
    }
    copy._periodicIntervalExpressions = this._periodicIntervalExpressions.concat(other._periodicIntervalExpressions);
    if (other._hasPeriodicEffect) {
      copy._hasPeriodicEffect = true;
      copy._periodicEffect = other._periodicEffect;
    }
    if (other._hasPeriodicEffectCount) {
      copy._hasPeriodicEffectCount = true;
      copy._periodicEffectCount = other._periodicEffectCount;
    }
    copy._behaviorTagList = this._behaviorTagList.concat(other._behaviorTagList);
    copy._behaviorValidatorsApply = this._behaviorValidatorsApply.concat(other._behaviorValidatorsApply);
    copy._behaviorValidatorsRemove = this._behaviorValidatorsRemove.concat(other._behaviorValidatorsRemove);
    copy._behaviorValidatorsDisable = this._behaviorValidatorsDisable.concat(other._behaviorValidatorsDisable);
    if (other._hasModifiers) {
      if (copy._hasModifiers) {
        copy._modifiers = copy.modifiers.merge(other.modifiers);
      } else {
        copy._modifiers = other._modifiers;
      }
      copy._hasModifiers = true;
    }
    if (other._hasDamageResponse) {
      if (copy._hasDamageResponse) {
        copy._damageResponse = copy.damageResponse.merge(other.damageResponse);
      } else {
        copy._damageResponse = other._damageResponse;
      }
      copy._hasDamageResponse = true;
    }
    if (other._hasDeathResponse) {
      if (copy._hasDeathResponse) {
        copy._deathResponse = copy.deathResponse.merge(other.deathResponse);
      } else {
        copy._deathResponse = other._deathResponse;
      }
      copy._hasDeathResponse = true;
    }
    copy._behaviorTagArray = this._behaviorTagArray.concat(other._behaviorTagArray);
    if (other._hasPersistThroughMorph) {
      copy._hasPersistThroughMorph = true;
      copy._persistThroughMorph = other._persistThroughMorph;
    }
    if (other._hasLocked) {
      copy._hasLocked = true;
      copy._disabled = other._disabled;
    }
    return copy;
  }
}
Behavior.default = new Behavior();
Behavior.TagItem = Behavior_TagItem;
Behavior.UnitModifier = Behavior_UnitModifier;
Behavior.Alignment = Behavior_Alignment;
class Behavior_Builder {
  constructor(value) {
    this._value = new Behavior(value);
  }
  build() {
    return new Behavior(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._parent = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._parent = null;
    return this;
  }
  setAlignment(value) {
    this._value._hasAlignment = true;
    this._value._alignment = value;
    return this;
  }
  deleteAlignment() {
    this._value._hasAlignment = false;
    this._value._alignment = null;
    return this;
  }
  setRefreshStack(value) {
    this._value._hasRefreshStack = true;
    this._value._refreshStack = value;
    return this;
  }
  deleteRefreshStack() {
    this._value._hasRefreshStack = false;
    this._value._refreshStack = null;
    return this;
  }
  setMaxStackCount(value) {
    this._value._hasMaxStackCount = true;
    this._value._maxStackCount = value;
    return this;
  }
  deleteMaxStackCount() {
    this._value._hasMaxStackCount = false;
    this._value._maxStackCount = null;
    return this;
  }
  setUpdateDurationWhileDisabled(value) {
    this._value._hasUpdateDurationWhileDisabled = true;
    this._value._updateDurationWhileDisabled = value;
    return this;
  }
  deleteUpdateDurationWhileDisabled() {
    this._value._hasUpdateDurationWhileDisabled = false;
    this._value._updateDurationWhileDisabled = null;
    return this;
  }
  setDurationRandomAddition(value) {
    this._value._hasDurationRandomAddition = true;
    this._value._durationRandomAddition = value;
    return this;
  }
  deleteDurationRandomAddition() {
    this._value._hasDurationRandomAddition = false;
    this._value._durationRandomAddition = null;
    return this;
  }
  setUnitModifier(value) {
    this._value._hasUnitModifier = true;
    this._value._unitModifier = value;
    return this;
  }
  deleteUnitModifier() {
    this._value._hasUnitModifier = false;
    this._value._unitModifier = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setStacksRemovedOnExpire(value) {
    this._value._hasStacksRemovedOnExpire = true;
    this._value._stacksRemovedOnExpire = value;
    return this;
  }
  deleteStacksRemovedOnExpire() {
    this._value._hasStacksRemovedOnExpire = false;
    this._value._stacksRemovedOnExpire = null;
    return this;
  }
  setStartEffect(value) {
    this._value._hasStartEffect = true;
    this._value._startEffect = value;
    return this;
  }
  deleteStartEffect() {
    this._value._hasStartEffect = false;
    this._value._startEffect = null;
    return this;
  }
  setFinalEffect(value) {
    this._value._hasFinalEffect = true;
    this._value._finalEffect = value;
    return this;
  }
  deleteFinalEffect() {
    this._value._hasFinalEffect = false;
    this._value._finalEffect = null;
    return this;
  }
  setRefreshEffect(value) {
    this._value._hasRefreshEffect = true;
    this._value._refreshEffect = value;
    return this;
  }
  deleteRefreshEffect() {
    this._value._hasRefreshEffect = false;
    this._value._refreshEffect = null;
    return this;
  }
  setExpireEffect(value) {
    this._value._hasExpireEffect = true;
    this._value._expireEffect = value;
    return this;
  }
  deleteExpireEffect() {
    this._value._hasExpireEffect = false;
    this._value._expireEffect = null;
    return this;
  }
  setPeriodicInterval(value) {
    this._value._hasPeriodicInterval = true;
    this._value._periodicInterval = value;
    return this;
  }
  deletePeriodicInterval() {
    this._value._hasPeriodicInterval = false;
    this._value._periodicInterval = null;
    return this;
  }
  addAllPeriodicIntervalExpressions(values) {
    this._value._periodicIntervalExpressions = this._value._periodicIntervalExpressions.concat(values);
    return this;
  }
  addPeriodicIntervalExpressions(value) {
    this._value._periodicIntervalExpressions = this._value._periodicIntervalExpressions.concat([value]);
    return this;
  }
  setPeriodicIntervalExpressions(index, value) {
    this._value._periodicIntervalExpressions = this._value._periodicIntervalExpressions.concat();
    this._value._periodicIntervalExpressions[index] = value;
    return this;
  }
  clearPeriodicIntervalExpressions() {
    this._value._periodicIntervalExpressions = [];
    return this;
  }
  setPeriodicEffect(value) {
    this._value._hasPeriodicEffect = true;
    this._value._periodicEffect = value;
    return this;
  }
  deletePeriodicEffect() {
    this._value._hasPeriodicEffect = false;
    this._value._periodicEffect = null;
    return this;
  }
  setPeriodicEffectCount(value) {
    this._value._hasPeriodicEffectCount = true;
    this._value._periodicEffectCount = value;
    return this;
  }
  deletePeriodicEffectCount() {
    this._value._hasPeriodicEffectCount = false;
    this._value._periodicEffectCount = null;
    return this;
  }
  addAllBehaviorTagList(values) {
    this._value._behaviorTagList = this._value._behaviorTagList.concat(values);
    return this;
  }
  addBehaviorTagList(value) {
    this._value._behaviorTagList = this._value._behaviorTagList.concat([value]);
    return this;
  }
  setBehaviorTagList(index, value) {
    this._value._behaviorTagList = this._value._behaviorTagList.concat();
    this._value._behaviorTagList[index] = value;
    return this;
  }
  clearBehaviorTagList() {
    this._value._behaviorTagList = [];
    return this;
  }
  addAllBehaviorValidatorsApply(values) {
    this._value._behaviorValidatorsApply = this._value._behaviorValidatorsApply.concat(values);
    return this;
  }
  addBehaviorValidatorsApply(value) {
    this._value._behaviorValidatorsApply = this._value._behaviorValidatorsApply.concat([value]);
    return this;
  }
  setBehaviorValidatorsApply(index, value) {
    this._value._behaviorValidatorsApply = this._value._behaviorValidatorsApply.concat();
    this._value._behaviorValidatorsApply[index] = value;
    return this;
  }
  clearBehaviorValidatorsApply() {
    this._value._behaviorValidatorsApply = [];
    return this;
  }
  addAllBehaviorValidatorsRemove(values) {
    this._value._behaviorValidatorsRemove = this._value._behaviorValidatorsRemove.concat(values);
    return this;
  }
  addBehaviorValidatorsRemove(value) {
    this._value._behaviorValidatorsRemove = this._value._behaviorValidatorsRemove.concat([value]);
    return this;
  }
  setBehaviorValidatorsRemove(index, value) {
    this._value._behaviorValidatorsRemove = this._value._behaviorValidatorsRemove.concat();
    this._value._behaviorValidatorsRemove[index] = value;
    return this;
  }
  clearBehaviorValidatorsRemove() {
    this._value._behaviorValidatorsRemove = [];
    return this;
  }
  addAllBehaviorValidatorsDisable(values) {
    this._value._behaviorValidatorsDisable = this._value._behaviorValidatorsDisable.concat(values);
    return this;
  }
  addBehaviorValidatorsDisable(value) {
    this._value._behaviorValidatorsDisable = this._value._behaviorValidatorsDisable.concat([value]);
    return this;
  }
  setBehaviorValidatorsDisable(index, value) {
    this._value._behaviorValidatorsDisable = this._value._behaviorValidatorsDisable.concat();
    this._value._behaviorValidatorsDisable[index] = value;
    return this;
  }
  clearBehaviorValidatorsDisable() {
    this._value._behaviorValidatorsDisable = [];
    return this;
  }
  setModifiers(value) {
    this._value._hasModifiers = true;
    this._value._modifiers = value;
    return this;
  }
  deleteModifiers() {
    this._value._hasModifiers = false;
    this._value._modifiers = null;
    return this;
  }
  setDamageResponse(value) {
    this._value._hasDamageResponse = true;
    this._value._damageResponse = value;
    return this;
  }
  deleteDamageResponse() {
    this._value._hasDamageResponse = false;
    this._value._damageResponse = null;
    return this;
  }
  setDeathResponse(value) {
    this._value._hasDeathResponse = true;
    this._value._deathResponse = value;
    return this;
  }
  deleteDeathResponse() {
    this._value._hasDeathResponse = false;
    this._value._deathResponse = null;
    return this;
  }
  addAllBehaviorTagArray(values) {
    this._value._behaviorTagArray = this._value._behaviorTagArray.concat(values);
    return this;
  }
  addBehaviorTagArray(value) {
    this._value._behaviorTagArray = this._value._behaviorTagArray.concat([value]);
    return this;
  }
  setBehaviorTagArray(index, value) {
    this._value._behaviorTagArray = this._value._behaviorTagArray.concat();
    this._value._behaviorTagArray[index] = value;
    return this;
  }
  clearBehaviorTagArray() {
    this._value._behaviorTagArray = [];
    return this;
  }
  setPersistThroughMorph(value) {
    this._value._hasPersistThroughMorph = true;
    this._value._persistThroughMorph = value;
    return this;
  }
  deletePersistThroughMorph() {
    this._value._hasPersistThroughMorph = false;
    this._value._persistThroughMorph = null;
    return this;
  }
  setLocked(value) {
    this._value._hasLocked = true;
    this._value._disabled = value;
    return this;
  }
  deleteLocked() {
    this._value._hasLocked = false;
    this._value._disabled = null;
    return this;
  }
}
Behavior.Builder = Behavior_Builder;
class Behavior_WithParent {
  /**
   * @param {Behavior} value
   * @param {Behavior_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Behavior.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get parent() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.parent;
      } else {
        this._cachedParent = this._parent ? this._parent.parent : this._value.parent;
      }
    }
    return this._cachedParent;
  }
  get hasAlignment() {
    if (this._cachedHasAlignment === undefined) {
      if (this._value.hasAlignment) {
        this._cachedHasAlignment = true;
      } else {
        this._cachedHasAlignment = this._parent ? this._parent.hasAlignment : false;
      }
    }
    return this._cachedHasAlignment;
  }
  get alignment() {
    if (this._cachedAlignment === undefined) {
      if (this._value.hasAlignment) {
        this._cachedAlignment = this._value.alignment;
      } else {
        this._cachedAlignment = this._parent ? this._parent.alignment : this._value.alignment;
      }
    }
    return this._cachedAlignment;
  }
  get hasRefreshStack() {
    if (this._cachedHasRefreshStack === undefined) {
      if (this._value.hasRefreshStack) {
        this._cachedHasRefreshStack = true;
      } else {
        this._cachedHasRefreshStack = this._parent ? this._parent.hasRefreshStack : false;
      }
    }
    return this._cachedHasRefreshStack;
  }
  get refreshStack() {
    if (this._cachedRefreshStack === undefined) {
      if (this._value.hasRefreshStack) {
        this._cachedRefreshStack = this._value.refreshStack;
      } else {
        this._cachedRefreshStack = this._parent ? this._parent.refreshStack : this._value.refreshStack;
      }
    }
    return this._cachedRefreshStack;
  }
  get hasMaxStackCount() {
    if (this._cachedHasMaxStackCount === undefined) {
      if (this._value.hasMaxStackCount) {
        this._cachedHasMaxStackCount = true;
      } else {
        this._cachedHasMaxStackCount = this._parent ? this._parent.hasMaxStackCount : false;
      }
    }
    return this._cachedHasMaxStackCount;
  }
  get maxStackCount() {
    if (this._cachedMaxStackCount === undefined) {
      if (this._value.hasMaxStackCount) {
        this._cachedMaxStackCount = this._value.maxStackCount;
      } else {
        this._cachedMaxStackCount = this._parent ? this._parent.maxStackCount : this._value.maxStackCount;
      }
    }
    return this._cachedMaxStackCount;
  }
  get hasUpdateDurationWhileDisabled() {
    if (this._cachedHasUpdateDurationWhileDisabled === undefined) {
      if (this._value.hasUpdateDurationWhileDisabled) {
        this._cachedHasUpdateDurationWhileDisabled = true;
      } else {
        this._cachedHasUpdateDurationWhileDisabled = this._parent ? this._parent.hasUpdateDurationWhileDisabled : false;
      }
    }
    return this._cachedHasUpdateDurationWhileDisabled;
  }
  get updateDurationWhileDisabled() {
    if (this._cachedUpdateDurationWhileDisabled === undefined) {
      if (this._value.hasUpdateDurationWhileDisabled) {
        this._cachedUpdateDurationWhileDisabled = this._value.updateDurationWhileDisabled;
      } else {
        this._cachedUpdateDurationWhileDisabled = this._parent ? this._parent.updateDurationWhileDisabled : this._value.updateDurationWhileDisabled;
      }
    }
    return this._cachedUpdateDurationWhileDisabled;
  }
  get hasDurationRandomAddition() {
    if (this._cachedHasDurationRandomAddition === undefined) {
      if (this._value.hasDurationRandomAddition) {
        this._cachedHasDurationRandomAddition = true;
      } else {
        this._cachedHasDurationRandomAddition = this._parent ? this._parent.hasDurationRandomAddition : false;
      }
    }
    return this._cachedHasDurationRandomAddition;
  }
  get durationRandomAddition() {
    if (this._cachedDurationRandomAddition === undefined) {
      if (this._value.hasDurationRandomAddition) {
        this._cachedDurationRandomAddition = this._value.durationRandomAddition;
      } else {
        this._cachedDurationRandomAddition = this._parent ? this._parent.durationRandomAddition : this._value.durationRandomAddition;
      }
    }
    return this._cachedDurationRandomAddition;
  }
  get hasUnitModifier() {
    if (this._cachedHasUnitModifier === undefined) {
      if (this._value.hasUnitModifier) {
        this._cachedHasUnitModifier = true;
      } else {
        this._cachedHasUnitModifier = this._parent ? this._parent.hasUnitModifier : false;
      }
    }
    return this._cachedHasUnitModifier;
  }
  get unitModifier() {
    if (!this._cachedUnitModifier) {
      if (this._value.hasUnitModifier) {
        this._cachedUnitModifier = new Behavior_UnitModifier.WithParent(this._value.unitModifier, this._parent && this._parent.hasUnitModifier ? this._parent.unitModifier : null);
      } else {
        this._cachedUnitModifier = this._parent ? new Behavior_UnitModifier.WithParent(Behavior_UnitModifier.default, this._parent.unitModifier) : Behavior_UnitModifier.WithParent.default;
      }
    }
    return this._cachedUnitModifier;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasStacksRemovedOnExpire() {
    if (this._cachedHasStacksRemovedOnExpire === undefined) {
      if (this._value.hasStacksRemovedOnExpire) {
        this._cachedHasStacksRemovedOnExpire = true;
      } else {
        this._cachedHasStacksRemovedOnExpire = this._parent ? this._parent.hasStacksRemovedOnExpire : false;
      }
    }
    return this._cachedHasStacksRemovedOnExpire;
  }
  get stacksRemovedOnExpire() {
    if (this._cachedStacksRemovedOnExpire === undefined) {
      if (this._value.hasStacksRemovedOnExpire) {
        this._cachedStacksRemovedOnExpire = this._value.stacksRemovedOnExpire;
      } else {
        this._cachedStacksRemovedOnExpire = this._parent ? this._parent.stacksRemovedOnExpire : this._value.stacksRemovedOnExpire;
      }
    }
    return this._cachedStacksRemovedOnExpire;
  }
  get hasStartEffect() {
    if (this._cachedHasStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedHasStartEffect = true;
      } else {
        this._cachedHasStartEffect = this._parent ? this._parent.hasStartEffect : false;
      }
    }
    return this._cachedHasStartEffect;
  }
  get startEffect() {
    if (this._cachedStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedStartEffect = this._value.startEffect;
      } else {
        this._cachedStartEffect = this._parent ? this._parent.startEffect : this._value.startEffect;
      }
    }
    return this._cachedStartEffect;
  }
  get hasFinalEffect() {
    if (this._cachedHasFinalEffect === undefined) {
      if (this._value.hasFinalEffect) {
        this._cachedHasFinalEffect = true;
      } else {
        this._cachedHasFinalEffect = this._parent ? this._parent.hasFinalEffect : false;
      }
    }
    return this._cachedHasFinalEffect;
  }
  get finalEffect() {
    if (this._cachedFinalEffect === undefined) {
      if (this._value.hasFinalEffect) {
        this._cachedFinalEffect = this._value.finalEffect;
      } else {
        this._cachedFinalEffect = this._parent ? this._parent.finalEffect : this._value.finalEffect;
      }
    }
    return this._cachedFinalEffect;
  }
  get hasRefreshEffect() {
    if (this._cachedHasRefreshEffect === undefined) {
      if (this._value.hasRefreshEffect) {
        this._cachedHasRefreshEffect = true;
      } else {
        this._cachedHasRefreshEffect = this._parent ? this._parent.hasRefreshEffect : false;
      }
    }
    return this._cachedHasRefreshEffect;
  }
  get refreshEffect() {
    if (this._cachedRefreshEffect === undefined) {
      if (this._value.hasRefreshEffect) {
        this._cachedRefreshEffect = this._value.refreshEffect;
      } else {
        this._cachedRefreshEffect = this._parent ? this._parent.refreshEffect : this._value.refreshEffect;
      }
    }
    return this._cachedRefreshEffect;
  }
  get hasExpireEffect() {
    if (this._cachedHasExpireEffect === undefined) {
      if (this._value.hasExpireEffect) {
        this._cachedHasExpireEffect = true;
      } else {
        this._cachedHasExpireEffect = this._parent ? this._parent.hasExpireEffect : false;
      }
    }
    return this._cachedHasExpireEffect;
  }
  get expireEffect() {
    if (this._cachedExpireEffect === undefined) {
      if (this._value.hasExpireEffect) {
        this._cachedExpireEffect = this._value.expireEffect;
      } else {
        this._cachedExpireEffect = this._parent ? this._parent.expireEffect : this._value.expireEffect;
      }
    }
    return this._cachedExpireEffect;
  }
  get hasPeriodicInterval() {
    if (this._cachedHasPeriodicInterval === undefined) {
      if (this._value.hasPeriodicInterval) {
        this._cachedHasPeriodicInterval = true;
      } else {
        this._cachedHasPeriodicInterval = this._parent ? this._parent.hasPeriodicInterval : false;
      }
    }
    return this._cachedHasPeriodicInterval;
  }
  get periodicInterval() {
    if (this._cachedPeriodicInterval === undefined) {
      if (this._value.hasPeriodicInterval) {
        this._cachedPeriodicInterval = this._value.periodicInterval;
      } else {
        this._cachedPeriodicInterval = this._parent ? this._parent.periodicInterval : this._value.periodicInterval;
      }
    }
    return this._cachedPeriodicInterval;
  }
  get selfPeriodicIntervalExpressions() {
    if (!this._selfPeriodicIntervalExpressions) {
      this._selfPeriodicIntervalExpressions = [];
      for (let i of this._value.periodicIntervalExpressions) {
        this._selfPeriodicIntervalExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfPeriodicIntervalExpressions;
  }
  get inherentPeriodicIntervalExpressions() {
    if (!this._inherentPeriodicIntervalExpressions) {
      this._inherentPeriodicIntervalExpressions = this._parent ? this._parent.periodicIntervalExpressions : [];
    }
    return this._inherentPeriodicIntervalExpressions;
  }
  get periodicIntervalExpressions() {
    if (!this._allPeriodicIntervalExpressions) {
      this._allPeriodicIntervalExpressions = this._parent ? this._parent.periodicIntervalExpressions.concat(this.selfPeriodicIntervalExpressions) : this.selfPeriodicIntervalExpressions;
    }
    return this._allPeriodicIntervalExpressions;
  }
  get hasPeriodicEffect() {
    if (this._cachedHasPeriodicEffect === undefined) {
      if (this._value.hasPeriodicEffect) {
        this._cachedHasPeriodicEffect = true;
      } else {
        this._cachedHasPeriodicEffect = this._parent ? this._parent.hasPeriodicEffect : false;
      }
    }
    return this._cachedHasPeriodicEffect;
  }
  get periodicEffect() {
    if (this._cachedPeriodicEffect === undefined) {
      if (this._value.hasPeriodicEffect) {
        this._cachedPeriodicEffect = this._value.periodicEffect;
      } else {
        this._cachedPeriodicEffect = this._parent ? this._parent.periodicEffect : this._value.periodicEffect;
      }
    }
    return this._cachedPeriodicEffect;
  }
  get hasPeriodicEffectCount() {
    if (this._cachedHasPeriodicEffectCount === undefined) {
      if (this._value.hasPeriodicEffectCount) {
        this._cachedHasPeriodicEffectCount = true;
      } else {
        this._cachedHasPeriodicEffectCount = this._parent ? this._parent.hasPeriodicEffectCount : false;
      }
    }
    return this._cachedHasPeriodicEffectCount;
  }
  get periodicEffectCount() {
    if (this._cachedPeriodicEffectCount === undefined) {
      if (this._value.hasPeriodicEffectCount) {
        this._cachedPeriodicEffectCount = this._value.periodicEffectCount;
      } else {
        this._cachedPeriodicEffectCount = this._parent ? this._parent.periodicEffectCount : this._value.periodicEffectCount;
      }
    }
    return this._cachedPeriodicEffectCount;
  }
  get selfBehaviorTagList() {
    return this._value.behaviorTagList;
  }
  get inherentBehaviorTagList() {
    if (!this._inherentBehaviorTagList) {
      this._inherentBehaviorTagList = this._parent ? this._parent.behaviorTagList : [];
    }
    return this._inherentBehaviorTagList;
  }
  get behaviorTagList() {
    if (!this._allBehaviorTagList) {
      this._allBehaviorTagList = this._parent ? this._parent.behaviorTagList.concat(this.selfBehaviorTagList) : this.selfBehaviorTagList;
    }
    return this._allBehaviorTagList;
  }
  get selfBehaviorValidatorsApply() {
    return this._value.behaviorValidatorsApply;
  }
  get inherentBehaviorValidatorsApply() {
    if (!this._inherentBehaviorValidatorsApply) {
      this._inherentBehaviorValidatorsApply = this._parent ? this._parent.behaviorValidatorsApply : [];
    }
    return this._inherentBehaviorValidatorsApply;
  }
  get behaviorValidatorsApply() {
    if (!this._allBehaviorValidatorsApply) {
      this._allBehaviorValidatorsApply = this._parent ? this._parent.behaviorValidatorsApply.concat(this.selfBehaviorValidatorsApply) : this.selfBehaviorValidatorsApply;
    }
    return this._allBehaviorValidatorsApply;
  }
  get selfBehaviorValidatorsRemove() {
    return this._value.behaviorValidatorsRemove;
  }
  get inherentBehaviorValidatorsRemove() {
    if (!this._inherentBehaviorValidatorsRemove) {
      this._inherentBehaviorValidatorsRemove = this._parent ? this._parent.behaviorValidatorsRemove : [];
    }
    return this._inherentBehaviorValidatorsRemove;
  }
  get behaviorValidatorsRemove() {
    if (!this._allBehaviorValidatorsRemove) {
      this._allBehaviorValidatorsRemove = this._parent ? this._parent.behaviorValidatorsRemove.concat(this.selfBehaviorValidatorsRemove) : this.selfBehaviorValidatorsRemove;
    }
    return this._allBehaviorValidatorsRemove;
  }
  get selfBehaviorValidatorsDisable() {
    return this._value.behaviorValidatorsDisable;
  }
  get inherentBehaviorValidatorsDisable() {
    if (!this._inherentBehaviorValidatorsDisable) {
      this._inherentBehaviorValidatorsDisable = this._parent ? this._parent.behaviorValidatorsDisable : [];
    }
    return this._inherentBehaviorValidatorsDisable;
  }
  get behaviorValidatorsDisable() {
    if (!this._allBehaviorValidatorsDisable) {
      this._allBehaviorValidatorsDisable = this._parent ? this._parent.behaviorValidatorsDisable.concat(this.selfBehaviorValidatorsDisable) : this.selfBehaviorValidatorsDisable;
    }
    return this._allBehaviorValidatorsDisable;
  }
  get hasModifiers() {
    if (this._cachedHasModifiers === undefined) {
      if (this._value.hasModifiers) {
        this._cachedHasModifiers = true;
      } else {
        this._cachedHasModifiers = this._parent ? this._parent.hasModifiers : false;
      }
    }
    return this._cachedHasModifiers;
  }
  get modifiers() {
    if (!this._cachedModifiers) {
      if (this._value.hasModifiers) {
        this._cachedModifiers = new BehaviorModifiers.WithParent(this._value.modifiers, this._parent && this._parent.hasModifiers ? this._parent.modifiers : null);
      } else {
        this._cachedModifiers = this._parent ? new BehaviorModifiers.WithParent(BehaviorModifiers.default, this._parent.modifiers) : BehaviorModifiers.WithParent.default;
      }
    }
    return this._cachedModifiers;
  }
  get hasDamageResponse() {
    if (this._cachedHasDamageResponse === undefined) {
      if (this._value.hasDamageResponse) {
        this._cachedHasDamageResponse = true;
      } else {
        this._cachedHasDamageResponse = this._parent ? this._parent.hasDamageResponse : false;
      }
    }
    return this._cachedHasDamageResponse;
  }
  get damageResponse() {
    if (!this._cachedDamageResponse) {
      if (this._value.hasDamageResponse) {
        this._cachedDamageResponse = new DamageResponse.WithParent(this._value.damageResponse, this._parent && this._parent.hasDamageResponse ? this._parent.damageResponse : null);
      } else {
        this._cachedDamageResponse = this._parent ? new DamageResponse.WithParent(DamageResponse.default, this._parent.damageResponse) : DamageResponse.WithParent.default;
      }
    }
    return this._cachedDamageResponse;
  }
  get hasDeathResponse() {
    if (this._cachedHasDeathResponse === undefined) {
      if (this._value.hasDeathResponse) {
        this._cachedHasDeathResponse = true;
      } else {
        this._cachedHasDeathResponse = this._parent ? this._parent.hasDeathResponse : false;
      }
    }
    return this._cachedHasDeathResponse;
  }
  get deathResponse() {
    if (!this._cachedDeathResponse) {
      if (this._value.hasDeathResponse) {
        this._cachedDeathResponse = new DeathResponse.WithParent(this._value.deathResponse, this._parent && this._parent.hasDeathResponse ? this._parent.deathResponse : null);
      } else {
        this._cachedDeathResponse = this._parent ? new DeathResponse.WithParent(DeathResponse.default, this._parent.deathResponse) : DeathResponse.WithParent.default;
      }
    }
    return this._cachedDeathResponse;
  }
  get selfBehaviorTagArray() {
    if (!this._selfBehaviorTagArray) {
      this._selfBehaviorTagArray = [];
      for (let i of this._value.behaviorTagArray) {
        this._selfBehaviorTagArray.push(new Behavior_TagItem.WithParent(i, null));
      }
    }
    return this._selfBehaviorTagArray;
  }
  get inherentBehaviorTagArray() {
    if (!this._inherentBehaviorTagArray) {
      this._inherentBehaviorTagArray = this._parent ? this._parent.behaviorTagArray : [];
    }
    return this._inherentBehaviorTagArray;
  }
  get behaviorTagArray() {
    if (!this._allBehaviorTagArray) {
      this._allBehaviorTagArray = this._parent ? this._parent.behaviorTagArray.concat(this.selfBehaviorTagArray) : this.selfBehaviorTagArray;
    }
    return this._allBehaviorTagArray;
  }
  get hasPersistThroughMorph() {
    if (this._cachedHasPersistThroughMorph === undefined) {
      if (this._value.hasPersistThroughMorph) {
        this._cachedHasPersistThroughMorph = true;
      } else {
        this._cachedHasPersistThroughMorph = this._parent ? this._parent.hasPersistThroughMorph : false;
      }
    }
    return this._cachedHasPersistThroughMorph;
  }
  get persistThroughMorph() {
    if (this._cachedPersistThroughMorph === undefined) {
      if (this._value.hasPersistThroughMorph) {
        this._cachedPersistThroughMorph = this._value.persistThroughMorph;
      } else {
        this._cachedPersistThroughMorph = this._parent ? this._parent.persistThroughMorph : this._value.persistThroughMorph;
      }
    }
    return this._cachedPersistThroughMorph;
  }
  get hasLocked() {
    if (this._cachedHasLocked === undefined) {
      if (this._value.hasLocked) {
        this._cachedHasLocked = true;
      } else {
        this._cachedHasLocked = this._parent ? this._parent.hasLocked : false;
      }
    }
    return this._cachedHasLocked;
  }
  get disabled() {
    if (this._cachedLocked === undefined) {
      if (this._value.hasLocked) {
        this._cachedLocked = this._value.disabled;
      } else {
        this._cachedLocked = this._parent ? this._parent.disabled : this._value.disabled;
      }
    }
    return this._cachedLocked;
  }
  update(current, parent) {
    const result = new Behavior_WithParent(current, parent);
    if (this._cachedUnitModifier && this._value.hasUnitModifier && current.hasUnitModifier) {
      if (this._value.unitModifier === current.unitModifier && this._parent === parent) {
        result._cachedUnitModifier = this._cachedUnitModifier;
      } else {
        result._cachedUnitModifier = this._cachedUnitModifier.update(current.unitModifier, parent && parent.hasUnitModifier ? parent.unitModifier : null);
      }
    }
    if (this._selfPeriodicIntervalExpressions) {
      if (this._value.periodicIntervalExpressions === current.periodicIntervalExpressions) {
        result._selfPeriodicIntervalExpressions = this._selfPeriodicIntervalExpressions;
      } else {
        result._selfPeriodicIntervalExpressions = [];
        for (let i = 0; i < current.periodicIntervalExpressions.length; i++) {
          const oldValue = this._value.periodicIntervalExpressions[i];
          if (oldValue) {
            const oldCache = this._selfPeriodicIntervalExpressions[i];
            if (oldValue === current.periodicIntervalExpressions[i]) {
              result._selfPeriodicIntervalExpressions[i] = oldCache;
            } else {
              result._selfPeriodicIntervalExpressions[i] = oldCache.update(current.periodicIntervalExpressions[i], null);
            }
          } else {
            result._selfPeriodicIntervalExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.periodicIntervalExpressions[i], null);
          }
        }
      }
    }
    if (this._cachedModifiers && this._value.hasModifiers && current.hasModifiers) {
      if (this._value.modifiers === current.modifiers && this._parent === parent) {
        result._cachedModifiers = this._cachedModifiers;
      } else {
        result._cachedModifiers = this._cachedModifiers.update(current.modifiers, parent && parent.hasModifiers ? parent.modifiers : null);
      }
    }
    if (this._cachedDamageResponse && this._value.hasDamageResponse && current.hasDamageResponse) {
      if (this._value.damageResponse === current.damageResponse && this._parent === parent) {
        result._cachedDamageResponse = this._cachedDamageResponse;
      } else {
        result._cachedDamageResponse = this._cachedDamageResponse.update(current.damageResponse, parent && parent.hasDamageResponse ? parent.damageResponse : null);
      }
    }
    if (this._cachedDeathResponse && this._value.hasDeathResponse && current.hasDeathResponse) {
      if (this._value.deathResponse === current.deathResponse && this._parent === parent) {
        result._cachedDeathResponse = this._cachedDeathResponse;
      } else {
        result._cachedDeathResponse = this._cachedDeathResponse.update(current.deathResponse, parent && parent.hasDeathResponse ? parent.deathResponse : null);
      }
    }
    if (this._selfBehaviorTagArray) {
      if (this._value.behaviorTagArray === current.behaviorTagArray) {
        result._selfBehaviorTagArray = this._selfBehaviorTagArray;
      } else {
        result._selfBehaviorTagArray = [];
        for (let i = 0; i < current.behaviorTagArray.length; i++) {
          const oldValue = this._value.behaviorTagArray[i];
          if (oldValue) {
            const oldCache = this._selfBehaviorTagArray[i];
            if (oldValue === current.behaviorTagArray[i]) {
              result._selfBehaviorTagArray[i] = oldCache;
            } else {
              result._selfBehaviorTagArray[i] = oldCache.update(current.behaviorTagArray[i], null);
            }
          } else {
            result._selfBehaviorTagArray[i] = new Behavior_TagItem.WithParent(current.behaviorTagArray[i], null);
          }
        }
      }
    }
    return result;
  }
}
Behavior_WithParent.default = new Behavior_WithParent(Behavior.default, null);
Behavior.WithParent = Behavior_WithParent;
class Behavior_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get parent() {
    if (!this._parent) {
      this._parent = {
        name: "parent",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedBehaviorNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parent;
  }
  get alignment() {
    if (!this._alignment) {
      this._alignment = {
        name: "alignment",
        Name: "Alignment",
        number: 2,
        protoType: 14,
        protoName: "alignment",
        type: Behavior_Alignment,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._alignment;
  }
  get refreshStack() {
    if (!this._refreshStack) {
      this._refreshStack = {
        name: "refreshStack",
        Name: "RefreshStack",
        number: 3,
        protoType: 8,
        protoName: "refresh_stack",
        type: JsonToBoolean,
        options: {
          comments: "If this is checked, the behavior\'s Duration will reset when subsequent stacks of the behavior are applied to the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshStack;
  }
  get maxStackCount() {
    if (!this._maxStackCount) {
      this._maxStackCount = {
        name: "maxStackCount",
        Name: "MaxStackCount",
        number: 4,
        protoType: 5,
        protoName: "max_stack_count",
        type: JsonToInt32,
        options: {
          comments: "The maximum number of stacks a unit can have of this behavior.",
          default: "No limit",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxStackCount;
  }
  get updateDurationWhileDisabled() {
    if (!this._updateDurationWhileDisabled) {
      this._updateDurationWhileDisabled = {
        name: "updateDurationWhileDisabled",
        Name: "UpdateDurationWhileDisabled",
        number: 5,
        protoType: 8,
        protoName: "update_duration_while_disabled",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._updateDurationWhileDisabled;
  }
  get durationRandomAddition() {
    if (!this._durationRandomAddition) {
      this._durationRandomAddition = {
        name: "durationRandomAddition",
        Name: "DurationRandomAddition",
        number: 6,
        protoType: 1,
        protoName: "duration_random_addition",
        type: JsonToDouble,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationRandomAddition;
  }
  get unitModifier() {
    if (!this._unitModifier) {
      this._unitModifier = {
        name: "unitModifier",
        Name: "UnitModifier",
        number: 7,
        protoType: 11,
        protoName: "unit_modifier",
        type: Behavior_UnitModifier,
        options: {
          comments: "Modifications that are applied to the unit when the behavior is applied.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitModifier;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 10,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "This is how long the behavior will last for.",
          default: "Indefinite",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get stacksRemovedOnExpire() {
    if (!this._stacksRemovedOnExpire) {
      this._stacksRemovedOnExpire = {
        name: "stacksRemovedOnExpire",
        Name: "StacksRemovedOnExpire",
        number: 101,
        protoType: 5,
        protoName: "stacks_removed_on_expire",
        type: JsonToInt32,
        options: {
          comments: "How many behavior stacks will be removed when the duration expires, 0 means all stacks will be removed. If duration expires but not all behavior stacks removed, the duration timer will be refreshed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stacksRemovedOnExpire;
  }
  get startEffect() {
    if (!this._startEffect) {
      this._startEffect = {
        name: "startEffect",
        Name: "StartEffect",
        number: 11,
        protoType: 9,
        protoName: "start_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the behavior is started.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startEffect;
  }
  get finalEffect() {
    if (!this._finalEffect) {
      this._finalEffect = {
        name: "finalEffect",
        Name: "FinalEffect",
        number: 12,
        protoType: 9,
        protoName: "final_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the behavior is removed.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finalEffect;
  }
  get refreshEffect() {
    if (!this._refreshEffect) {
      this._refreshEffect = {
        name: "refreshEffect",
        Name: "RefreshEffect",
        number: 13,
        protoType: 9,
        protoName: "refresh_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when subsequent stacks of a behavior are applied to a unit.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshEffect;
  }
  get expireEffect() {
    if (!this._expireEffect) {
      this._expireEffect = {
        name: "expireEffect",
        Name: "ExpireEffect",
        number: 14,
        protoType: 9,
        protoName: "expire_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the behavior\'s duration expires.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expireEffect;
  }
  get periodicInterval() {
    if (!this._periodicInterval) {
      this._periodicInterval = {
        name: "periodicInterval",
        Name: "PeriodicInterval",
        number: 15,
        protoType: 1,
        protoName: "periodic_interval",
        type: JsonToDouble,
        options: {
          comments: "Determines how often the Periodic Effect occurs. Must be greater than 0 to function to create periodic effects.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicInterval;
  }
  get periodicIntervalExpressions() {
    if (!this._periodicIntervalExpressions) {
      this._periodicIntervalExpressions = {
        name: "periodicIntervalExpressions",
        Name: "PeriodicIntervalExpressions",
        number: 23,
        protoType: 11,
        protoName: "periodic_interval_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "The evaluated expressions are added to the Periodic Interval.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicIntervalExpressions;
  }
  get periodicEffect() {
    if (!this._periodicEffect) {
      this._periodicEffect = {
        name: "periodicEffect",
        Name: "PeriodicEffect",
        number: 16,
        protoType: 9,
        protoName: "periodic_effect",
        type: JsonToString,
        options: {
          comments: "The effect created a the end of each Periodic Interval.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffect;
  }
  get periodicEffectCount() {
    if (!this._periodicEffectCount) {
      this._periodicEffectCount = {
        name: "periodicEffectCount",
        Name: "PeriodicEffectCount",
        number: 17,
        protoType: 5,
        protoName: "periodic_effect_count",
        type: JsonToInt32,
        options: {
          comments: "Determines how many times the Periodic Effect is run. A periodic effect with count of -1 will last until the behavior is removed.",
          min: -1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffectCount;
  }
  get behaviorTagList() {
    if (!this._behaviorTagList) {
      this._behaviorTagList = {
        name: "behaviorTagList",
        Name: "BehaviorTagList",
        number: 18,
        protoType: 9,
        protoName: "behavior_tag_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorTagList;
  }
  get behaviorValidatorsApply() {
    if (!this._behaviorValidatorsApply) {
      this._behaviorValidatorsApply = {
        name: "behaviorValidatorsApply",
        Name: "BehaviorValidatorsApply",
        number: 22,
        protoType: 9,
        protoName: "behavior_validators_apply",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The behavior will only be applied if all of validators listed here succeed. Unlike Remove and Disable validators, these are only checked once.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorValidatorsApply;
  }
  get behaviorValidatorsRemove() {
    if (!this._behaviorValidatorsRemove) {
      this._behaviorValidatorsRemove = {
        name: "behaviorValidatorsRemove",
        Name: "BehaviorValidatorsRemove",
        number: 19,
        protoType: 9,
        protoName: "behavior_validators_remove",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The behavior will be removed if any of these validators succeed.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorValidatorsRemove;
  }
  get behaviorValidatorsDisable() {
    if (!this._behaviorValidatorsDisable) {
      this._behaviorValidatorsDisable = {
        name: "behaviorValidatorsDisable",
        Name: "BehaviorValidatorsDisable",
        number: 20,
        protoType: 9,
        protoName: "behavior_validators_disable",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The behavior will be disabled if any of these validators succeed. The behavior will be enabled again the next time that all of these validators fail.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorValidatorsDisable;
  }
  get modifiers() {
    if (!this._modifiers) {
      this._modifiers = {
        name: "modifiers",
        Name: "Modifiers",
        number: 21,
        protoType: 11,
        protoName: "modifiers",
        type: BehaviorModifiers,
        options: {
          comments: "These modifiers can be applied to a number unit attributes (like health or movement speed) and different types of modifiers interact in different ways. Each modifier is applied once per stack of the behavior. Modifiers are only applied while the behavior is active.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifiers;
  }
  get damageResponse() {
    if (!this._damageResponse) {
      this._damageResponse = {
        name: "damageResponse",
        Name: "DamageResponse",
        number: 31,
        protoType: 11,
        protoName: "damage_response",
        type: DamageResponse,
        options: {
          comments: "Allows the unit to create an effect or modify damage amounts in response to taking or dealing damage.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageResponse;
  }
  get deathResponse() {
    if (!this._deathResponse) {
      this._deathResponse = {
        name: "deathResponse",
        Name: "DeathResponse",
        number: 32,
        protoType: 11,
        protoName: "death_response",
        type: DeathResponse,
        options: {
          comments: "Allows the unit to create an effect when it dies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deathResponse;
  }
  get behaviorTagArray() {
    if (!this._behaviorTagArray) {
      this._behaviorTagArray = {
        name: "behaviorTagArray",
        Name: "BehaviorTagArray",
        number: 33,
        protoType: 11,
        protoName: "behavior_tag_array",
        type: Behavior_TagItem,
        isRepeated: true,
        options: {
          comments: "Used to have the behavior apply global tags to the unit. Tags can be referenced in validators and expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorTagArray;
  }
  get persistThroughMorph() {
    if (!this._persistThroughMorph) {
      this._persistThroughMorph = {
        name: "persistThroughMorph",
        Name: "PersistThroughMorph",
        number: 40,
        protoType: 8,
        protoName: "persist_through_morph",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistThroughMorph;
  }
  get disabled() {
    if (!this._disabled) {
      this._disabled = {
        name: "disabled",
        Name: "Locked",
        number: 100,
        protoType: 8,
        protoName: "locked",
        type: JsonToBoolean,
        options: {
          comments: "Disables the behavior. Used by Wild Sky to allow behaviors to be enabled by contextual loading.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabled;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.parent,
        this.alignment,
        this.refreshStack,
        this.maxStackCount,
        this.updateDurationWhileDisabled,
        this.durationRandomAddition,
        this.unitModifier,
        this.duration,
        this.stacksRemovedOnExpire,
        this.startEffect,
        this.finalEffect,
        this.refreshEffect,
        this.expireEffect,
        this.periodicInterval,
        this.periodicIntervalExpressions,
        this.periodicEffect,
        this.periodicEffectCount,
        this.behaviorTagList,
        this.behaviorValidatorsApply,
        this.behaviorValidatorsRemove,
        this.behaviorValidatorsDisable,
        this.modifiers,
        this.damageResponse,
        this.deathResponse,
        this.behaviorTagArray,
        this.persistThroughMorph,
        this.disabled,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlignment",
        Name: "DummyOneofForAlignment",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshStack",
        Name: "DummyOneofForRefreshStack",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxStackCount",
        Name: "DummyOneofForMaxStackCount",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpdateDurationWhileDisabled",
        Name: "DummyOneofForUpdateDurationWhileDisabled",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDurationRandomAddition",
        Name: "DummyOneofForDurationRandomAddition",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitModifier",
        Name: "DummyOneofForUnitModifier",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStacksRemovedOnExpire",
        Name: "DummyOneofForStacksRemovedOnExpire",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartEffect",
        Name: "DummyOneofForStartEffect",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinalEffect",
        Name: "DummyOneofForFinalEffect",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshEffect",
        Name: "DummyOneofForRefreshEffect",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExpireEffect",
        Name: "DummyOneofForExpireEffect",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicInterval",
        Name: "DummyOneofForPeriodicInterval",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicEffect",
        Name: "DummyOneofForPeriodicEffect",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicEffectCount",
        Name: "DummyOneofForPeriodicEffectCount",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModifiers",
        Name: "DummyOneofForModifiers",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageResponse",
        Name: "DummyOneofForDamageResponse",
        fields: [
          this.fields[25],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeathResponse",
        Name: "DummyOneofForDeathResponse",
        fields: [
          this.fields[26],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPersistThroughMorph",
        Name: "DummyOneofForPersistThroughMorph",
        fields: [
          this.fields[28],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocked",
        Name: "DummyOneofForLocked",
        fields: [
          this.fields[29],
        ],
      });
    }
    return this._oneofs;
  }
}
Behavior.descriptor = new Behavior_Descriptor();
